// Page-specific strings, namespaced as 'pages.<pageName>.<key>'.
export default {
  'pages.chat.promptLibrary.purposeRequired': '請輸入此提示詞的用途。',
  'pages.chat.promptLibrary.metadataUnavailable':
    '部分提示詞選項暫時無法使用。儲存前至少需要選擇一個業務領域。',
  'pages.chat.promptLibrary.retryOptions': '重試',
  'pages.chat.promptLibrary.tags': '標籤',
  'pages.chat.promptLibrary.tagsRequired': '請至少新增一個標籤。',
  'pages.chat.promptLibrary.tagsPlaceholder': '選擇或建立標籤',
  'pages.chat.promptLibrary.practiceAreas': '業務領域',
  'pages.chat.promptLibrary.practiceAreasRequired': '請至少選擇一個業務領域。',
  'pages.chat.promptLibrary.practiceAreasPlaceholder': '選擇業務領域',
  'pages.chat.promptLibrary.exampleTemplate':
    '任務：[描述此提示詞應執行的任務。]\n\n輸入：[指定需要提供的文件或資訊。]\n\n要求：[描述結構、語氣、限制和詳細程度。]\n\n請將以下內容用作所需輸出的範例。請根據新的輸入進行調整，而非重複範例中的事實：\n\n',
  'pages.chat.promptLibrary.discardTitle': '捨棄此提示詞草稿？',
  'pages.chat.promptLibrary.discardDescription': '您的修改尚未儲存至提示詞庫。',
  'pages.chat.promptLibrary.discard': '捨棄',
  'pages.chat.promptLibrary.keepEditing': '繼續編輯',
  'pages.chat.promptLibrary.saved': '提示詞已儲存至您的個人提示詞庫。',
  'pages.chat.promptLibrary.viewLibrary': '檢視提示詞庫',
  'pages.chat.promptLibrary.saveFailed': '無法儲存提示詞。您的草稿仍然保留，請重試。',
  'pages.chat.promptLibrary.create': '建立可重複使用的提示詞',
  'pages.chat.promptLibrary.cancel': '取消',
  'pages.chat.promptLibrary.save': '儲存至我的提示詞庫',
  'pages.chat.promptLibrary.reviewTitle': '使其適用於新對話',
  'pages.chat.promptLibrary.reviewDescription':
    '保留可重複使用的指令，或將有用的回答作為範例。將名稱和事項特有的事實替換為[協議]等預留位置。請明確說明「上述」等表述所指的內容。聊天記錄和附件不會包含在內。',
  'pages.chat.promptLibrary.original': '原始聊天文字',
  'pages.chat.promptLibrary.keepWording': '保留所選措辭',
  'pages.chat.promptLibrary.useExample': '用作輸出範例',
  'pages.chat.promptLibrary.exampleHelp': '請填寫下方的任務、輸入和要求，說明如何產生類似結果。',
  'pages.chat.promptLibrary.name': '名稱',
  'pages.chat.promptLibrary.nameRequired': '請輸入此提示詞的名稱。',
  'pages.chat.promptLibrary.purpose': '用途',
  'pages.chat.promptLibrary.content': '提示詞',
  'pages.chat.promptLibrary.contentRequired': '請輸入要儲存的指令。',
  'pages.adminManagement.groupName': '群組名稱',
  'pages.adminManagement.personalTag': '個人',
  'pages.adminManagement.owner': '擁有者',
  'pages.adminManagement.deletedUserTag': '已刪除的使用者',
  'pages.adminManagement.members': '成員',
  'pages.adminManagement.options': '選項',
  'pages.adminManagement.manageGroupTooltip': '管理群組',
  'pages.adminManagement.manageFilesTooltip': '管理檔案',
  'pages.adminManagement.removeGroupTooltip': '移除群組',
  'pages.adminManagement.stats.totalUsers': '使用者總數',
  'pages.adminManagement.stats.totalGroups': '群組總數',
  'pages.adminManagement.stats.personalGroups': '個人群組',
  'pages.adminManagement.stats.sharedGroups': '共用群組',
  'pages.adminManagement.stats.totalFiles': '檔案總數',
  'pages.adminManagement.stats.totalFolders': '資料夾總數',
  'pages.adminManagement.sharedTag': '共用',
  'pages.adminManagement.moveAll': '全部移動',
  'pages.adminManagement.fileDescription': '{username} · {action} {date}',
  'pages.adminManagement.fileAction.uploaded': '已上傳',
  'pages.adminManagement.fileAction.created': '已建立',
  'pages.adminManagement.createGroupButton': '建立群組',
  'pages.adminManagement.modifyUserGroupTitle': '修改使用者群組',
  'pages.adminManagement.createUserGroupTitle': '建立使用者群組',
  'pages.adminManagement.updateSubmitText': '更新',
  'pages.adminManagement.userGroupUpdatedSuccess': '使用者群組已成功更新',
  'pages.adminManagement.userGroupCreatedSuccess': '使用者群組已成功建立',
  'pages.adminManagement.groupNameRequiredMessage': '請輸入群組名稱',
  'pages.adminManagement.ownerRequiredMessage': '請選擇群組擁有者',
  'pages.adminManagement.membersRequiredMessage': '請選擇群組成員',
  'pages.adminManagement.moveFolderTitle': '移動資料夾',
  'pages.adminManagement.moveFileTitle': '移動檔案',
  'pages.adminManagement.allMovedSuccess': '已成功全部移動',
  'pages.adminManagement.folderMovedSuccess': '資料夾已成功移動',
  'pages.adminManagement.fileMovedSuccess': '檔案已成功移動',
  'pages.adminManagement.destinationGroupLabel': '目標群組',
  'pages.adminManagement.destinationGroupRequiredMessage': '請選擇目標群組',
  'pages.adminManagement.destinationFolderPlaceholder': '選擇目標資料夾',
  'pages.adminManagement.renameOptionalLabel': '重新命名（選填）',
  'pages.adminManagement.loadFolderDataError': '載入資料夾資料失敗',
  'pages.adminManagement.ownerCannotBeRemovedWarning': '群組擁有者無法從成員中移除',
  'pages.aISetting.promptCopied': '提示詞已複製！',
  'pages.aISetting.failedToCopyPrompt': '複製提示詞失敗',
  'pages.aISetting.updatedByMeta': '由 {user} 於 {date} 更新',
  'pages.aISetting.updateButton': '更新',
  'pages.aISetting.systemPromptLabel': '系統提示詞',
  'pages.aISetting.additionalPromptLabel': '附加提示詞',
  'pages.aISetting.temperatureLabel': '溫度',
  'pages.aISetting.updatedBadge': '已更新！！',
  'pages.aISetting.requiredParamsMissing': '缺少必要參數：{params}',
  'pages.angelInsider.micrositeFrameTitle': 'A&GEL Insider',
  'pages.angelInsider.nav.basics': '基礎入門',
  'pages.angelInsider.nav.learnMore': '深入了解',
  'pages.angelInsider.nav.whatsNew': '最新消息',
  'pages.angelInsider.nav.futureStuff': '未來展望',
  'pages.angelInsider.nav.logoAlt': 'A&GEL Insider',
  'pages.angelInsider.landing.tiles.basics.title': '基礎入門',
  'pages.angelInsider.landing.tiles.basics.subtitle': '從這裡開始，涵蓋您第一天所需的一切。',
  'pages.angelInsider.landing.tiles.learnMore.title': '深入了解',
  'pages.angelInsider.landing.tiles.learnMore.subtitle': '進階功能，滿足想更進一步的您。',
  'pages.angelInsider.landing.tiles.whatsNew.title': '最新消息',
  'pages.angelInsider.landing.tiles.whatsNew.subtitle': '近期推出的功能與更新。',
  'pages.angelInsider.landing.tiles.comingUp.title': '未來展望',
  'pages.angelInsider.landing.tiles.comingUp.subtitle': '團隊接下來正在打造的內容。',
  'pages.angelInsider.landing.pills.all': '全部',
  'pages.angelInsider.landing.pills.chatAndContext': '對話與情境',
  'pages.angelInsider.landing.pills.filesAndVault': '檔案與保管庫',
  'pages.angelInsider.landing.pills.promptLibrary': '提示詞庫',
  'pages.angelInsider.landing.pills.quickInfo': '快速資訊',
  'pages.angelInsider.landing.pills.scribe': '錄音',
  'pages.angelInsider.landing.pills.disputeResolution': '爭議解決',
  'pages.angelInsider.landing.pills.sideBySide': '並排比較',
  'pages.angelInsider.landing.pills.multiStepPrompt': '多步驟提示詞',
  'pages.angelInsider.landing.pills.timeline': '時間軸',
  'pages.angelInsider.landing.pills.workstudio': 'Workstudio',
  'pages.angelInsider.landing.pills.deepResearch': '深度研究',
  'pages.angelInsider.landing.pills.scopeSummary': '範圍摘要',
  'pages.angelInsider.landing.pills.review': '審閱',
  'pages.angelInsider.landing.pills.whatsNew': '最新消息',
  'pages.angelInsider.landing.pills.futureStuff': '未來展望',
  'pages.angelInsider.landing.preferOneFeature': '想要一次專注了解一項功能嗎？',
  'pages.angelInsider.landing.scrollFeatureList': '捲動功能清單',
  'pages.angelInsider.basics.habits.habit1.num': '習慣 01',
  'pages.angelInsider.basics.habits.habit1.title': '為 A&GEL 提供可運用的資訊',
  'pages.angelInsider.basics.habits.habit2.num': '習慣 02',
  'pages.angelInsider.basics.habits.habit2.title': '將 LLM 視為「文字處理器」，而非知識引擎',
  'pages.angelInsider.basics.habits.habit3.num': '習慣 03',
  'pages.angelInsider.basics.habits.habit3.title': '不只是聊天—探索其他功能',
  'pages.angelInsider.basics.heading': '基礎入門',
  'pages.angelInsider.basics.welcome.timeHeading': '學習新工具需要時間—這是很正常的',
  'pages.angelInsider.basics.welcome.pacingHeading': '依照自己的步調前進',
  'pages.angelInsider.basics.welcome.togetherHeading': '攜手同行，走得更遠',
  'pages.angelInsider.basics.welcome.signatureName': 'Kok Leong',
  'pages.angelInsider.basics.welcome.signatureTeam': 'A&GEL 開發團隊',
  'pages.angelInsider.basics.welcome.ctaLetsBegin': '開始使用 →',
  'pages.angelInsider.basics.habitsSection.title': '三個習慣，引導您展開旅程',
  'pages.angelInsider.reader.back': '← 返回',
  'pages.angelInsider.reader.label': 'A&GEL INSIDER',
  'pages.angelInsider.reader.contents': '目錄',
  'pages.angelInsider.reader.issueNumber': '第 {number} 期',
  'pages.angelInsider.reader.featureGuide': '功能指南',
  'pages.angelInsider.reader.minRead': '閱讀時間 {minutes} 分鐘',
  'pages.angelInsider.reader.atAGlance': '概覽',
  'pages.angelInsider.blockRenderer.supportedAlt': '支援',
  'pages.angelInsider.typewriterExample.badLabel': '這樣可以：',
  'pages.angelInsider.typewriterExample.goodLabel': '但這樣更好：',
  'pages.angelInsider.basics.habits.labels.takeaways': '重點整理',
  'pages.angelInsider.basics.habits.labels.examples': '範例',
  'pages.angelInsider.basics.habits.labels.benefits': '效益',
  'pages.angelInsider.basics.habits.habit1.tile.patternMatchers':
    'A&GEL 這類 AI 工具並不會讀心；它們是<strong>模式比對器</strong>。問題問得籠統，得到的就是泛泛的答案；提供豐富而具體的情境，才更有可能獲得精準、可付諸行動的結果。',
  'pages.angelInsider.basics.habits.habit1.tile.callItContext':
    '我們把這個起點稱為<strong>「情境」</strong>。',
  'pages.angelInsider.basics.habits.habit1.tile.rawMaterial':
    '請把情境視為 A&GEL 賴以工作的原料。撰寫法律備忘錄時，別只說「彙整這個案子」。應該上傳判決書、指出您在意的關鍵事實或法律爭點，並告訴 AI 讀者是誰（您也可以使用我們為彙整任務開發的現成提示詞，可在提示詞庫中找到）。一般而言，您提供的情境越多，A&GEL 表現越好。',
  'pages.angelInsider.basics.habits.habit1.tile.promptLibraryLink': '了解更多提示詞庫內容',
  'pages.angelInsider.basics.habits.habit1.tile.empowerYou':
    'A&GEL 這類 AI 工具直接賦能<em>您本人</em>—它們會放大您的能力，但前提是由您指出方向。沒有情境，AI 就像一位未獲案情簡報的傑出律師，或一位缺少必要背景資訊、無從著手的能幹同事。',
  'pages.angelInsider.basics.habits.habit1.tile.vault.title': '保管庫是您在 A&GEL 上的「大腦」',
  'pages.angelInsider.basics.habits.habit1.tile.vault.body':
    '保管庫是 A&GEL 最主要的情境來源，它把 A&GEL 的輸出錨定在您可信、經過整理的知識庫之上。A&GEL 不會搜尋網際網路—它嚴格在您上傳的內容範圍內運作。請把它想成一位不知疲倦的同事：遞給他一張堆滿無關檔案的凌亂辦公桌，他的工作就會打折扣；遞給他一份切題的先例，他的工作就會變得犀利。請把檔案整理進合乎邏輯的子資料夾，對上傳內容有所取捨，並用「引用檔案權重」與「工作階段檔案權重」微調 A&GEL 的優先順序。請把保管庫當成一座精心編排的圖書館，而不是垃圾掩埋場。',
  'pages.angelInsider.basics.habits.habit1.tile.vault.link': '了解更多保管庫內容',
  'pages.angelInsider.basics.habits.habit1.tile.documents.title':
    '在下提示詞之前先給 A&GEL 具體的文件',
  'pages.angelInsider.basics.habits.habit1.tile.documents.body':
    '如果您把檔案拖放到對話中，或選取某份檔案與它對話，這就等於只把這份文件的內容載入 A&GEL 的短期記憶。參加過我們工作坊的許多同仁應該都聽我們把這份檔案形容成「你昨晚剛追完的那集韓劇」（<em>今天滿腦子都只想聊它</em>）。這會讓 A&GEL 產生「隧道視野」，而這一點可以善加運用，用來取得準確的輸出。',
  'pages.angelInsider.basics.habits.habit1.tile.documents.link': '了解更多情境內容',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.title':
    '與 A&GEL 協作，和與同事協作並無二致',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.body':
    '正如您會給團隊成員一些資訊以助其推進工作，對 A&GEL 也是一樣。',
  'pages.angelInsider.basics.habits.habit1.tile.query.title':
    '那我提示詞中的問題或指令本身呢？這算不算「給了 A&GEL 一些東西」？',
  'pages.angelInsider.basics.habits.habit1.tile.query.body':
    '算。對 A&GEL 這類 AI 工具而言，提示詞只是被當成一串文字來吸收／處理，因此整則提示詞對 AI 工具或 A&GEL 來說就是「情境」。如果您在提示詞中提問，那麼問得更好，答案自然更好。',
  'pages.angelInsider.basics.habits.habit1.tile.query.link': '了解更多提示詞撰寫內容',
  'pages.angelInsider.basics.habits.habit1.tile.benefitsIntro':
    '為 A&GEL 提供豐富的情境，您將獲得：',
  'pages.angelInsider.basics.habits.habit1.tile.benefit1':
    '<strong>更好的輸出：</strong>具體的情境帶來具體的結果—獲得充分簡報的 A&GEL，表現得像一位已然熟悉案情的同事，而非從零開始的新手。',
  'pages.angelInsider.basics.habits.habit1.tile.benefit2':
    '<strong>更少的來回：</strong>起點越精準，您花在重複下提示詞或修正上的時間就越少。請及早把方向定準。',
  'pages.angelInsider.basics.habits.habit1.tile.benefit3':
    '<strong>（好的那種）隧道視野：</strong>在下提示詞前先上傳特定文件，會把 A&GEL 的注意力牢牢鎖定—它只在該情境內運作，這代表更高的正確性與更少的輸出雜訊。',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.bad':
    '把每一次 A&GEL 對話都當成一次性行為，每次都從零開始',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.good':
    '像對待新加入團隊的同事那樣把 A&GEL 拉進來—先簡要說明案件、當事人以及您想達成的目標，再請它動手。',
  'pages.angelInsider.basics.habits.habit1.examples.clause.bad': '請 A&GEL「審閱這個條款」',
  'pages.angelInsider.basics.habits.habit1.examples.clause.good':
    '「請為[客戶]審閱這個條款，用於[……]」，並說明審閱時應留意什麼（例如「任何與費用或財務事項相關的問題」）。',
  'pages.angelInsider.basics.habits.habit2.tile.intro':
    '大型語言模型擅長整理資訊結構、辨識模式、撰寫文字以及組織複雜資料。它是用來<em>處理</em>的工具，而不是用來<em>決策</em>的。您依然是裁判、策略制定者與最終權威。AI 承擔語言處理的粗重活—改寫、彙整、萃取條款—而由您運用專業能力驗證其輸出。這個區分至關重要：可以信任 AI 去處理，但絕不要把判斷外包出去。正如指南所提醒的，AI 工具「或許無法取代人的判斷，但在許多方面能放大您的能力」。',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.title':
    '把它拆開（尤其是冗長的提示詞）',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.body':
    '許多使用者把 A&GEL 當成簡單的聊天機器人，打進一長串提示詞就期待最好的結果。這並不是使用 A&GEL 這類 AI 工具的最佳方式。進階使用者會把複雜任務拆解成更小、更好掌握的部分—與其用一則大提示詞，不如分成數則子提示詞。這種技巧稱為<em>分解</em>，往往能帶來更高品質的結果。',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.imageAlt': '一則冗長的提示詞',
  'pages.angelInsider.basics.habits.habit2.tile.oneGoExample':
    '一口氣執行一則龐大、繁複、多部分的提示詞，例如「準備一份報告，涵蓋我在文件 1 與文件 2 中的所有關注事項，接著彙整該報告以產生執行摘要，然後再把完整報告與執行摘要合併成一份文件」。',
  'pages.angelInsider.basics.habits.habit2.tile.breakTaskIntro':
    '把任務拆成更小的連續步驟，並用應用程式中的多步驟提示詞逐一執行。',
  'pages.angelInsider.basics.habits.habit2.tile.step1.title': '步驟 1：萃取',
  'pages.angelInsider.basics.habits.habit2.tile.step1.context':
    '輸入情境：[<em>插入文件 1 與文件 2 的內文</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step1.prompt':
    '提示詞 1：「產生一份完整的條列清單，列出兩份文件中提及的所有關注事項、問題或風險。」',
  'pages.angelInsider.basics.habits.habit2.tile.step2.title': '步驟 2：撰寫完整報告',
  'pages.angelInsider.basics.habits.habit2.tile.step2.context':
    '輸入情境：[<em>插入步驟 1 的輸出</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step2.prompt':
    '提示詞 2：「運用該條列清單，撰寫一份詳盡的正式報告。把相似的關注事項歸入相應標題之下。請勿加入引言或執行摘要。」',
  'pages.angelInsider.basics.habits.habit2.tile.step3.title': '步驟 3：執行摘要與最終彙整',
  'pages.angelInsider.basics.habits.habit2.tile.step3.context':
    '輸入情境：[<em>插入步驟 2 的輸出</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step3.prompt':
    '提示詞 3：「首先，為這份正式報告撰寫一段精簡的執行摘要。接著輸出該執行摘要，加上一條視覺分隔線，並在其下方原樣輸出該正式報告，以形成一份合併後的文件。」',
  'pages.angelInsider.basics.habits.habit2.tile.multiStepLink': '查看多步驟提示詞的完整實作範例',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.title':
    '用 A&GEL 改寫、排版既有文字，或據以延伸推演',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.body':
    '與其在毫無參考資料的情況下請 A&GEL 從零撰擬複雜的法律文件，不如提供參考資料，並且 (i) 借助 A&GEL 的語言能力，把您的草稿在語氣、結構或排版上加以調整，或把多份草稿融合為一；或 (ii) 從中延伸推演意圖、走向、影響或其他次階特徵（例如跨數個段落或文件產生一份審閱發現清單）。',
  'pages.angelInsider.basics.habits.habit2.tile.benefitsIntro':
    '把 A&GEL 當成文字處理器並拆解您的任務，您將獲得：',
  'pages.angelInsider.basics.habits.habit2.tile.benefit1':
    '<strong>更高品質的輸出：</strong>把複雜任務分解成子提示詞，能讓 A&GEL 一次只專注一件事—每一步都穩穩地建立在前一步之上，而不會在一則超載的提示詞下崩塌。',
  'pages.angelInsider.basics.habits.habit2.tile.benefit2':
    '<strong>更可預期的結果：</strong>當您掌控每一步，您就掌控了輸出。您可以先驗證再往前推進，而不是期待一則大提示詞剛好命中。',
  'pages.angelInsider.basics.habits.habit2.tile.benefit3':
    '<strong>更善用您的專業：</strong>A&GEL 承擔語言上的粗重活—改寫、建立結構、萃取重點。您則保持審閱者與策略制定者的角色，而這正是您的判斷最有價值之處。',
  'pages.angelInsider.basics.habits.habit2.examples.nda.bad':
    '請 A&GEL「為一個軟體專案撰擬一份保密協議」',
  'pages.angelInsider.basics.habits.habit2.examples.nda.good':
    '「這是我們的標準保密協議範本[貼上]。請把保密期間改為 5 年，加入法規揭露的例外條款，並把所有關於新加坡法律的引用替換為香港法律。」',
  'pages.angelInsider.basics.habits.habit3.tile.intro':
    '透過探索單純對話以外的功能—例如上傳文件、使用特定應用程式或專門功能，或把多個功能依步驟串接起來—您可以對輸出取得更細緻的掌控。',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.title': '動手嘗試是關鍵',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.body':
    '請自由嘗試與探索其他功能。專門模式下的許多功能都針對更高的正確性與周全度做過調校。請找出最適合您工作流程的功能，並且不要害怕犯錯。能力養成就像爬樓梯；先從基礎開始，隨著信心增加，您自然會走向更進階的技巧。',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.closing':
    '當您掌握了情境、尊重 AI 作為文字處理器的角色（以及您自身作為專家的角色），並學會拆解複雜任務，您就會把 A&GEL 從一件新奇玩意兒，變成日常執業中不可或缺的一部分。',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.title':
    'A&GEL 與其說是聊天機器人，不如說是一把瑞士刀',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.body':
    '這是我們一開始就做的設計選擇：提供一整套多用途的知識工具，以精準之力破解複雜難題，而不是把所有能力都塞進單一對話視窗。對話很適合腦力激盪與快速提問，但面對篇幅極大的文件（例如超過 20,000 字的文件）或複雜的多步驟、多部分任務時就會力有未逮。我們沒有把這些利器藏在對話裡，而是把它們放在左側邊欄最顯眼的位置。我們的目標，是協助您把具體的工作目標與合適的功能—或功能組合—連結起來。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.title': '探索對話以外的其他功能',
  'pages.angelInsider.basics.habits.habit3.tile.explore.review':
    '審閱：適合多文件分析、實地查核，以及運用結構化問題清單梳理複雜檔案。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.reviewLink': '了解更多審閱內容',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudio':
    'Workstudio：透過自動落實標準立場，使合約撰擬標準化。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudioLink': '了解更多 Workstudio 內容',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribe':
    '錄音：把音訊檔精準轉寫成文字，並支援即時逐字稿與跨境通話的同步翻譯。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribeLink': '了解更多錄音內容',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfo':
    '快速資訊／引導式摘要：對任一單份文件進行快速且可溯源的解讀。要概覽就用快速資訊；想掌控重點就用引導式摘要。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfoLink':
    '了解更多快速資訊與引導式摘要內容',
  'pages.angelInsider.basics.habits.habit3.tile.explore.translation':
    '翻譯：為法律與商務內容提供專門的、段落層級精準的翻譯。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.apps':
    '應用程式：針對特定任務在正確性與周全度上做過調校。舉例來說，多步驟提示詞提供多種分析工具，可就特定重點剖析文件，為篇幅更長、複雜度超出對話能力範圍的工作提供所需的精確度。',
  'pages.angelInsider.basics.habits.habit3.tile.benefitsIntro': '把任務對應到具體功能，您將獲得：',
  'pages.angelInsider.basics.habits.habit3.tile.benefit1':
    '<strong>更高的掌控度：</strong>為工作挑選合適的工具，而不是一味依賴單一的對話介面，正確性自然更高。',
  'pages.angelInsider.basics.habits.habit3.tile.benefit2':
    '<strong>能力累積：</strong>動手嘗試是關鍵。當您試用不同功能與組合時，就會逐步建立起對 A&GEL 能力邊界的心智模型。這就像爬樓梯：先從對話中的基礎提問開始，隨著熟練度提升，再進階到應用程式或審閱中的複雜多步驟分析。',
  'pages.angelInsider.basics.habits.habit3.tile.benefit3':
    '<strong>效率：</strong>知道該用哪一件工具就能省下時間。您不必再為那些本該交給專門功能處理的任務（例如用錄音做逐字稿、用翻譯做精準語言轉換）在對話裡反覆折騰提示詞。',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.bad':
    '不論面對 90 頁的合約還是多步驟分析，都只用對話',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.good':
    '試著用審閱處理一份冗長的合約，或用多步驟提示詞處理一項分成數個階段的任務—並留意哪個功能在該項工作上更快、更準。',
  'pages.angelInsider.basics.habits.habit3.examples.paste.bad':
    '把一份 90 頁的合約貼進對話，然後問「有哪些風險？」',
  'pages.angelInsider.basics.habits.habit3.examples.paste.good':
    '用「審閱」搭配一份結構化的問題清單來處理它—或使用應用程式中的「多步驟」—逐節梳理該文件，精準找出您真正要找的內容。',
  'pages.angelInsider.seeMore': '查看更多',
  'pages.angelInsider.learnMore.heading': '深入了解',
  'pages.angelInsider.learnMore.intro':
    '除了對話之外，A&GEL 的應用程式模式還涵蓋各種專項任務：深度研究、引導式摘要、快速資訊、時間軸以及擷取期限。這些功能越精準、準備越充分，成效越好。',
  'pages.angelInsider.learnMore.featuredBadge': '精選',
  'pages.angelInsider.learnMore.cards.usingFiles.title': '在 A&GEL 中使用您的檔案',
  'pages.angelInsider.learnMore.cards.usingFiles.body':
    '掃描的紙本文件必須先具備文字圖層，A&GEL 才能讀取。請先使用 Kofax 將 PDF 轉為可搜尋格式，再行上傳。',
  'pages.angelInsider.learnMore.cards.workStudio.title': 'Workstudio',
  'pages.angelInsider.learnMore.cards.workStudio.body':
    '只要一次建立團隊的標準立場——A&GEL 便會回傳附有追蹤修訂的 Word 文件。',
  'pages.angelInsider.learnMore.cards.workStudio.imageAlt': 'Workstudio',
  'pages.angelInsider.learnMore.cards.review.title': '審閱',
  'pages.angelInsider.learnMore.cards.review.body':
    '一次針對多份文件提出多個問題——結果以表格呈現，並附上內嵌引註。使用迷你對話即可在同一頁面繼續追問。',
  'pages.angelInsider.learnMore.cards.review.imageAlt': '審閱模式',
  'pages.angelInsider.learnMore.cards.dispute.title': '爭議解決',
  'pages.angelInsider.learnMore.cards.dispute.body':
    '在完整文件集中完成案件摘要、起訴狀分析、答辯狀撰擬與訴狀追蹤。',
  'pages.angelInsider.learnMore.cards.dispute.imageAlt': '訴狀追蹤器',
  'pages.angelInsider.learnMore.cards.sideBySide.title': '並排比較與差異比對',
  'pages.angelInsider.learnMore.cards.sideBySide.body':
    '逐條款審閱，並可完整驗證來源段落。差異比對功能支援追蹤修訂與修正條款。',
  'pages.angelInsider.learnMore.cards.sideBySide.imageAlt': '並排比較分析',
  'pages.angelInsider.learnMore.cards.multiStep.title': '多步驟提示詞',
  'pages.angelInsider.learnMore.cards.multiStep.body':
    '將複雜的法律任務拆解為連續步驟，每一步都以前一步為基礎。',
  'pages.angelInsider.learnMore.cards.multiStep.imageAlt': '應用程式模式',
  'pages.angelInsider.learnMore.cards.timeline.title': '時間軸',
  'pages.angelInsider.learnMore.cards.timeline.body':
    '將最多 100 份文件的時序整合為一條經來源驗證的時間軸。',
  'pages.angelInsider.learnMore.cards.timeline.imageAlt': '時間軸',
  'pages.angelInsider.learnMore.cards.deepResearch.title': '深度研究',
  'pages.angelInsider.learnMore.cards.deepResearch.body':
    '在結構化研究提示詞的引導下進行深入的跨文件分析。每項發現都可透過可點擊的內嵌引註回溯至來源段落。',
  'pages.angelInsider.learnMore.cards.deepResearch.imageAlt': '深度研究',
  'pages.angelInsider.learnMore.cards.scopeSummary.title': '範圍摘要',
  'pages.angelInsider.learnMore.cards.scopeSummary.body':
    '依您設定的重點範圍產生結構化摘要。每個擷取要點都附有可點擊的內嵌引註，方便對照來源驗證。',
  'pages.angelInsider.learnMore.faq.heading': '常見問題',
  'pages.angelInsider.learnMore.faq.group1.kicker': '一般原則',
  'pages.angelInsider.learnMore.faq.experts.question': '「始終讓專業人士發揮專業」是什麼意思？',
  'pages.angelInsider.learnMore.faq.experts.answer':
    '身為專業人士，您的判斷、洞察與操守應始終是工作的核心。A&GEL 不會取代您的專業——它的設計目的是協助您用更多資源完成更多事。',
  'pages.angelInsider.learnMore.faq.unfamiliar.question':
    '如果我對詢問 A&GEL 的主題完全不熟悉，該怎麼辦？',
  'pages.angelInsider.learnMore.faq.unfamiliar.answer':
    '您仍然可以使用 A&GEL——但請更謹慎，並對輸出進行更多查核。可將 A&GEL 視為通往團隊既有專業知識的入口，隨時取得洞見，支援您的訓練與發展。',
  'pages.angelInsider.learnMore.faq.group2.kicker': '檔案管理',
  'pages.angelInsider.learnMore.faq.referenceMaterial.question': '我應該上傳哪類參考資料到 A&GEL？',
  'pages.angelInsider.learnMore.faq.referenceMaterial.answer':
    '僅上傳可信、可靠且正確的資料——第一手法律來源（法規、判例）以及可信的內部資料（公司專業知識、經驗證的文件）。請維持清楚的命名規則。',
  'pages.angelInsider.learnMore.faq.thirdParty.question': '我可以上傳第三方文件嗎？',
  'pages.angelInsider.learnMore.faq.thirdParty.answer':
    '可以——包括對造律師提供的文件。請上傳至明確標示的資料夾，以便與您可信的範本區分。同時請遵守公司關於 AI 使用與第三方內容的相關政策。',
  'pages.angelInsider.learnMore.faq.processingTime.question':
    '為什麼 A&GEL 處理上傳檔案需要較長時間？',
  'pages.angelInsider.learnMore.faq.processingTime.answer':
    '文件必須先轉換為 A&GEL 可運用的「嵌入向量」——此程序在上傳時只會執行一次。在對話中，您可透過「情境」按鈕選取已上傳的文件，於新工作階段中重複使用。',
  'pages.angelInsider.learnMore.faq.bulkUpload.question': '我該如何批次上傳文件？',
  'pages.angelInsider.learnMore.faq.bulkUpload.answer':
    '在檔案模式下，點擊右上角的上傳按鈕，選取檔案後按「開啟」。上傳進行期間，您仍可繼續使用 A&GEL。',
  'pages.angelInsider.learnMore.faq.sorting.question': '我該如何整理與管理參考資料？',
  'pages.angelInsider.learnMore.faq.sorting.answer':
    '請勿把所有內容都放進同一個資料夾。請依（i）主題與（ii）工作流程分類文件——例如 <code>Home / IP Licensing / Licensor</code>。這有助於 A&GEL 擷取正確的情境，也讓您更容易驗證其輸出。',
  'pages.angelInsider.learnMore.faq.group3.kicker': '提示詞撰寫',
  'pages.angelInsider.learnMore.faq.promptTypes.question': '我可以使用哪些類型的提示詞？',
  'pages.angelInsider.learnMore.faq.promptTypes.answer':
    '包括資訊查詢類（提問式、說明式、研究式）、任務導向類（指令式、多步驟、範本式）、分析類（資料分析、問題解決、比較分析）、分類類（歸類、排序、標記）以及轉換類（翻譯、格式轉換、文風調整）等提示詞。',
  'pages.angelInsider.learnMore.faq.effectivePrompts.question': '我該如何撰寫有效的提示詞？',
  'pages.angelInsider.learnMore.faq.effectivePrompts.answer':
    '最有效的提示詞包含四個部分：<strong>（a）角色</strong>——A&GEL 應扮演的身分；<strong>（b）任務</strong>——具體的指令；<strong>（c）情境</strong>——背景資訊與參考資料；<strong>（d）格式</strong>——您希望輸出呈現的結構。',
  'pages.angelInsider.learnMore.faq.rag.question': '什麼是 RAG？A&GEL 何時會使用它？',
  'pages.angelInsider.learnMore.faq.rag.answer':
    'RAG（檢索增強生成）是 A&GEL 對話模式的預設方式。它會取用您保管庫中的參考資料，並連同您的提示詞一起傳給模型，以提升輸出的精確度與可靠性。',
  'pages.angelInsider.learnMore.faq.allMaterials.question':
    '為什麼不該讓 A&GEL 在每次提示時都納入我上傳的所有資料？',
  'pages.angelInsider.learnMore.faq.allMaterials.answer':
    '提供不相關的情境會降低速度、正確性與可靠性。A&GEL 以機率方式運作，可能引用不適合當前任務的資料。請將情境限縮為與您提示詞相關的文件。',
  'pages.angelInsider.learnMore.faq.selectMaterials.question':
    '我該如何為每個提示詞挑選相關的參考資料？',
  'pages.angelInsider.learnMore.faq.selectMaterials.answer':
    '在對話模式中，前往「情境」，點擊選取圖示，僅勾選相關的文件或資料夾。',
  'pages.angelInsider.learnMore.faq.group4.kicker': '運用輸出結果',
  'pages.angelInsider.learnMore.faq.outputAsIs.question': '我可以直接使用 A&GEL 的輸出嗎？',
  'pages.angelInsider.learnMore.faq.outputAsIs.answer':
    '不行——使用前請務必檢查 A&GEL 的輸出。請將其視為起點，並與可信的知識來源（包括您上傳的參考資料）交叉查核。',
  'pages.angelInsider.learnMore.faq.accuracy.question': '我該如何查核輸出的正確性與可靠性？',
  'pages.angelInsider.learnMore.faq.accuracy.answer':
    '在對話模式中，輸出會附上 A&GEL 所引用來源文件的參考連結。請逐一點擊參考連結，對照原始資料進行驗證。A&GEL 應是通往您專業知識的入口，而非知識本身的來源。沒有參考來源的輸出容易產生幻覺，除非提示詞純粹用於寫作、格式編排或文字編輯且已提供充分情境，否則不應使用。',
  'pages.angelInsider.learnMore.faq.group5.kicker': '詞彙表',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.term': '最愛檔案權重',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.definition':
    '調整 A&GEL 在產生回應時，對保管庫中標示為「最愛」之文件的優先程度。',
  'pages.angelInsider.learnMore.glossary.reRanking.term': '重新排序',
  'pages.angelInsider.learnMore.glossary.reRanking.definition':
    '一項次級排序程序，會複查初始搜尋結果，在產生回應前優先挑出最相關的條款與文字片段。',
  'pages.angelInsider.learnMore.glossary.searchRatio.term': '搜尋比例',
  'pages.angelInsider.learnMore.glossary.searchRatio.definition':
    '控制 A&GEL 搜尋保管庫的廣度。比例越高，情境範圍越廣；比例越低，越著重精確比對。',
  'pages.angelInsider.learnMore.glossary.systemPrompt.term': '系統提示詞',
  'pages.angelInsider.learnMore.glossary.systemPrompt.definition':
    '為每次工作階段設定 A&GEL 角色、語氣與界線的基礎指令。',
  'pages.angelInsider.learnMore.glossary.thinking.term': '「思考」/「推理」',
  'pages.angelInsider.learnMore.glossary.thinking.definition':
    'A&GEL 在產生最終回應前所進行的內部逐步推演，目的是減少複雜分析中的錯誤。',
  'pages.angelInsider.learnMore.issues.heading': '如果您想閱讀各期內容',
  'pages.angelInsider.learnMore.issues.issue1.title': '情境（幾乎）就是一切',
  'pages.angelInsider.learnMore.issues.issue1.description':
    '基礎入門 • 提示詞要點 • 2026 年 2 月 17 日',
  'pages.angelInsider.learnMore.issues.issue2.title': '爭議解決應用情境',
  'pages.angelInsider.learnMore.issues.issue2.description':
    '案件摘要 • 訴狀追蹤器 • 提示詞技巧 • 2026 年 3 月 19 日',
  'pages.angelInsider.learnMore.issues.issue3.title': '全新時間軸與多步驟提示詞應用程式',
  'pages.angelInsider.learnMore.issues.issue3.description':
    '電子郵件上傳 • 錄音更新 • 時間軸改版 • 2026 年 3 月 19 日',
  'pages.angelInsider.learnMore.issues.issue4.title': '錄音即時翻譯與 Workstudio',
  'pages.angelInsider.learnMore.issues.issue4.description':
    '即時翻譯 • 全新 Workstudio 功能 • 2026 年 4 月 1 日',
  'pages.angelInsider.learnMore.issues.issue5.title': '內嵌引註、迷你對話與更多更新',
  'pages.angelInsider.learnMore.issues.issue5.description':
    '定位引註 • 可移動迷你對話 • 錄音時間戳記 • 2026 年 4 月 10 日',
  'pages.angelInsider.learnMore.issues.pill': '第 {number} 期',
  'pages.angelInsider.whatsNew.heading': '最新消息',
  'pages.angelInsider.whatsNew.cards.msgUpload.title': '.msg 郵件上傳',
  'pages.angelInsider.whatsNew.cards.msgUpload.body':
    '可直接上傳 .msg 電子郵件檔案，並完整讀取其中的附件內容。',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.title': '內嵌引註',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.body':
    '深度研究、時間軸、範圍摘要與審閱現已支援可點擊的定位引註——不必離開頁面即可對照來源驗證任何輸出。',
  'pages.angelInsider.comingUp.heading': '未來展望',
  'pages.angelInsider.comingUp.intro':
    '在下一期 A&GEL Insider 中，我們將更深入介紹 Workstudio。您將學會如何從零建構多步驟提示詞，並運用它們產生反映團隊標準立場的追蹤修訂草稿。敬請期待。',
  'pages.angelInsider.comingUp.cards.workstudioV2.title': 'Workstudio V2',
  'pages.angelInsider.comingUp.cards.workstudioV2.body':
    '更深入的 Workstudio 撰寫工具，以及更完整的追蹤修訂輸出。詳情請見第 5 期。',
  'pages.angelInsider.comingUp.cards.workstudioV2.badge': '即將推出',
  'pages.angelInsider.comingUp.cards.moreToCome.title': '更多內容陸續推出',
  'pages.angelInsider.comingUp.cards.moreToCome.body':
    'A&GEL 團隊持續推出新功能。敬請期待下一期 Insider。',
  'pages.angelInsider.comingUp.cards.moreToCome.badge': '開發中',
  'pages.angelInsider.issues.basics-intro.title': '歡迎使用 A&GEL',
  'pages.angelInsider.issues.basics-intro.subtitle': '幾點建議，助您有個好的開始。',
  'pages.angelInsider.issues.basics-intro.glance.0': '學習新工具需要時間——我們會在每一步支援您。',
  'pages.angelInsider.issues.basics-intro.glance.1':
    'A&GEL 這類工具能<strong>放大您的能力</strong>，遠超您獨自所能達成的程度。',
  'pages.angelInsider.issues.basics-intro.glance.2':
    '最好的學習方式就是<strong>開始使用 A&GEL</strong>——自由探索，容許犯錯。',
  'pages.angelInsider.issues.basics-intro.glance.3': '當團隊一起擁抱 A&GEL，效益會為所有人加乘。',
  'pages.angelInsider.issues.basics-intro.sections.0.kicker': '01 — 開始上手',
  'pages.angelInsider.issues.basics-intro.sections.0.heading': '學習新工具需要時間—這是很正常的',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.0.p':
    '很高興您加入我們。在您開始探索 A&GEL 之際，我們想分享幾點想法，助您有個好的開始。',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.1.p':
    '我們明白，剛開始接觸新技術時可能會覺得有些吃力。請記得：我們會在每一步支援您。若您有任何疑問、卡在某個環節，或只是希望我們帶您走一遍流程，都歡迎隨時與我們聯繫。',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.3.p':
    'A&GEL 這類 AI 工具<strong>與以往的工具不同</strong>——它們<strong>直接賦能於您</strong>。可以想像成隨時待命的一支助理團隊：它們或許無法取代人的判斷，但在許多方面都能把您的能力放大到獨自難以企及的程度。',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.4.p':
    '<strong>開始學習的最好方式，就是開始使用 A&GEL—</strong>我們鼓勵您自由探索。多方嘗試，容許自己犯（安全範圍內的）錯，從中找到最適合您的方式。',
  'pages.angelInsider.issues.basics-intro.sections.1.kicker': '02 — 能力養成',
  'pages.angelInsider.issues.basics-intro.sections.1.heading': '依照自己的步調前進',
  'pages.angelInsider.issues.basics-intro.sections.1.blocks.0.p':
    '可以把能力養成想成爬樓梯。先從基礎開始，隨著信心增加，往上一層走會自然許多。不必著急——這不是一場比賽。請給自己足夠的時間打好基礎。',
  'pages.angelInsider.issues.basics-intro.sections.2.kicker': '03 — 社群',
  'pages.angelInsider.issues.basics-intro.sections.2.heading': '攜手同行，走得更遠',
  'pages.angelInsider.issues.basics-intro.sections.2.blocks.0.p':
    '當團隊與事務所一起擁抱 A&GEL，效益會為所有人加乘。在使用者社群中分享知識、彼此協作，會產生提升所有人的漣漪效應。',
  'pages.angelInsider.issues.basics-intro.signoff.line':
    '歡迎加入——我們很期待與 A&GEL 一起做出什麼樣的成果。',
  'pages.angelInsider.issues.basics-intro.signoff.name': 'Kok Leong<br>A&GEL 開發團隊',
  'pages.angelInsider.issues.issue-1.title': '情境（幾乎）就是一切',
  'pages.angelInsider.issues.issue-1.subtitle': '提示詞要點—情境的選擇如何形塑 A&GEL 回傳的一切。',
  'pages.angelInsider.issues.issue-1.date': '2026 年 1 月 15 日',
  'pages.angelInsider.issues.issue-1.glance.0':
    '對話現已配備專屬的<strong>情境</strong>按鈕，以及<strong>「情境占比」</strong>指示器。',
  'pages.angelInsider.issues.issue-1.glance.1':
    '預設搜尋參數現為<strong>零情境</strong>——速度更快，適合校對與輕度編修。',
  'pages.angelInsider.issues.issue-1.glance.2':
    '從保管庫建立一組<strong>預設情境組合</strong>，供日常工作使用。',
  'pages.angelInsider.issues.issue-1.glance.3':
    '沒有情境的提示詞只是猜測——請務必補上只有您掌握的背景資訊。',
  'pages.angelInsider.issues.issue-1.sections.0.kicker': '01 — 對話',
  'pages.angelInsider.issues.issue-1.sections.0.heading':
    '對話中的情境：專屬按鈕與「情境占比」指示器',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.0.p':
    'A&GEL 的對話功能採用客製化的<strong>檢索增強生成（RAG）</strong>流程。它會取用您保管庫中的專業知識與參考資料，並傳給模型以產生輸出。決定 RAG 品質最重要的因素就是<em>情境選擇</em>——也就是答案取材自保管庫多大的範圍。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.1.p':
    '為了讓這一點更清楚，我們新增了<strong>「情境占比」</strong>指示器——雖然粗略，卻能一眼看出目前對話工作階段納入了保管庫多少內容。點擊情境按鈕，即可精確選擇要納入對話的資料夾或檔案。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.title': '新的預設值：零情境',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.body':
    '預設搜尋參數現為零情境（位於對話視窗右上角）。這樣對話速度更快，僅依預先訓練的公開知識生成內容——適合校對或文字修潤等簡單需求。在零情境設定下，A&GEL 通常可在數秒內回應。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.3.h': '為日常使用設定預設情境',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.4.p':
    '由於 A&GEL 是依據<em>您的</em>專業知識作答，您可以建立預設情境組合：點擊情境按鈕，選取資料夾，再點加號（+）。為組合命名，可勾選<strong>「設為預設」</strong>，然後按確定。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.5.p':
    '選取<strong>全部</strong>資料夾（100% 情境）會讓 A&GEL 變慢，因為它必須搜尋每一份文件——範圍越廣未必越好。請針對特定問題調整情境。回應時間可能長達一分鐘，取決於您可存取的檔案數量與問題的複雜度。',
  'pages.angelInsider.issues.issue-1.sections.1.kicker': '02 — 提示詞',
  'pages.angelInsider.issues.issue-1.sections.1.heading': '撰寫提示詞時，務必加上您的情境',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.0.quote':
    '沒有情境的提示詞只是猜測——形同「提示詞輪盤」。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.1.p':
    '提示詞要有效，就必須取得正確的資訊——在高度專業的領域尤其如此。請把 A&GEL 當作一位能幹的助理，但它需要完整的全貌：請提供只有您知道的背景——您的關鍵目標、成敗的衡量標準，甚至「好答案」與「壞答案」的範例。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.2.h': '讓提示詞更充實的簡單架構',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.3.p':
    '請不斷自問：我提供的情境是否足夠。這正是您展現專業功力之處——與基本提示相比，結果的品質可能有天壤之別。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.title': '訴訟範例',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.body':
    '訴訟律師只要複製一份提示詞，再把方括號中的部分改寫成自己案件的內容，輸出品質便會大幅提升。您提供的法律情境（適用法律的簡要整理）與商業情境（周邊事實背景）越充分，該提示詞作為分析工具的表現就越好。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.5.p':
    '最了解自身情境的人是您——因此請務必補上那種能讓您的提示詞、問題清單與自訂指令真正發揮效果的具體情境。',
  'pages.angelInsider.issues.issue-1.sections.2.kicker': '03 — 開始使用',
  'pages.angelInsider.issues.issue-1.sections.2.heading': '需要協助嗎？',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.title':
    '遇到問題？請告訴我們三件事',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.body':
    '請傳訊息或寄電子郵件給 A&GEL 開發人員。只要包含以下內容即可：',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.0':
    '<strong>時間戳記</strong>—例如「今天下午 4:31 開始的一次對話」',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.1':
    '<strong>出問題的功能</strong>—例如「在分析 → 深度研究中嘗試上傳檔案，卻無法載入」',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.2':
    '<strong>簡要描述</strong>或螢幕截圖',
  'pages.angelInsider.issues.issue-1.signoff.line': '祝好，並請記得—情境優先。',
  'pages.angelInsider.issues.issue-1.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.issue-2.title': '爭議解決應用情境',
  'pages.angelInsider.issues.issue-2.subtitle':
    '產生摘要與初稿、分析並追蹤訴狀—另附提示詞撰寫技巧。',
  'pages.angelInsider.issues.issue-2.date': '2026 年 2 月 12 日',
  'pages.angelInsider.issues.issue-2.glance.0':
    '兩組<strong>案件摘要</strong>提示詞（精簡版與詳盡版）—詳盡版在複雜判決上表現特別出色。',
  'pages.angelInsider.issues.issue-2.glance.1':
    '用於撰擬<strong>答辯狀</strong>與面向客戶的<strong>法律新知</strong>的提示詞。',
  'pages.angelInsider.issues.issue-2.glance.2':
    '一整套用於<strong>分析訴狀</strong>的提示詞—涵蓋起訴狀、答辯狀與訴狀充分性。',
  'pages.angelInsider.issues.issue-2.glance.3':
    '把<strong>審閱模式</strong>當成跨多份文件的訴狀追蹤器使用。',
  'pages.angelInsider.issues.issue-2.sections.0.kicker': '01 — 摘要',
  'pages.angelInsider.issues.issue-2.sections.0.heading': '產生案件摘要',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.0.p':
    '我們開發了兩組用於彙整案件的提示詞—一組產生精簡概覽，另一組進行更深入的分析。兩者改編自新加坡律師學院（SAL）公開發布的提示詞，並藉助生成式 AI 反覆打磨（包括請 A&GEL 評論自己的輸出）。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.1.p':
    '依我們的經驗，<strong>詳盡版</strong>案件摘要通常更為出色，在較複雜的判決上尤其明顯。A&GEL 被要求<em>完全</em>依據原判決作答—但請注意，它在區分<em>判決理由（ratio decidendi）</em>與<em>附帶意見（obiter dicta）</em>時可能力有未逮。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.title': '並非萬靈丹',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.body':
    '輸出仍須以一般方式複核與查證—徹底檢查其正確性與完整性。這些提示詞提供的是有效率的起點，而非完成的工作成果。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.3.p':
    '請搭配<strong>引導式摘要</strong>功能（位於應用程式模式下）使用，該功能會在提示詞引導下彙整單一份文件。上傳一份新加坡法院判決，選擇案件摘要（詳盡版）提示詞，並補上您特別在意的重點。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.4.figure.caption':
    '提示詞庫中的案件摘要（精簡版）v1.1 與案件摘要（詳盡版）v1.1。',
  'pages.angelInsider.issues.issue-2.sections.1.kicker': '02 — 撰擬',
  'pages.angelInsider.issues.issue-2.sections.1.heading': '產生初稿',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.0.p':
    '有一組提示詞（以 SAL 公開發布的提示詞為基礎）可針對起訴狀產生<strong>答辯狀</strong>初稿。請複製後依需求調整，並務必補上充分的情境。',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.1.p':
    '另一組提示詞可依案件摘要產生面向客戶的<strong>法律新知</strong>，並以一篇簡短的知識管理範文引導文風、結構與語氣。',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.0.caption':
    '針對起訴狀撰擬答辯狀。',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.1.caption':
    '依參考文章的文風與語氣撰擬 v1.2。',
  'pages.angelInsider.issues.issue-2.sections.2.kicker': '03 — 訴狀',
  'pages.angelInsider.issues.issue-2.sections.2.heading': '分析訴狀',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.0.p':
    '我們準備了數組訴狀分析提示詞。這些提示詞僅經初步測試—歡迎試用、複製改良，並分享給其他使用者。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.0':
    '<strong>分析起訴狀</strong>—執行摘要、時序整理、對照《2021 年法院規則》的充分性評估、主要爭點與初步抗辯，以及立即行動事項與後續步驟。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.1':
    '<strong>分析答辯狀</strong>—萃取抗辯策略，並找出未針對起訴狀中指控具體回應的缺口。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.2':
    '<strong>訴狀充分性</strong>—原本為評估答辯狀而設計；請複製後依您正在審閱的訴狀類型調整。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.0.caption':
    '起訴狀分析與時序整理 v1.5。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.1.caption':
    '分析針對起訴狀的答辯狀 v1.0。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.2.caption':
    '答辯狀訴狀充分性 v1.0。',
  'pages.angelInsider.issues.issue-2.sections.3.kicker': '04 — 審閱模式',
  'pages.angelInsider.issues.issue-2.sections.3.heading': '把審閱當成訴狀追蹤器使用',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.0.p':
    '一眼看盡爭議全程中各方的立場。在<strong>審閱模式</strong>下，把起訴狀中的每一項訴因都當作引導性問題，有系統地檢視並挑戰訴狀與宣誓書中提出的立場。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.1.h': '步驟 1—在對話中產生問題清單',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.2.p':
    '將起訴狀上傳至您的檔案或直接拖入對話，接著執行提示詞以萃取訴因：',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.label': '問題清單產生器',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.text':
    '你是一位擁有 20 年經驗的訴訟律師。請深呼吸，集中注意力。\n\n所上傳的文件是一份起訴狀。你的任務是產生一份要點式摘要。每個要點應涵蓋：(a) 一項訴因；(b) 該訴因所針對的被告；(c) 所依據的事實主張；以及 (d) 所請求的救濟。請把所有子要點寫在同一個要點內—不要使用下一層要點。請萃取文件中的全部內容。若有多名被告，請先完整列出針對第一被告的所有訴因，再處理第二被告，依此類推。\n\n內容要完整但精簡：彙整並援引與每一項訴因直接相關的全部內容。用詞要精確：避免含糊措辭，並沿用文件本身的用語。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.4.h': '步驟 2—在審閱中以該清單比對訴狀',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.5.p':
    '複製產生的清單，切換到<strong>審閱</strong>，點擊<strong>快速提問</strong>。把清單貼到<em>新增問題</em>中，點擊<em>新增 +</em>，附上您的起訴狀，然後按送出。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.6.gallery.0.caption':
    '審閱模式—把問題清單新增為快速提問矩陣。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.title': '不只是訴狀',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.body':
    '審閱能對大量文件提出大量問題，這項能力同樣適合其他文件密集的工作—例如證據開示、文件審閱，以及審閱篇幅龐大的宣誓書。',
  'pages.angelInsider.issues.issue-2.sections.4.kicker': '05 — 功力',
  'pages.angelInsider.issues.issue-2.sections.4.heading': '提示詞技巧：測試與改良',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.0.p':
    '<strong>測試您的提示詞。</strong>將 A&GEL 的輸出與您事先備妥的標準答案比對，以評估提示詞的水準。若兩者高度吻合，代表提示詞已相當成熟；若不吻合，請找出落差並補上情境。',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.1.p':
    '<strong>改良您的提示詞。</strong>使用提示詞庫中的 <em>Improve My Prompt v1.0</em> 工具進一步優化。',
  'pages.angelInsider.issues.issue-2.signoff.line': '複製、調整，並分享行得通的做法。',
  'pages.angelInsider.issues.issue-2.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-scribe.title': '錄音',
  'pages.angelInsider.issues.feature-scribe.subtitle':
    '錄音、轉寫、即時翻譯與編修會議內容—全都在同一處完成。',
  'pages.angelInsider.issues.feature-scribe.glance.0':
    '<strong>即時編修</strong>—在錄音進行的同時即可修改逐字稿；編修過的部分會加底線。',
  'pages.angelInsider.issues.feature-scribe.glance.1':
    '<strong>音訊回放</strong>—點擊逐字稿的任一片段，即可從該處開始播放錄音。',
  'pages.angelInsider.issues.feature-scribe.glance.2':
    '<strong>即時翻譯</strong>—即時翻譯成您選擇的語言。',
  'pages.angelInsider.issues.feature-scribe.glance.3':
    '<strong>附時間戳記的下載檔</strong>—匯出的 Word 逐字稿附有時間戳記，方便快速定位。',
  'pages.angelInsider.issues.feature-scribe.sections.0.kicker': '錄音',
  'pages.angelInsider.issues.feature-scribe.sections.0.heading': '即時編修與音訊回放',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.0.p':
    '<strong>即時編修</strong>—改良後的錄音功能讓您可以直接修改逐字稿；編修過的部分會加底線，方便查閱。<strong>音訊回放</strong>—轉寫內容儲存後，開啟原始逐字稿並點擊任一片段，即可從該處開始播放錄音。',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.0.caption':
    '錄音進行中，同步產生即時逐字稿。',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.1.caption':
    '原始逐字稿—點擊片段即可回放對應音訊。',
  'pages.angelInsider.issues.feature-scribe.sections.1.kicker': '錄音',
  'pages.angelInsider.issues.feature-scribe.sections.1.heading': '即時翻譯，現已登場於錄音功能',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.0.p':
    '用您選擇的語言聽懂通話與會議內容。勾選<strong>即時翻譯</strong>並選定語言—A&GEL 會即時把譯文呈現在原始逐字稿下方。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.1.figure.caption':
    '啟用即時翻譯，並從下拉選單中選擇語言。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.2.p':
    '在 A&GEL 轉寫與翻譯的同時，您可以直接輸入筆記或修改逐字稿—您的編修會以<strong>黃色</strong>顯示，以便與 A&GEL 產生的文字區分。儲存後的逐字稿會同時保留譯文與您的編修。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.0.caption':
    '譯文位於原文下方，可編修的筆記以黃色顯示。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.1.caption':
    '時間戳記沿原始逐字稿左側依序排列。',
  'pages.angelInsider.issues.feature-scribe.sections.2.kicker': '錄音',
  'pages.angelInsider.issues.feature-scribe.sections.2.heading': '可下載的逐字稿，現已支援時間戳記',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.0.p':
    '錄音逐字稿現已在下載的 Word 文件中包含<strong>時間戳記</strong>—這些標記讓您更容易定位到錄音對話或會議中的特定時刻。',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.1.figure.caption':
    '下載的錄音逐字稿，保留了時間戳記與譯文。',
  'pages.angelInsider.issues.feature-scribe.signoff.line': '錄製、複核、回放。',
  'pages.angelInsider.issues.feature-scribe.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-prompt-library.title': '提示詞庫',
  'pages.angelInsider.issues.feature-prompt-library.subtitle':
    '尋找、複製並調整由社群建構的提示詞—再用內建工具加以打磨。',
  'pages.angelInsider.issues.feature-prompt-library.glance.0':
    '瀏覽、複製並調整提示詞庫中由社群建構的提示詞，使其貼合您的具體案件。',
  'pages.angelInsider.issues.feature-prompt-library.glance.1':
    '<strong>測試您的提示詞</strong>—將 A&GEL 的輸出與您事先備妥的標準答案比對。',
  'pages.angelInsider.issues.feature-prompt-library.glance.2':
    '使用提示詞庫中的 <strong>Improve My Prompt v1.0</strong>，進一步優化表現不如預期的提示詞。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.kicker': '功力',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.heading': '提示詞技巧：測試與改良',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.0.p':
    '<strong>測試您的提示詞。</strong>評估提示詞是否有效的好方法，是將 A&GEL 的輸出與您事先備妥的「標準答案」或參考輸出比對。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.1.p':
    '舉例來說，若您正在開發一組用於彙整案件的提示詞，可以拿一份您先前撰寫且熟悉的案件摘要作為基準。執行您的摘要提示詞，並將 A&GEL 的輸出與您先前的成果對照。若輸出與基準高度吻合，代表提示詞已相當成熟；若不吻合，請找出具體落差並據此優化提示詞—例如補上更多情境。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.2.p':
    '<strong>改良您的提示詞。</strong>可以考慮使用提示詞庫中的 <em>Improve My Prompt v1.0</em> 工具，進一步優化您的提示詞。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.3.figure.caption':
    'Improve My Prompt v1.0—優化庫中既有的提示詞。',
  'pages.angelInsider.issues.feature-prompt-library.signoff.line':
    '複製、調整，並分享行得通的做法。',
  'pages.angelInsider.issues.feature-prompt-library.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-prompting.title': '提示詞撰寫',
  'pages.angelInsider.issues.feature-prompting.subtitle':
    '沒有情境的提示詞只是猜測。這套架構能改變這一點。',
  'pages.angelInsider.issues.feature-prompting.glance.0':
    '每一則有效的提示詞都包含四個部分：<strong>角色、任務、情境與格式</strong>。',
  'pages.angelInsider.issues.feature-prompting.glance.1':
    '情境是只有<em>您</em>才能提供的部分—您的專業功力正展現於此。',
  'pages.angelInsider.issues.feature-prompting.glance.2':
    '沒有情境的提示詞形同「提示詞輪盤」—形式上成立，卻難以產出有用的結果。',
  'pages.angelInsider.issues.feature-prompting.glance.3':
    '從提示詞庫複製一則提示詞，再依您案件的具體事實與法律架構加以調整。',
  'pages.angelInsider.issues.feature-prompting.sections.0.kicker': '01 — 架構',
  'pages.angelInsider.issues.feature-prompting.sections.0.heading': '角色、任務、情境、格式',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.0.p':
    '每一則有效的提示詞都包含四個部分。可以把它當成一份檢核清單：',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.1.p':
    '<strong>角色</strong>—告訴 A&GEL 該扮演什麼身分。<em>「你是一位擁有 20 年經驗的訴訟律師。」</em>這會形塑輸出的語氣、深度與具體程度。',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.2.p':
    '<strong>任務</strong>—清楚且具體地說明您希望完成什麼。',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.3.p':
    '<strong>情境</strong>—這是只有您才能提供的部分：具體的法律架構、商業事實，以及案件周邊的情況。沒有情境的提示詞只是猜測—團隊稱之為「提示詞輪盤」。A&GEL 輸出的品質，與您提供的情境品質成正比。',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.4.p':
    '<strong>格式</strong>—明確指出您希望輸出以何種結構呈現。編號清單？表格？條款草稿？還是一段精簡的文字？若不指定，A&GEL 會採用通用格式，未必符合您的工作流程。',
  'pages.angelInsider.issues.feature-prompting.sections.1.kicker': '02 — 情境實務',
  'pages.angelInsider.issues.feature-prompting.sections.1.heading': '情境帶來的差別',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.0.p':
    '請把 A&GEL 當成一位能幹的助理，它需要完整的全貌才能發揮最佳表現。與其問籠統的問題，不如提供只有您知道的具體背景—您的關鍵目標、案件事實，以及「好答案」與「壞答案」各是什麼樣子。',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.1.p':
    '您提供的法律內容（例如適用法律領域的簡要整理）與商業情境（例如交易或爭議的周邊事實）越充分，輸出就越有用。有了這類情境，結果的品質與基本提示相比可能有天壤之別。',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.title': '案件摘要範例',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.body':
    '使用案件摘要提示詞時，請補上您所關心的法律爭點的簡要說明—例如判決理由（ratio decidendi）與附帶意見（obiter dicta）之間的區別。從庫中複製該提示詞，依您的具體關注點加以修改，您會發現輸出比直接套用原提示詞更有針對性。',
  'pages.angelInsider.issues.feature-prompting.sections.2.kicker': '03 — 測試與改良',
  'pages.angelInsider.issues.feature-prompting.sections.2.heading': '先立基準，再行打磨',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.0.p':
    '拿您手邊既有的「標準答案」測試任何提示詞—例如您撰寫過的案件摘要，或先前擬過的條款。執行提示詞，把輸出與您的基準比對。若兩者吻合，代表提示詞已相當成熟；若不吻合，請找出具體落差並相應補上情境。',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.1.p':
    '使用提示詞庫中的 <strong>Improve My Prompt v1.0</strong> 工具，進一步優化任何表現不如預期的提示詞。',
  'pages.angelInsider.issues.feature-prompting.signoff.line':
    '最了解自身情境的人是您—請把它寫進提示詞。',
  'pages.angelInsider.issues.feature-prompting.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-prompting.altCta.label': '了解更多提示詞庫內容 &rarr;',
  'pages.angelInsider.issues.feature-guided-summary.title': '快速資訊與引導式摘要',
  'pages.angelInsider.issues.feature-guided-summary.subtitle':
    '對任一單份文件進行快速且可溯源的解讀—概覽式或定向式皆可。',
  'pages.angelInsider.issues.feature-guided-summary.glance.0':
    '使用<strong>快速資訊</strong>立即取得任一文件的概覽。',
  'pages.angelInsider.issues.feature-guided-summary.glance.1':
    '<strong>引導式摘要</strong>（位於應用程式模式下）讓您掌控關注重點—請搭配庫中的提示詞使用。',
  'pages.angelInsider.issues.feature-guided-summary.glance.2':
    '上傳文件、挑選提示詞，並補上您希望涵蓋的具體重點。',
  'pages.angelInsider.issues.feature-guided-summary.glance.3':
    '現已加速—生成過程中提供<strong>階段性更新與內嵌引註</strong>。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.kicker': '01 — 引導式摘要',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.heading':
    '在提示詞引導下，為任一文件產生可溯源的摘要',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.0.p':
    '提示詞庫收錄了兩組用於彙整文件的提示詞—一組產生精簡概覽，另一組進行更深入的分析。兩者改編自新加坡律師學院（SAL）公開發布的提示詞，並藉助生成式 AI 反覆打磨。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.1.p':
    '依我們的經驗，<strong>詳盡版</strong>摘要工具通常更為出色，在較複雜的文件上尤其明顯。A&GEL 被要求<em>完全</em>依據原文作答—但在判例法中，它區分<em>判決理由（ratio decidendi）</em>與<em>附帶意見（obiter dicta）</em>時可能力有未逮。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.title':
    '並非萬靈丹',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.body':
    '輸出仍須以一般方式複核與查證—徹底檢查其正確性與完整性。這些提示詞提供的是有效率的起點，而非完成的工作成果。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.3.p':
    '使用<strong>引導式摘要</strong>功能（位於應用程式模式下），可針對單一份文件執行任何提示詞。上傳檔案，從庫中挑選提示詞，並補上您特別在意的重點。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.4.figure.caption':
    '提示詞庫中的案件摘要（精簡版）v1.1 與案件摘要（詳盡版）v1.1。',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.kicker': '02 — 速度與更新',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.heading':
    '生成更快，並提供階段性更新',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.0.p':
    '引導式摘要現已在生成過程中提供<strong>附內嵌引註的階段性更新</strong>—您可以看到各段內容逐步產出，並在完整輸出完成前就開始核對引註。',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.1.p':
    '整體輸出速度也已提升。請注意：對於較簡單的文件，摘要可能載入得夠快，因而完全略過階段性更新。',
  'pages.angelInsider.issues.feature-guided-summary.signoff.line':
    '要概覽就用快速資訊；想掌控重點就用引導式摘要。',
  'pages.angelInsider.issues.feature-guided-summary.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-vault.title': '您的保管庫',
  'pages.angelInsider.issues.feature-vault.subtitle':
    '保管庫是您在 A&GEL 上的「大腦」—經營得好，AI 的輸出也會跟著更精準。',
  'pages.angelInsider.issues.feature-vault.glance.0':
    'A&GEL <strong>不會</strong>搜尋網際網路—它只在您的保管庫範圍內運作。',
  'pages.angelInsider.issues.feature-vault.glance.1':
    '<strong>情境就是一切</strong>：精準而有選擇地上傳，才能得到精準可靠的輸出。',
  'pages.angelInsider.issues.feature-vault.glance.2':
    '您的資料夾結構本身就是中繼資料—它會把 AI 導向正確的觀點。',
  'pages.angelInsider.issues.feature-vault.glance.3':
    '使用<strong>引用檔案權重</strong>與<strong>工作階段檔案權重</strong>，微調 A&GEL 的優先順序。',
  'pages.angelInsider.issues.feature-vault.sections.0.kicker': '01 — 大腦',
  'pages.angelInsider.issues.feature-vault.sections.0.heading': '保管庫是您在 A&GEL 上的「大腦」',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.0.p':
    '保管庫的設計初衷，是作為 A&GEL 最主要的情境來源，把 AI 依機率產生的輸出錨定在您可信、經過整理的知識庫之上。',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.1.p':
    '<strong>A&GEL 會上網搜尋答案嗎？</strong>不會。A&GEL 嚴格在您保管庫的範圍內運作，只依據您上傳並整理過的文件。這是刻意的設計選擇，服務於三個目的：確保輸出的正確性、維護安全性，以及保全您專屬知識庫的完整性。',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.2.p':
    'A&GEL 不會從網路抓取未經查證的資訊，而是嚴格以您的保管庫作為唯一的事實來源。若您的保管庫整理得當，A&GEL 的各項功能便會立基於您所認可的先例、您查證過的事實，以及您贊同的策略。當 A&GEL 回答問題時，它並不是憑一般常識猜測—而是在綜整您那些具體而具權威性的資料中的洞見。',
  'pages.angelInsider.issues.feature-vault.sections.1.kicker': '02 — 上傳',
  'pages.angelInsider.issues.feature-vault.sections.1.heading': '上傳什麼，以及怎麼上傳',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.0.p':
    '<strong>可以上傳什麼？</strong>任何 Word 文件、PDF 或電子郵件。其他檔案格式正在開發中。',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.1.p':
    '<strong>怎麼上傳？</strong>把單一檔案或整個資料夾拖放到檔案介面上，或點擊上傳按鈕。',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.2.figure.caption':
    '直接把檔案或資料夾拖放到檔案介面上。',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.title': '垃圾進，垃圾出',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.body':
    '請別把 A&GEL 當成有求必應的神諭，而要把它看作一位不知疲倦的同事，他讀過您上傳的一切。若您遞給這位同事一張堆滿無關檔案的凌亂辦公桌，他的工作多半會一頭霧水；若您只遞給他一份切題的先例，他的工作就會變得犀利。這正是使用 A&GEL 的核心真理：<strong>情境就是一切。</strong>',
  'pages.angelInsider.issues.feature-vault.sections.2.kicker': '03 — 結構',
  'pages.angelInsider.issues.feature-vault.sections.2.heading': '請建立一定的資料夾結構',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.0.p':
    '資料夾結構不只是為了整齊—它是引導 AI 的中繼資料。把檔案整理進合乎邏輯的子資料夾，例如把「賣方」與「客戶」的先例分開，能協助 A&GEL 擷取到正確的觀點。',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.1.figure.caption':
    '深入子資料夾—把「被授權人」與「授權人」的先例分開，可保持情境清晰。',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.2.p':
    '<strong>避免落入「全部上傳」的陷阱。</strong>把整個資料庫一股腦倒進一個資料夾、讓 AI 自己釐清，聽起來很省事。請別這麼做。A&GEL 採用檢索增強生成（RAG），也就是說它會從您上傳的檔案中擷取答案。生成式 AI 並不「理解」事實—它預測的是機率。當您餵給它不相關的雜訊時，就會稀釋有效訊號。結果就是：輸出的正確性、精確度與可靠性都會下降。請務必手動挑選與您提示詞相關的特定文件或資料夾。',
  'pages.angelInsider.issues.feature-vault.sections.3.kicker': '04 — 微調',
  'pages.angelInsider.issues.feature-vault.sections.3.heading': '微調訊號',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.0.p':
    'A&GEL 提供了控制此流程的旋鈕。使用<strong>引用檔案權重</strong>，可讓 AI 優先考量您所援引的特定文件；使用<strong>工作階段檔案權重</strong>，則可提高僅為該次對話上傳之檔案的比重。',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.1.p':
    '最後請記得：A&GEL 是起點—是用來集思廣益的夥伴，或用來打磨初步想法的協作空間，而不是終點線。請務必對照回應中所連結的來源文件查證輸出。',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.title': '歸根究柢',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.body':
    '請把保管庫當成一座精心編排的圖書館，而不是垃圾掩埋場。清楚自己的文件放在哪裡，對情境有所取捨，A&GEL 便會從一個吵雜的聊天機器人，轉變為一位高精準度的助理。',
  'pages.angelInsider.issues.feature-vault.signoff.line': '經營好您的保管庫，掌控好您的情境。',
  'pages.angelInsider.issues.feature-vault.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-vault.cta.label': '返回基礎入門 →',
  'pages.angelInsider.issues.issue-3.title': '全新時間軸與多步驟提示詞應用程式',
  'pages.angelInsider.issues.issue-3.subtitle':
    '.msg 上傳、更聰明的錄音功能、結構化的多步驟提示，以及大幅改版的時間軸。',
  'pages.angelInsider.issues.issue-3.date': '2026 年 3 月 18 日',
  'pages.angelInsider.issues.issue-3.glance.0':
    '<strong>電子郵件檔案（.msg）</strong>現已可上傳並完整讀取—包括其中的附件。',
  'pages.angelInsider.issues.issue-3.glance.1':
    '<strong>錄音功能</strong>現已支援即時編修、音訊回放，以及每分鐘自動儲存。',
  'pages.angelInsider.issues.issue-3.glance.2':
    '全新<strong>多步驟提示詞</strong>模式，可把複雜的法律工作流程拆解為具針對性的步驟。',
  'pages.angelInsider.issues.issue-3.glance.3':
    '<strong>時間軸</strong>全面改版，可合併多份文件中的時序。',
  'pages.angelInsider.issues.issue-3.sections.0.kicker': '01 — 檔案',
  'pages.angelInsider.issues.issue-3.sections.0.heading': '上傳電子郵件檔案（.msg）',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.0.p':
    'A&GEL 使用者現在可以把完整的 <strong>.msg</strong> 電子郵件檔案上傳至檔案中，供對話或任何專門模式使用。A&GEL 會讀取全部內容—包括附件—但帶有<em>僅限內部</em>敏感度標籤或受密碼保護的附件除外。',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.1.p':
    '上傳後，您可以請 A&GEL 彙整這封郵件、彙整隨附的文件，或針對它執行提示詞庫中的任何提示詞。',
  'pages.angelInsider.issues.issue-3.sections.1.kicker': '02 — 錄音',
  'pages.angelInsider.issues.issue-3.sections.1.heading': '錄音：即時編修與音訊回放',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.0.p':
    '<strong>即時編修</strong>—改良後的錄音功能讓您可以直接修改逐字稿；編修過的部分會加底線，方便查閱。<strong>音訊回放</strong>—轉寫內容儲存後，開啟原始逐字稿並點擊任一片段，即可從該處開始播放錄音。',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.0.caption':
    '錄音進行中，同步產生即時逐字稿。',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.1.caption':
    '原始逐字稿—點擊片段即可回放對應音訊。',
  'pages.angelInsider.issues.issue-3.sections.2.kicker': '03 — 全新模式',
  'pages.angelInsider.issues.issue-3.sections.2.heading': '多步驟提示詞',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.0.p':
    '位於<strong>專門應用程式</strong>之下。單次提示詞對簡單問題很有效率，但複雜的法律任務更適合採用結構化、逐步推進的做法。多步驟提示詞讓您把問題拆解為一連串具針對性的互動—這是我們處理中高複雜度文件工作時最愛的模式。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.1.h': '把工作流程拆解為合乎邏輯的階段',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.n': '公司法務 · 步驟 1',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.text':
    '彙整各方各自負有哪些義務。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.n': '步驟 2',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.text':
    '在上述彙整的基礎上，標出任何單方有利或不尋常的條款。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.n': '步驟 3',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.text':
    '針對已標出的條款，若我代表[某方]，請以修訂標記列出我應爭取的五項主要修改。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.n': '訴訟 · 步驟 1',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.text':
    '根據[所附]起訴狀，擬定第一組詰問書。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.n': '步驟 2',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.text':
    '在完成步驟 1 的基礎上，擬定相對應的文件提出請求。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.n': '步驟 3',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.text':
    '作為最後一步，找出最可能持有相關文件的五位主要保管人，並說明理由。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.title': '只有一則提示詞？照樣用它',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.body':
    '即使只有一個步驟，這個應用程式也非常適合處理需要針對文件執行的複雜單則提示詞—往往比對話模式更好。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.5.figure.caption':
    '多步驟提示詞的輸出—點擊引註會開啟內嵌文件檢視器並標示重點。',
  'pages.angelInsider.issues.issue-3.sections.3.kicker': '04 — 時間軸',
  'pages.angelInsider.issues.issue-3.sections.3.heading': '大幅改版的時間軸',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.0.p':
    '<strong>跨文件合併時間軸。</strong>更新後的時間軸會從每一份選定文件中萃取時序，並合併成一條—當您手上有多份篇幅龐大的宣誓書、訴狀或書狀，各自都有自己的時間軸時，這項功能格外寶貴。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.0.caption':
    '跨五個檔案合併而成的起訴狀與答辯狀時間軸。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.1.caption':
    '深入檢視單一文件的時間軸，並附上來源引註。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.2.p':
    '<strong>檢視來源。</strong>點擊任一事件末端的引註，即可開啟來源文件，並標示出處所在的那一行。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.3.h': '智慧時間軸，貼合您的案件',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.4.p':
    '選定文件後，點擊<strong>擴充提示詞</strong>，即可讓萃取聚焦於您關注的主題。<em>Basic Litigation（共用）</em>組態會萃取事件描述、來源文件、實體／個人以及佐證段落—您也可以自行新增欄位。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.title': '訊息紀錄同樣適用',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.body':
    '把時間軸指向聊天紀錄或訊息截圖（WhatsApp、WeChat），即可建立時序。',
  'pages.angelInsider.issues.issue-3.signoff.line': '步伐小一點，時序清晰一些。',
  'pages.angelInsider.issues.issue-3.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-dispute.title': '爭議解決',
  'pages.angelInsider.issues.feature-dispute.subtitle':
    '案件摘要、起訴狀分析、答辯狀撰擬與訴狀追蹤—全都在 A&GEL 內完成。',
  'pages.angelInsider.issues.feature-dispute.glance.0':
    '<strong>案件摘要</strong>—面對複雜判決時，詳盡版通常優於精簡版。',
  'pages.angelInsider.issues.feature-dispute.glance.1':
    '<strong>起訴狀分析</strong>—上傳起訴狀並直接執行分析提示詞。',
  'pages.angelInsider.issues.feature-dispute.glance.2':
    '<strong>答辯狀撰擬</strong>—依起訴狀產生答辯狀初稿。',
  'pages.angelInsider.issues.feature-dispute.glance.3':
    '<strong>訴狀追蹤器</strong>—審閱模式可在完整文件集中，把每一項訴因與各方立場逐一對應。',
  'pages.angelInsider.issues.feature-dispute.sections.0.kicker': '01 — 案件摘要',
  'pages.angelInsider.issues.feature-dispute.sections.0.heading': '彙整判決與訴狀',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.0.p':
    '提示詞庫收錄了兩組案件摘要提示詞—精簡版與詳盡版。依我們的經驗，<strong>詳盡版</strong>通常更為出色，面對複雜判決時尤其明顯。A&GEL 被要求完全依據來源文件作答。',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.1.figure.caption':
    '提示詞庫中的案件摘要（精簡版）v1.1 與案件摘要（詳盡版）v1.1。',
  'pages.angelInsider.issues.feature-dispute.sections.1.kicker': '02 — 起訴狀與答辯狀',
  'pages.angelInsider.issues.feature-dispute.sections.1.heading': '起訴狀分析與答辯狀撰擬',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.0.p':
    '在案件初期評估階段，可使用<strong>起訴狀分析與時序整理</strong>提示詞。上傳起訴狀並執行該提示詞—A&GEL 會萃取關鍵事實、訴因以及一條時序。',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.1.p':
    '若要撰擬第一份答辯狀，請使用庫中的<strong>針對起訴狀撰擬答辯狀</strong>提示詞。複製後，依您案件的情況調整情境。',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.title': '詳盡版勝過精簡版',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.body':
    '面對複雜判決或篇幅冗長的起訴狀，詳盡版摘要工具的輸出在正確性與完整性上始終更為出色。',
  'pages.angelInsider.issues.feature-dispute.sections.2.kicker': '03 — 訴狀追蹤器',
  'pages.angelInsider.issues.feature-dispute.sections.2.heading': '把審閱模式當成訴狀追蹤器',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.0.p':
    '審閱模式可同時針對多份文件執行一份問題清單。在爭議解決情境中，載入起訴狀、答辯狀與答辯後續書狀，逐一訴因設定問題，A&GEL 便會在一張表格中呈現各方立場的對照。',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.1.figure.caption':
    'Lim Group 案：審閱模式跨 5 個檔案追蹤詐欺與不當行為主張。',
  'pages.angelInsider.issues.feature-dispute.signoff.line': '案件評估更快，準備更充分。',
  'pages.angelInsider.issues.feature-dispute.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-sidebyside.title': '並排比較與差異比對',
  'pages.angelInsider.issues.feature-sidebyside.subtitle':
    '顆粒度最細的審閱模式—逐條款進行，並可完整驗證來源段落。',
  'pages.angelInsider.issues.feature-sidebyside.glance.0':
    '<strong>並排比較</strong>逐條款展開，每一項發現都可完整驗證來源段落。',
  'pages.angelInsider.issues.feature-sidebyside.glance.1':
    '<strong>差異比對</strong>可針對追蹤修訂或文件修正產生第一輪法律審閱意見。',
  'pages.angelInsider.issues.feature-sidebyside.glance.2':
    '每一項發現都能回溯到確切的來源條款—不必在文件中翻找。',
  'pages.angelInsider.issues.feature-sidebyside.glance.3':
    '<strong>迷你對話視窗</strong>現已可移動、可調整大小—把它拖到不礙事的位置即可。',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.kicker': '01 — 並排比較',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.heading': '逐條款分析並可溯源驗證',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.0.p':
    '並排比較是 A&GEL 顆粒度最細的審閱模式。它會逐條款梳理整份文件，並為每一項發現呈現確切的來源段落—讓您可以直接對照原文驗證輸出。',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.1.figure.caption':
    '對一份股份買賣協議（SPA）的並排比較分析—每項發現都可回溯至來源條款。',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.2.figure.caption':
    '說明面板—A&GEL 的推理過程與來源並排內嵌顯示。',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.kicker': '02 — 差異比對',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.heading': '追蹤修訂的第一輪審閱',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.0.p':
    '<strong>差異比對</strong>可針對追蹤修訂或文件修正產生第一輪法律審閱意見。上傳修正後的文件，A&GEL 便會就變更內容及其影響產出結構化分析。',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.title':
    '這是起點，不是成品',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.body':
    '並排比較與差異比對的輸出是有效率的起點—定稿前請務必對照原文查證。',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.kicker': '03 — 迷你對話',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.heading': '可移動的迷你對話介面',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.blocks.0.p':
    '審閱、差異比對與並排比較都配備<strong>迷你對話視窗</strong>，讓您能同時針對文件與 A&GEL 的輸出提問。該視窗現已<strong>可移動、可調整大小</strong>—把它拖到螢幕上任何位置，避免遮擋您正在審閱的內容。',
  'pages.angelInsider.issues.feature-sidebyside.signoff.line': '逐條款推進，來源可查證。',
  'pages.angelInsider.issues.feature-sidebyside.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-multistep.title': '多步驟提示詞',
  'pages.angelInsider.issues.feature-multistep.subtitle':
    '把複雜的法律任務拆解為連續步驟—每一步都以前一步為基礎。',
  'pages.angelInsider.issues.feature-multistep.glance.0': '位於<strong>專門應用程式</strong>之下。',
  'pages.angelInsider.issues.feature-multistep.glance.1':
    '每一步都建立在前一步的輸出之上—非常適合複雜的工作流程。',
  'pages.angelInsider.issues.feature-multistep.glance.2':
    '既適用於多步驟工作流程，<em>也</em>適用於針對單一文件的複雜單則提示詞。',
  'pages.angelInsider.issues.feature-multistep.glance.3':
    '輸出附有內嵌來源引註—點擊即可開啟來源並標示重點。',
  'pages.angelInsider.issues.feature-multistep.sections.0.kicker': '01 — 開始上手',
  'pages.angelInsider.issues.feature-multistep.sections.0.heading': '面向複雜法律工作的結構化模式',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.0.p':
    '位於<strong>專門應用程式</strong>之下。多步驟提示詞讓您把法律問題拆解為一連串具針對性的步驟—每一步都以前一步為基礎。它既適合多步驟工作流程，也適合那些需要文件層級精確度的複雜單則提示詞。',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.1.figure.caption':
    '專門應用程式格狀選單中的多步驟提示詞。',
  'pages.angelInsider.issues.feature-multistep.sections.1.kicker': '02 — 範例',
  'pages.angelInsider.issues.feature-multistep.sections.1.heading':
    '把工作流程拆解為合乎邏輯的階段',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.n': '公司法務 · 步驟 1',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.text':
    '彙整各方各自負有哪些義務。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.n': '步驟 2',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.text':
    '在上述彙整的基礎上，標出任何單方有利或不尋常的條款。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.n': '步驟 3',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.text':
    '針對已標出的條款，若我代表[某方]，請以修訂標記列出我應爭取的五項主要修改。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.n': '訴訟 · 步驟 1',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.text':
    '根據[所附]起訴狀，擬定第一組詰問書。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.n': '步驟 2',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.text':
    '在完成步驟 1 的基礎上，擬定相對應的文件提出請求。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.n': '步驟 3',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.text':
    '找出最可能持有相關文件的五位主要保管人，並說明理由。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.title':
    '只有一則提示詞？照樣用它',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.body':
    '即使只有一個步驟，這個應用程式也非常適合針對文件執行的複雜提示詞—往往比對話模式更好。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.3.figure.caption':
    '多步驟提示詞的輸出—點擊引註會開啟內嵌文件檢視器並標示重點。',
  'pages.angelInsider.issues.feature-multistep.sections.2.kicker': '03 — 實作範例',
  'pages.angelInsider.issues.feature-multistep.sections.2.heading': '跨兩份文件撰寫報告',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.0.p':
    '這是一套三步驟工作流程：從兩份文件中萃取關注事項，再合併成一份附執行摘要的報告—若想靠單則對話提示詞穩定完成，難度過高。',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.title': '步驟 1—萃取',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.body':
    '<strong>輸入情境：</strong>[插入文件 1 與文件 2 的內文]<br><strong>提示詞：</strong>「閱讀所提供的文字。萃取一份完整的條列清單，列出兩份文件中提及的所有關注事項、問題或風險。」<br><em>輸出：一份清楚、已整合的關注事項清單。</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.title':
    '步驟 2—撰寫完整報告',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.body':
    '<strong>輸入情境：</strong>[步驟 1 的輸出]<br><strong>提示詞：</strong>「運用所提供的關注事項清單，撰寫一份詳盡的正式報告。把相似的關注事項歸入相應標題之下。此階段請勿加入引言或執行摘要。」<br><em>輸出：一份完整且具結構的報告。</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.title':
    '步驟 3—執行摘要與最終彙整',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.body':
    '<strong>輸入情境：</strong>[步驟 2 的輸出]<br><strong>提示詞：</strong>「閱讀所提供的報告。首先，撰寫一段精簡的執行摘要。接著輸出該執行摘要，加上一條視覺分隔線，並在其下方原樣輸出完整報告，以形成一份合併後的單一文件。」<br><em>輸出：最終的合併文件。</em>',
  'pages.angelInsider.issues.feature-multistep.signoff.line': '步伐小一點，輸出精準一些。',
  'pages.angelInsider.issues.feature-multistep.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-timeline.title': '時間軸',
  'pages.angelInsider.issues.feature-timeline.subtitle':
    '將最多 100 份文件的時序合併為一條經來源驗證的時間軸。',
  'pages.angelInsider.issues.feature-timeline.glance.0':
    '把<strong>最多 100 份文件</strong>的時序合併為一條時間軸。',
  'pages.angelInsider.issues.feature-timeline.glance.1':
    '<strong>可點擊的內嵌引註</strong>—點擊任一引註即可開啟來源並標示相關段落。',
  'pages.angelInsider.issues.feature-timeline.glance.2':
    '<strong>智慧時間軸</strong>讓您萃取自訂欄位：實體、佐證段落等等。',
  'pages.angelInsider.issues.feature-timeline.glance.3':
    '聊天紀錄與訊息截圖（WhatsApp、WeChat）同樣適用。',
  'pages.angelInsider.issues.feature-timeline.sections.0.kicker': '01 — 合併時間軸',
  'pages.angelInsider.issues.feature-timeline.sections.0.heading': '跨多份文件的時序',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.0.p':
    '更新後的時間軸會從每一份選定文件中萃取時序，並合併成一條—當您手上有多份篇幅龐大的宣誓書、訴狀或書狀，各自都有自己的時間軸時，這項功能格外寶貴。',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.0.caption':
    '跨五個檔案合併而成的起訴狀與答辯狀時間軸。',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.1.caption':
    '深入檢視單一事件—來源文件、實體與佐證段落一併呈現。',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.2.p':
    '<strong>檢視來源。</strong>點擊任一事件末端的內嵌引註，即可開啟來源文件，並標示出處所在的那一行。',
  'pages.angelInsider.issues.feature-timeline.sections.1.kicker': '02 — 智慧時間軸',
  'pages.angelInsider.issues.feature-timeline.sections.1.heading': '為您的案件萃取自訂欄位',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.0.p':
    '點擊<strong>擴充提示詞</strong>，即可讓萃取聚焦於您關注的主題。<em>Basic Litigation（共用）</em>組態會萃取事件描述、來源文件、實體／個人以及佐證段落—您也可以自行新增欄位。',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.1.figure.caption':
    '智慧時間軸：在擴充提示詞下新增自訂萃取欄位。',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.title':
    '訊息紀錄同樣適用',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.body':
    '把時間軸指向聊天紀錄或訊息截圖（WhatsApp、WeChat），即可建立時序。',
  'pages.angelInsider.issues.feature-timeline.signoff.line': '一條時間軸，涵蓋每份文件。',
  'pages.angelInsider.issues.feature-timeline.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-using-files.title': '在 A&GEL 中使用您的檔案',
  'pages.angelInsider.issues.feature-using-files.subtitle':
    'A&GEL 原生支援 Word 文件、PDF 與電子郵件（未來還會加入更多格式）。不過，某些檔案可能因缺少文字圖層、敏感度標籤設定有誤或格式問題而無法上傳，而每種情況都有簡單的解法。',
  'pages.angelInsider.issues.feature-using-files.intro':
    '您可能會遇到某些檔案無法順利上傳到 A&GEL 的情況。本指南整理了最常見的原因—從沒有文字圖層的掃描件，到文件敏感度標籤—以及相應的解決方式。',
  'pages.angelInsider.issues.feature-using-files.glance.0':
    'A&GEL 讀取的是 PDF 中的<strong>文字圖層</strong>—掃描的紙本文件往往沒有文字圖層。',
  'pages.angelInsider.issues.feature-using-files.glance.1':
    '這在較舊的檔案，以及未經 OCR 處理的掃描件中很常見。',
  'pages.angelInsider.issues.feature-using-files.glance.2':
    '解法：先把 PDF 轉為可搜尋格式，再重新上傳至 A&GEL。',
  'pages.angelInsider.issues.feature-using-files.glance.3':
    '需要一次轉換大量 PDF？A&GEL 開發團隊可以協助。',
  'pages.angelInsider.issues.feature-using-files.glance.4':
    '內部文件必須先重新標示為<strong>外部</strong>再上傳，否則 A&GEL 會拒絕。',
  'pages.angelInsider.issues.feature-using-files.glance.5':
    '較舊的 Word 文件（1997–2004 年、OOXML 之前的 .doc）已獲支援—無須轉換。',
  'pages.angelInsider.issues.feature-using-files.sections.0.kicker': '01 — 缺少文字圖層',
  'pages.angelInsider.issues.feature-using-files.sections.0.heading': '掃描文件的相關問題',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.0.p':
    'A&GEL 透過萃取 PDF 中內嵌的文字圖層來讀取文件。當文件沒有文字圖層時（例如掃描的紙本），A&GEL 只會看到頁面的影像，因而無法處理。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.1.p':
    '大多數掃描文件—尤其是用影印機數位化的檔案—都會存成純影像 PDF。這在較舊的檔案，以及以影像形式掃描（且未做 OCR）的文件中很常見。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.2.p':
    '上傳之前，請先用支援 OCR（光學字元辨識）的 PDF 閱讀器開啟檔案—例如 Kofax—以確保能順利處理。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.n': '步驟 1',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.text':
    '用具備 OCR 功能的 PDF 閱讀器（例如 Kofax）開啟您的掃描版 PDF。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.n': '步驟 2',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.text':
    '執行 OCR 讓檔案可被搜尋—在 Kofax 中，對應的是<strong>「Make Searchable」</strong>或<strong>「Searchable PDF」</strong>功能。若有多個檔案要轉換，請找批次或多檔 OCR 選項（在 Kofax 中位於 Advanced Processing 之下），不要一個一個轉。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.n': '步驟 3',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.text':
    '儲存轉換後的檔案，然後上傳至 A&GEL。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.4.p':
    '轉換完成後，檔案便會含有可搜尋的文字圖層，A&GEL 即可照常處理。此外，您也可以在掃描當下就直接產生可搜尋的 PDF，而不必事後轉換—許多印表機與掃描器都能在掃描過程中直接輸出可搜尋 PDF。請在您自己的裝置上尋找對應的「Searchable PDF」或 OCR 選項，各型號的選單名稱與步驟可能有所不同。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.5.figure.caption':
    '範例：在這台掃描器的「掃描並傳送」畫面中，把檔案格式選為 PDF 並啟用 OCR（優先速度或優先精確度），即可產生附文字圖層的可搜尋 PDF。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.6.p':
    '需要一次對大量 PDF 做 OCR？請聯絡 A&GEL 開發團隊—他們可以協助您完成批次轉換。',
  'pages.angelInsider.issues.feature-using-files.sections.1.kicker': '02 — 敏感度標籤',
  'pages.angelInsider.issues.feature-using-files.sections.1.heading': '敏感度標籤的相關問題',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.0.p':
    '每份文件都帶有敏感度標籤，該標籤在 Word 或 Outlook 中儲存時設定，A&GEL 會在接受上傳前檢查它。',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.1.p':
    'A&GEL 會拒絕帶有「內部」敏感度標籤的檔案—請先把文件重新標示為「外部」並儲存，然後再上傳。',
  'pages.angelInsider.issues.feature-using-files.sections.2.kicker': '03 — 較舊的 Word 檔案',
  'pages.angelInsider.issues.feature-using-files.sections.2.heading': '支援較舊的 Word 文件',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.0.p':
    '較舊的 Word 文件同樣受支援。以下格式在上傳前都無須轉換或另存：',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.left.label': 'PDF',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.topMiddle.label':
    'MS Word 目前版本（.docx）',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.bottomMiddle.label':
    'MS Word 1997–2004（.doc）',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.right.label':
    '電子郵件（.msg）',
  'pages.angelInsider.issues.feature-using-files.signoff.line':
    '用 Kofax 或印表機的 OCR 設定把掃描件轉成可搜尋格式，上傳前把內部文件另存為「外部」，並請注意：較舊與目前的 Word 格式都無須轉換即可使用。',
  'pages.angelInsider.issues.feature-using-files.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-work-studio.title': 'Workstudio',
  'pages.angelInsider.issues.feature-work-studio.subtitle':
    '把團隊的標準立場固化為一套標準化審閱流程—輸出附追蹤修訂的 Word 文件。',
  'pages.angelInsider.issues.feature-work-studio.glance.0':
    '把團隊的談判立場一次建入 Workstudio—之後每一份合約都能重複使用。',
  'pages.angelInsider.issues.feature-work-studio.glance.1':
    'A&GEL 會套用該 Workstudio，並回傳一份<strong>附追蹤修訂的 Word 文件</strong>。',
  'pages.angelInsider.issues.feature-work-studio.glance.2':
    '以已接受／已拒絕／待處理三種狀態審閱各處修改。',
  'pages.angelInsider.issues.feature-work-studio.glance.3':
    '關於如何建立與運用 Workstudio 的更多細節，將於下一期 A&GEL Insider 呈現。',
  'pages.angelInsider.issues.feature-work-studio.sections.0.kicker': '01 — Workstudio',
  'pages.angelInsider.issues.feature-work-studio.sections.0.heading': '讓您的標準立場自動落實',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.0.p':
    'Workstudio 讓您把團隊的談判立場與標準立場固化為一套可重複使用的審閱範本。建好之後，上傳任何合約，A&GEL 都會套用該 Workstudio—回傳一份以追蹤修訂形式提出修改建議的 Word 文件，可直接進入審閱與修改流程。',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.1.figure.caption':
    'Workstudio 實戰—以已接受／已拒絕／待處理狀態審閱各處修改與註解。',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.title':
    '完整的 Workstudio 指南即將推出',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.body':
    '下一期 A&GEL Insider 將介紹如何從零建立 Workstudio，以及如何把它運用在團隊的實際案件上。',
  'pages.angelInsider.issues.feature-work-studio.signoff.line': '您的立場，自動落實。',
  'pages.angelInsider.issues.feature-work-studio.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-deepresearch.title': '深度研究',
  'pages.angelInsider.issues.feature-deepresearch.subtitle':
    '在結構化研究提示詞引導下進行跨文件分析—每項發現都可回溯至其來源段落。',
  'pages.angelInsider.issues.feature-deepresearch.glance.0':
    '針對您選定的整套文件執行結構化研究提示詞。',
  'pages.angelInsider.issues.feature-deepresearch.glance.1':
    '每項發現都附有<strong>可點擊的內嵌引註</strong>—開啟來源並標示相關段落。',
  'pages.angelInsider.issues.feature-deepresearch.glance.2':
    '位於<strong>專門應用程式</strong>之下。',
  'pages.angelInsider.issues.feature-deepresearch.glance.3':
    '搭配精心整理的一手資料保管庫使用，可獲得最高精確度。',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.kicker': '01 — 功能簡介',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.heading':
    '在結構化提示詞引導下的跨文件分析',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.0.p':
    '深度研究會針對您選定的文件執行一則結構化研究提示詞，並回傳詳盡且可溯源的分析。它專為需要跨多份文件綜整資訊的任務而設計—例如判例法分析、市場研究、法規梳理—而不是用來盤問單一檔案。',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.1.figure.caption':
    '深度研究的輸出—每項發現都透過可點擊的內嵌引註回溯至其來源文件。',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.kicker': '02 — 內嵌引註',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.heading': '對照來源驗證每項發現',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.0.p':
    '深度研究輸出中的每項發現都附有<strong>編號的內嵌引註</strong>。點擊任一引註，即可開啟來源文件並標示出處段落—全程不必離開頁面。',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.title':
    '有選擇地設定情境',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.body':
    '請把情境限縮為與您研究問題最相關的文件。範圍太廣會稀釋有效訊號—深度研究在經過整理、目標明確的上傳內容上表現最佳。',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.kicker': '03 — 何時使用',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.heading': '最適合綜整歸納類任務',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.blocks.0.p':
    '當您需要跨多個來源綜整歸納時，就該用深度研究—例如比對多份宣誓書中的立場、就特定爭點梳理判例法，或跨法域整理法規要求。若只針對單一文件，則可考慮改用引導式摘要或範圍摘要。',
  'pages.angelInsider.issues.feature-deepresearch.signoff.line': '每項發現，來源可查證。',
  'pages.angelInsider.issues.feature-deepresearch.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-scopesummary.title': '範圍摘要',
  'pages.angelInsider.issues.feature-scopesummary.subtitle':
    '依您設定的重點範圍產生結構化摘要—每個擷取要點都附有可點擊的內嵌引註。',
  'pages.angelInsider.issues.feature-scopesummary.glance.0':
    '產生聚焦於您所設定範圍的摘要—而非整份文件的通篇摘要。',
  'pages.angelInsider.issues.feature-scopesummary.glance.1':
    '每個擷取要點都附有<strong>可點擊的內嵌引註</strong>，方便對照來源驗證。',
  'pages.angelInsider.issues.feature-scopesummary.glance.2':
    '位於<strong>專門應用程式</strong>之下。',
  'pages.angelInsider.issues.feature-scopesummary.glance.3':
    '範圍界定得越收斂，擷取結果就越有針對性、越能付諸行動。',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.kicker': '01 — 功能簡介',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.heading': '在設定範圍內的聚焦式擷取',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.0.p':
    '範圍摘要讓您界定希望 A&GEL 聚焦的領域—義務、風險分配、終止權、智慧財產權條款—並產生僅限於這些範圍的結構化摘要。相較於整份文件的通篇摘要，輸出更有針對性，也與您的審閱優先順序直接對應。',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.title':
    '把範圍界定清楚',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.body':
    '範圍越收斂，輸出就越精確。範圍太廣時，輸出會與整份文件摘要相差無幾。目標明確的範圍—例如「資料保護與安全義務」—則能產出精簡且可付諸行動的擷取結果。',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.kicker': '02 — 內嵌引註',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.heading': '每個要點，來源可查證',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.blocks.0.p':
    '範圍摘要中的每個擷取要點都附有<strong>可點擊的內嵌引註</strong>—點擊即可開啟來源文件，並標示出處所在的條款或段落。不必切換分頁；所有查證都在同一頁面完成。',
  'pages.angelInsider.issues.feature-scopesummary.signoff.line': '界定範圍，標明來源，可供查證。',
  'pages.angelInsider.issues.feature-scopesummary.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-review.title': '審閱',
  'pages.angelInsider.issues.feature-review.subtitle':
    '一次針對多份文件提出多個問題—結果以表格呈現，並附上內嵌引註。',
  'pages.angelInsider.issues.feature-review.glance.0':
    '<strong>同時針對多份文件執行一份問題清單</strong>—結果彙整於一張表格。',
  'pages.angelInsider.issues.feature-review.glance.1':
    '點擊任一儲存格即可展開<strong>說明面板</strong>，其中附有指向來源條款的內嵌引註。',
  'pages.angelInsider.issues.feature-review.glance.2':
    '使用<strong>迷你對話</strong>，不必離開審閱頁面即可繼續追問。',
  'pages.angelInsider.issues.feature-review.glance.3': '位於<strong>專門應用程式</strong>之下。',
  'pages.angelInsider.issues.feature-review.sections.0.kicker': '01 — 功能簡介',
  'pages.angelInsider.issues.feature-review.sections.0.heading':
    '在一張表格中完成多文件、多問題審閱',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.0.p':
    '審閱會同時針對多份文件執行一份問題清單，並把結果彙整成表格—每個問題一列，每份文件一欄。這種呈現方式非常適合合約比對、跨文件集的實地查核，或梳理各方在訴狀中的立場。',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.1.figure.caption':
    'AI SaaS 基準審閱—在一張表格中依既定問題集審閱 20 個檔案。',
  'pages.angelInsider.issues.feature-review.sections.1.kicker': '02 — 說明面板',
  'pages.angelInsider.issues.feature-review.sections.1.heading': '每項發現都有可溯源的說明',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.0.p':
    '點擊任一儲存格即可展開<strong>說明面板</strong>。每項發現都會被拆解，並附有結構化的內嵌引註—點擊任一引註即可直接開啟來源條款。',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.1.figure.caption':
    '審閱中的說明面板—每項發現都連結至其來源條款。',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.title':
    '問題清單編一次，重複使用',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.body':
    '一份結構良好的問題清單，會成為該類文件的可重複使用範本。存起來，下次面對同類合約時直接套用即可。',
  'pages.angelInsider.issues.feature-review.sections.2.kicker': '03 — 迷你對話',
  'pages.angelInsider.issues.feature-review.sections.2.heading': '不必離開頁面即可追問',
  'pages.angelInsider.issues.feature-review.sections.2.blocks.0.p':
    '<strong>迷你對話視窗</strong>讓您能同時針對文件與審閱結果提出後續問題—不必跳轉頁面。該視窗可移動、可調整大小，因此不會擋住您的工作區域。',
  'pages.angelInsider.issues.feature-review.signoff.line': '每份文件，每個問題，彙於一表。',
  'pages.angelInsider.issues.feature-review.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-msg.title': '.msg 郵件上傳',
  'pages.angelInsider.issues.feature-msg.subtitle':
    '把完整的電子郵件檔案—連同附件—上傳至 A&GEL，像處理其他文件一樣使用它們。',
  'pages.angelInsider.issues.feature-msg.glance.0':
    '直接把 <strong>.msg</strong> 電子郵件檔案上傳至檔案中。',
  'pages.angelInsider.issues.feature-msg.glance.1': 'A&GEL 會讀取全部內容—包括附件。',
  'pages.angelInsider.issues.feature-msg.glance.2':
    '可搭配對話或任何專門模式（引導式摘要、時間軸等）使用。',
  'pages.angelInsider.issues.feature-msg.glance.3':
    '例外：帶有<em>僅限內部</em>標籤或受密碼保護的附件會被略過。',
  'pages.angelInsider.issues.feature-msg.sections.0.kicker': '.msg 上傳',
  'pages.angelInsider.issues.feature-msg.sections.0.heading': '上傳電子郵件檔案（.msg）',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.0.p':
    'A&GEL 使用者現在可以把完整的 <strong>.msg</strong> 電子郵件檔案上傳至檔案中，供對話或任何專門模式使用。A&GEL 會讀取全部內容—包括附件—但帶有<em>僅限內部</em>敏感度標籤或受密碼保護的附件除外。',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.1.p':
    '上傳後，您可以請 A&GEL 彙整這封郵件、彙整隨附的文件，或針對它執行提示詞庫中的任何提示詞。',
  'pages.angelInsider.issues.feature-msg.signoff.line': '郵件連同附件，一併讀取。',
  'pages.angelInsider.issues.feature-msg.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-inline-ref.title': '內嵌引註',
  'pages.angelInsider.issues.feature-inline-ref.subtitle':
    '深度研究、時間軸、範圍摘要與審閱皆支援可點擊的定位引註—不必離開頁面即可對照來源驗證每一項輸出。',
  'pages.angelInsider.issues.feature-inline-ref.glance.0':
    '深度研究、時間軸與範圍摘要的輸出現已附有<strong>可點擊的內嵌引註</strong>。',
  'pages.angelInsider.issues.feature-inline-ref.glance.1':
    '點擊任一引註，即可開啟來源文件並標示對應的確切段落。',
  'pages.angelInsider.issues.feature-inline-ref.glance.2':
    '審閱的<strong>說明面板</strong>同樣為每項 AI 產生的發現提供結構化內嵌引註。',
  'pages.angelInsider.issues.feature-inline-ref.glance.3':
    '不必切換分頁—所有驗證都在同一頁面完成。',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.kicker': '內嵌引註',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.heading': '對照來源驗證每一項輸出',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.0.p':
    'A&GEL 所有主要的輸出類應用程式—<strong>深度研究、時間軸、範圍摘要</strong>—現已支援可點擊的內嵌引註。每條引註都有編號並附連結：點擊即可開啟來源文件，並標示對應的確切段落。',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.1.p':
    '如此一來，就不必為了驗證某個具體要點而切換分頁或手動翻找來源文件。交叉比對可在同一頁面內完成。',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.kicker': '審閱中的內嵌引註',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.heading': '說明面板中的結構化引註',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.0.p':
    '審閱頁面的<strong>說明</strong>區塊—點擊任一儲存格即可展開—現已支援結構化內嵌引註。每個說明要點都連結至其來源條款或段落，讓您能輕鬆把 AI 產生的發現與事實依據加以核對。',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.1.figure.caption':
    '審閱中的說明面板，附有連結到來源文件的結構化內嵌引註。',
  'pages.angelInsider.issues.feature-inline-ref.signoff.line': '每一項輸出，來源可查證。',
  'pages.angelInsider.issues.feature-inline-ref.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.issue-5.title': '內嵌引註、迷你對話與更多更新',
  'pages.angelInsider.issues.issue-5.subtitle':
    '各應用程式全面支援定位引註、可移動的迷你對話、錄音時間戳記，以及一系列使用體驗優化。',
  'pages.angelInsider.issues.issue-5.date': '2026 年 4 月 10 日',
  'pages.angelInsider.issues.issue-5.glance.0':
    '深度研究、時間軸、範圍摘要與審閱現已支援<strong>可點擊的內嵌引註</strong>。',
  'pages.angelInsider.issues.issue-5.glance.1':
    '審閱、差異比對與並排比較中的迷你對話視窗現已<strong>可移動、可調整大小</strong>。',
  'pages.angelInsider.issues.issue-5.glance.2':
    '錄音逐字稿現已在下載的 Word 文件中包含<strong>時間戳記</strong>。',
  'pages.angelInsider.issues.issue-5.glance.3':
    '除停止按鈕外，現在還可<strong>透過歷程記錄分頁終止工作階段</strong>。',
  'pages.angelInsider.issues.issue-5.glance.4': '搜尋改進：關鍵字比對更準確，並支援文件內搜尋。',
  'pages.angelInsider.issues.issue-5.sections.0.kicker': '01 — 內嵌引註',
  'pages.angelInsider.issues.issue-5.sections.0.heading': '各應用程式全面支援定位引註',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.0.p':
    '深度研究、時間軸與範圍摘要現已支援<strong>可點擊的內嵌引註</strong>。有了這些引註，您可以即時把輸出與來源文件交叉核對—點擊任一引註即可開啟來源並標示相關段落，全程不必離開頁面。',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.1.p':
    '審閱頁面展開後的<strong>說明</strong>區塊同樣新增了連結至來源文件的結構化內嵌引註，讓您更容易把 AI 產生的分析與事實依據加以核對。',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.2.figure.caption':
    '審閱中的說明面板—連結至來源文件的結構化內嵌引註。',
  'pages.angelInsider.issues.issue-5.sections.1.kicker': '02 — 迷你對話',
  'pages.angelInsider.issues.issue-5.sections.1.heading': '可移動的迷你對話介面',
  'pages.angelInsider.issues.issue-5.sections.1.blocks.0.p':
    '<strong>審閱、差異比對與並排比較</strong>中的迷你對話視窗現已可移動、可調整大小。在梳理輸出內容時，把它拖到一旁即可—它不會再遮擋您的主要工作區域。',
  'pages.angelInsider.issues.issue-5.sections.2.kicker': '03 — 錄音',
  'pages.angelInsider.issues.issue-5.sections.2.heading': '下載的逐字稿附有時間戳記',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.0.p':
    '下載的錄音逐字稿（Word 文件）現已包含<strong>時間戳記</strong>—這些標記讓您可以直接從文件跳到錄音中的特定時刻。',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.1.figure.caption':
    '下載的錄音逐字稿，時間戳記與譯文並列顯示。',
  'pages.angelInsider.issues.issue-5.sections.3.kicker': '04 — 其他更新',
  'pages.angelInsider.issues.issue-5.sections.3.heading': '使用體驗優化',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.0.h': '更方便地終止工作階段',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.1.p':
    '除了既有的停止按鈕外，進行中的工作階段現在還可以透過<strong>在歷程記錄分頁中刪除它們</strong>來終止—當您需要修改提示詞後重新執行，或工作階段沒有回應時，這點特別有用。',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.2.h': '搜尋強化',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.3.p':
    '搜尋現已受惠於<strong>內嵌引註</strong>、更準確的關鍵字比對以及文件內搜尋—讓您更容易在保管庫中定位特定內容。',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.4.h': '更快的引導式摘要',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.5.p':
    '引導式摘要現已在生成過程中提供<strong>附內嵌引註的階段性更新</strong>，整體輸出速度也已提升。對於較簡單的文件，摘要可能載入得夠快，因而略過階段性更新。',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.6.h': '優化後的檔案介面',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.7.p':
    '檔案頁面的分頁機制已改進—您可以一眼看到更多檔案與資料夾，頁面會隨螢幕動態填滿。',
  'pages.angelInsider.issues.issue-5.signoff.line': '查證更快，工作區更清爽。',
  'pages.angelInsider.issues.issue-5.signoff.name': 'A&GEL 開發團隊',
  'pages.angelInsider.issues.feature-faq.title': '常見問題',
  'pages.angelInsider.issues.feature-faq.subtitle':
    'A&GEL 入門指南—從檔案管理、提示詞撰寫，到查核輸出結果。',
  'pages.angelInsider.issues.feature-faq.date': '2026 年 2 月 10 日',
  'pages.angelInsider.issues.feature-faq.glance.0': 'A&GEL 如何支援—而非取代—您的專業能力。',
  'pages.angelInsider.issues.feature-faq.glance.1': '檔案管理最佳做法：該上傳什麼，以及如何整理。',
  'pages.angelInsider.issues.feature-faq.glance.2':
    '如何運用「角色—任務—情境—格式」架構撰寫有效的提示詞。',
  'pages.angelInsider.issues.feature-faq.glance.3': '如何查核 A&GEL 輸出的正確性與可靠性。',
  'pages.angelInsider.issues.feature-faq.glance.4': 'A&GEL 所用技術詞彙的詞彙表。',
  'pages.angelInsider.issues.feature-faq.sections.0.kicker': '1 — 一般原則',
  'pages.angelInsider.issues.feature-faq.sections.0.heading': '始終讓專業人士發揮專業',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.0.h':
    '問：A&GEL 設計理念的一部分是我們應「始終讓專業人士發揮專業」。這是什麼意思？',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.1.p':
    '「始終讓專業人士發揮專業」指的是：身為所在領域的專業人士／專家，您的判斷、洞察與操守應始終是工作的核心。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.2.p':
    'A&GEL 不會取代這份專業，也不會扮演領域專家。相反地，它的設計目的是協助您這樣的知識工作者／律師，用更多資源完成更多事。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.3.h':
    '問：如果我對詢問 A&GEL 的主題完全不熟悉，那我是不是就不該使用 A&GEL？',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.4.p':
    '若您的專業功力仍在累積中—這並不代表您應該避免使用 A&GEL，而是代表要更留意自己使用 A&GEL 的方式。您應格外謹慎，並對 A&GEL 的輸出進行更多查核。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.5.p':
    '此外，不妨把 A&GEL 當成通往團隊或公司既有專業知識的入口與嚮導。以這種方式取用既有專業知識、隨時汲取其中的洞見與啟發，A&GEL 便會成為支援您訓練與發展的有力工具。',
  'pages.angelInsider.issues.feature-faq.sections.1.kicker': '2 — 檔案管理',
  'pages.angelInsider.issues.feature-faq.sections.1.heading': '該上傳什麼，以及如何整理',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.0.h':
    '問：我應該上傳哪類參考資料到 A&GEL？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.1.p':
    '一般原則是：只上傳可信、可靠且正確的資料。例如第一手法律來源（法規、判例等），以及可信的內部資料（公司專業知識，或您自己經過反覆驗證的文件）。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.2.p':
    '由於 A&GEL 的輸出高度仰賴您所指定的文件／資料夾，請務必挑選並上傳正確的檔案，並為這些可信文件建立清楚的命名規則。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.title': 'Word 文件設定',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.body':
    '上傳至 A&GEL 之前，Word 文件的安全性設定必須設為「外部」（或其等效選項）。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.4.h':
    '問：第三方文件呢？我可以上傳到 A&GEL 嗎？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.5.p':
    '當然可以！我們鼓勵您使用 A&GEL 分析、盤查或審閱第三方文件—事實上，這正是 A&GEL 多種專門模式（例如審閱）的核心強項之一。這也包括來自對造律師／交易相對人的文件。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.6.p':
    '只要記得把它上傳到能清楚標示其為第三方文件的資料夾，這樣您從檔案路徑就能分辨：這究竟是可信的範本，還是您正在處理的「外來」文件。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.7.p':
    '同時也請留意與您使用 A&GEL 相關的公司政策（例如涵蓋生成式 AI 使用的政策）與可接受使用政策，其中包括在必要時須取得適當授權才能使用第三方內容。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.8.h':
    '問：為什麼 A&GEL「處理」我上傳到檔案分頁或對話中的檔案需要較長時間？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.9.p':
    '文件必須先轉換成 A&GEL 能處理的形式（這種形式稱為「嵌入向量」），因此上傳時可能需要一些時間—但這只在檔案上傳到保管庫中的「檔案」時進行一次。上傳到檔案分頁的文件，可在新的工作階段中，於對話或任一專門模式裡把該檔案選為情境而重複使用。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.10.p':
    '在對話中，一旦您上傳了某份文件，就可以點擊「情境」按鈕，再點擊「使用文件開始新對話」按鈕，在全新的對話工作階段中再次與同一份文件互動。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.11.h':
    '問：我該如何把文件批次上傳到檔案分頁？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.12.p':
    '在檔案模式下，點擊畫面右上角的上傳按鈕。選取您想上傳的檔案（數量不限），然後按「開啟」。在參考資料上傳期間，您可以繼續使用 A&GEL 的其他功能。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.13.h':
    '問：我該如何整理與管理上傳到 A&GEL 的參考資料？為什麼不能乾脆把所有東西都上傳到同一個資料夾？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.14.p':
    '<strong>為什麼檔案管理很重要？</strong>妥善的檔案管理，是確保您能有效做到以下兩點的關鍵：(a) 為 A&GEL 挑選相關參考資料，讓它的回應有所依據；以及 (b) 檢視 A&GEL 究竟使用了哪些參考資料，以確保所產生輸出的正確性與可靠性。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.15.p':
    '<strong>我該如何管理已上傳的參考資料？</strong>上傳參考資料到 A&GEL 時，我們強烈建議您不要把所有東西都放進同一個資料夾，而應依以下兩個面向整理與分組文件：(i) 主題；以及 (ii) 工作流程。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.16.p':
    '做法是：在檔案分頁中，上傳文件之前，點擊右上角的「建立資料夾」按鈕建立新資料夾，並以主題命名。接著在新建的資料夾內再建立子資料夾，以所上傳文件的工作流程命名。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.17.p':
    '如此一來，當您上傳文件時，就會形成一條同時呈現主題與工作流程的合適檔案路徑。例如：<code>Home / IP Licensing Agreements / Licensor</code>',
  'pages.angelInsider.issues.feature-faq.sections.2.kicker': '3 — 向 A&GEL 下提示詞',
  'pages.angelInsider.issues.feature-faq.sections.2.heading': '撰寫有效的提示詞',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.0.h': '問：我可以使用哪些類型的提示詞？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.1.p':
    '您可以用多種方式向 A&GEL 下提示詞。以下列出幾種類型供您參考（其中有些您可能沒想過）：',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.2.h': '資訊查詢與檢索',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.0':
    '<strong>提問式提示詞：</strong>直接提問，以取得事實資訊、說明或澄清。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.1':
    '<strong>說明式提示詞：</strong>要求針對概念、流程或現象作詳細說明。這類提示詞常用「解釋」「描述」「拆解」等措辭。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.2':
    '<strong>研究式提示詞：</strong>較複雜的資訊蒐集需求，可能需要綜整多個來源的資訊。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.4.h': '任務導向與指令式',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.0':
    '<strong>指令式提示詞：</strong>清楚、直接的命令，使用「撰寫」「建立」「分析」「彙整」等動作動詞。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.1':
    '<strong>多步驟任務提示詞：</strong>把較大的任務拆解為連續步驟的複雜指令。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.2':
    '<strong>範本式提示詞：</strong>為 AI 提供特定格式或架構以供遵循的結構化提示詞。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.6.h': '分析與問題解決',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.0':
    '<strong>資料分析式提示詞：</strong>用於分析資料集、辨識模式或萃取洞見的指令。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.1':
    '<strong>問題解決式提示詞：</strong>提出某項挑戰，並要求 AI 提供解決方案、策略或建議。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.2':
    '<strong>比較分析式提示詞：</strong>要求比較不同選項、評估替代方案，或權衡利弊。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.8.h': '分類與整理',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.0':
    '<strong>分類式提示詞：</strong>要求把文字、資料或資訊歸入預設的類別或標籤。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.1':
    '<strong>排序與排名式提示詞：</strong>要求依特定標準（如重要性、優先順序或偏好）組織資訊。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.2':
    '<strong>標記式提示詞：</strong>要求為內容指派標籤、標記或中繼資料，以便整理或搜尋。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.10.h': '轉換與格式化',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.0':
    '<strong>翻譯式提示詞：</strong>要求把文字從一種語言轉換為另一種語言，或讓內容適應不同的文化脈絡。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.1':
    '<strong>格式轉換式提示詞：</strong>要求改變資訊的結構或呈現方式，例如把散文改寫為條列重點。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.2':
    '<strong>文風轉換式提示詞：</strong>要求以不同語氣、文風或面向不同讀者重寫內容。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.12.h': '其他類型的提示詞',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.0': '角色扮演與人設類提示詞',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.1': '對話與互動類提示詞',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.2': '系統與行為設定類提示詞',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.3': '推理與邏輯類提示詞',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.4': '程式碼與技術類提示詞',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.5': '教學與訓練類提示詞',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.14.h': '問：我該如何撰寫有效的提示詞？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.15.p':
    '一般而言，最有效的提示詞由四個部分組成：<strong>(a) 角色；(b) 任務；(c) 情境；以及 (d) 格式。</strong>',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.16.h': '(a) 角色',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.17.p':
    '角色指的是您在撰寫 AI 提示詞時，對自身身分的說明，或希望 A&GEL 扮演的身分。這有助於把 A&GEL 導向特定的文風與語氣。加入角色設定，會讓您得到更貼合自身需求的回應。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.label': '範例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.text':
    '你是一位擁有 30 年經驗的資深律師。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.19.h': '(b) 任務',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.20.p':
    '這是您給模型下達的指令。任務指令越具體，得到的結果越好。不過，指派 AI 任務時，清楚與精簡同樣重要。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.label': '範例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.text':
    '請用不超過 100 字彙整這份文件。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.22.h': '(c) 情境',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.23.p':
    '您餵給 A&GEL 的情境（即資訊）能帶來天壤之別。情境是讓 A&GEL 提示詞產出有針對性結果的最佳途徑。這類情境也可以用專家「知識」的形式給出，也就是您希望 A&GEL 在產生輸出時特別納入考量的內容。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.label': '範例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.text':
    '本摘要是給客戶看的，客戶是本次交易中的買方。請在摘要中從買方角度列出交易的相關細節。\n\n知識：轉讓、更約或移轉條款並不屬於控制權、所有權或權益變更的條款或規定。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.25.h': '(d) 格式',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.26.p':
    '這是指輸出的呈現形式。可選項包括清單、表格以及 Markdown 格式。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.label': '範例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.text':
    '請以表格形式呈現該摘要。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.title': '從提示詞庫入手',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.body':
    '撰寫有效提示詞的一種方式，是拿一則已被證明有效的現成提示詞，再依您的目的加以調整。前往提示詞庫分頁，「複製」相關提示詞，並針對您的案件加以修改。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.29.h':
    '完整範例—角色 + 任務 + 情境 + 格式',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.label': '完整提示詞範例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.text':
    '你是一位經驗豐富的律師。請為這份文件產生一份精簡摘要（每部分不超過 100 字）。指示：重點指出 (1) 文中涵蓋的主要益處與正面之處，並另起一個項目符號，至少給出一個所引用事實作為例證；以及 (b) 文中涵蓋的主要風險與不利之處，並另起一個項目符號，至少給出一個所引用事實作為例證。請確保摘要連貫清晰。若發現不止一個例證或支持論據，請依文中所述指出哪一個最好或最差。請使用正式語言並維持中立語氣，避免加入個人意見或詮釋。所有輸出皆以 markdown 格式呈現，每個重點使用項目符號，特別重要的發現使用粗體。你的成果必須精確、正確且專業，因為它將由資深法律專業人士審閱，並用於高風險的金融交易之中。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.31.h':
    '問：什麼是 RAG？A&GEL 何時會使用它？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.32.p':
    '預設情況下，A&GEL 的對話功能採用檢索增強生成（RAG）。它會從您上傳到檔案分頁的參考資料中擷取資訊，再連同您向 A&GEL 下的提示詞一併傳給生成元件（即大型語言模型）。隨後，A&GEL 會依據其掌握的資料—以及來自 RAG 的額外情境—產生輸出。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.33.p':
    'RAG 與大型語言模型技術的結合，為 A&GEL 提供了情境與相關資訊，使其能產出「經增強的回應」，進而提升輸出的精確度，也提高答案可靠的機率。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.34.h':
    '問：為什麼我不該乾脆讓 A&GEL 在所有提示中都納入我上傳的全部資料？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.35.p':
    '我們強烈建議您不要讓 A&GEL 去考量與您提示詞無關的已上傳資料。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.36.p':
    'A&GEL 這類生成式 AI 工具並不理解詞語、條款、協議等的意義。它們透過機率方法運作，而非真正的理解。在對話模式下，若把所有檔案都選為情境，A&GEL 就會從您保管庫中上傳的全部文件裡擷取參考內容。然而，與您提示詞真正相關的情境資料，可能僅限於某個特定主題，甚至某個特定工作流程。提供與您目的無關的額外情境給 A&GEL，很可能會降低其輸出的速度、正確性、精確度與可靠性。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.37.h':
    '問：我該如何為每一則提示詞挑選相關的參考資料？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.38.p':
    '在對話模式下，若要限制 A&GEL 只以嚴格相關的參考資料作為提示詞的情境，請前往「情境」，點擊選取圖示，並只勾選相關的文件／資料夾。',
  'pages.angelInsider.issues.feature-faq.sections.3.kicker': '4 — 運用輸出結果',
  'pages.angelInsider.issues.feature-faq.sections.3.heading': '查核正確性與可靠性',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.0.h':
    '問：我已經向 A&GEL 下了提示詞並拿到輸出。可以直接使用嗎？',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.1.p':
    '一般而言，在把 A&GEL 的輸出用於您的工作成果之前，應該始終加以查核。建議您只把 A&GEL 的輸出當作起點或參考，並務必與可信／可靠的知識來源（例如您上傳的參考資料或經查證的法律素材）交叉比對。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.2.h':
    '問：我該如何查核輸出的正確性與可靠性？',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.3.p':
    '在對話模式下，A&GEL 的輸出已經過最佳化，只要有可用來源便會附上引註。這些引註是指向可信資訊（例如您上傳到檔案分頁的資料）的連結。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.4.p':
    '<strong>A&GEL 應該是通往您專業知識的入口，而非您專業知識的來源。</strong>點擊每一條引註連結，您就能看到 A&GEL 取用情境的那份參考資料。您應始終對照這些參考資料查核 A&GEL 的輸出，以確保其正確性與可靠性。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.5.p':
    '若您已落實妥善的 A&GEL 檔案管理做法，這些引註連結—它們會顯示所引用文件的檔案路徑—還能讓您一眼判斷 A&GEL 是否使用了正確主題（及工作流程）的資料來增強其輸出。舉例來說，若您是站在「租賃權讓與人」的立場提問，卻發現 A&GEL 引用了「租賃權受讓人」資料夾中的文件，您立刻就能看出該輸出並未完全貼合您的目的。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.title':
    '如果輸出沒有任何引註怎麼辦？',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.body':
    '沒有引註的輸出容易產生幻覺，因為它並未立基於任何可信的參考資料。若您看不到任何引註，那幾乎可以確定：輸出中呈現的資訊僅來自模型的預先訓練。除非您確信該輸出是在回應一般性寫作或文字編輯類提示（例如簡化文件或校對）或彙整任務，且模型已獲得充分情境，否則不應使用該輸出。',
  'pages.angelInsider.issues.feature-faq.sections.4.kicker': '5 — 詞彙表',
  'pages.angelInsider.issues.feature-faq.sections.4.heading': 'A&GEL 使用的技術詞彙',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.0.p':
    '<strong>最愛檔案權重：</strong>調整 A&GEL 在產生回應時，對您（在保管庫中）標示為「最愛」之文件的優先程度。權重越高，這些偏好來源對輸出的影響就越大，超過保管庫中的一般檔案。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.1.p':
    '<strong>重新排序：</strong>一道次級排序程序，A&GEL 會複查初始搜尋結果，以優先挑出最相關的條款或文字片段。這可確保在產生回應之前，最切題的資訊排在最前面。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.2.p':
    '<strong>搜尋比例：</strong>控制 AI 為回答某個查詢所擷取的內部資料量。比例越高，搜尋範圍越廣、納入的情境越多（適合廣泛探索）；比例越低，則越嚴格聚焦於精確比對（大致類似 CTRL+F）。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.3.p':
    '<strong>系統提示詞：</strong>一組基礎指令，用來確立 A&GEL 的具體角色、語氣與運作界線（例如「你是一位擁有 20 年經驗的資深合夥人」）。這些設定構成主要架構，引導 A&GEL 處理其後的每一次請求。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.4.p':
    '<strong>「思考」或「推理」：</strong>指 A&GEL 在產生最終回應之前，對複雜查詢逐步進行邏輯拆解的過程。這種內部推演模仿人類的推理方式，目的是減少複雜分析中的錯誤。',
  'pages.angelInsider.issues.feature-faq.signoff.line':
    '任何新工具都需要一點時間適應—A&GEL 也不例外。您用得越多，它就越好用。',
  'pages.angelInsider.issues.feature-faq.signoff.name': 'A&GEL 開發團隊',
  'pages.app.addCustomFieldsTitle': '新增每個事件要擷取的自訂欄位',
  'pages.app.addCustomStepButton': '自訂步驟',
  'pages.app.addFieldButton': '新增欄位',
  'pages.app.addFromLibraryButton': '從資料庫選擇',
  'pages.app.addFromSavedButton': '已儲存的設定',
  'pages.app.addToMattersButton': '新增至項目',
  'pages.app.analysisType.agenticResearch.title': '智能研究',
  'pages.app.analysisType.comparison.title': '比較',
  'pages.app.analysisType.contractDeadlines.title': '擷取截止日期',
  'pages.app.analysisType.executiveSummary.title': '摘要報告',
  'pages.app.analysisType.gartnerReport.description': '提供包含預測與建議的深入產業報告。',
  'pages.app.analysisType.gartnerReport.title': 'Gartner 風格報告',
  'pages.app.analysisType.guidedSummary.description': '依提示詞引導，針對單一文件提供詳細摘要。',
  'pages.app.analysisType.multiStepPrompt.title': '多步驟提示詞',
  'pages.app.analysisType.scopeOfWork.title': '工作範圍摘要',
  'pages.app.analysisType.timeline.description': '針對最多 100 份文件提供詳細的事件時間軸。',
  'pages.app.analyzingFiles': '正在分析檔案...',
  'pages.app.applicablePartiesColumnTitle': '適用當事方',
  'pages.app.appsList.executiveSummary.description': '為管理階層提供重點、發現與建議的高層次總覽',
  'pages.app.appsList.gartnerReport.description': '採用嚴謹客觀的研究方法，提供深入的產業分析',
  'pages.app.appsList.guidedSummary.description': '依提示詞引導，針對單一文件提供詳細摘要',
  'pages.app.appsList.standardInfo.description': '提供精簡摘要、人員與實體清單，以及簡短時間軸',
  'pages.app.appsList.timeline.description': '針對最多 100 份文件提供詳細的事件時間軸',
  'pages.app.appsTitle': '應用程式',
  'pages.app.backToSavedPromptsLabel': '返回已儲存的提示',
  'pages.app.backgroundColumnTitle': '背景',
  'pages.app.buildMultiStepPromptTitle': '建立多步驟提示',
  'pages.app.buildNewButton': '新建設定',
  'pages.app.clauseColumnTitle': '條款',
  'pages.app.clearStepsButton': '清空',
  'pages.app.clearStepsConfirm': '移除清單中的所有步驟？',
  'pages.app.clientDetailsPlaceholder': '客戶名稱及簡要資訊',
  'pages.app.clientInformationTitle': '客戶資訊',
  'pages.app.clientLabel': '客戶',
  'pages.app.collapseAllPrompts': '收合所有提示',
  'pages.app.collapsePrompt': '收合提示',
  'pages.app.compilingFinalSummary': '正在彙整最終摘要...',
  'pages.app.complexityLabel': '複雜度',
  'pages.app.configNameLabel': '設定名稱',
  'pages.app.configTagsLabel': '標籤',
  'pages.app.configurationDeletedSuccess': '設定已刪除',
  'pages.app.configurationSavedSuccess': '設定儲存成功',
  'pages.app.configurationUpdatedSuccess': '設定更新成功',
  'pages.app.contactLabel': '聯絡人',
  'pages.app.counterpartyLabel': '交易對手',
  'pages.app.dateReferenceColumnTitle': '日期／參考編號',
  'pages.app.deadlinesSectionTitle': '截止日期',
  'pages.app.deleteConfigConfirmTitle': '確定要刪除此設定嗎?',
  'pages.app.deleteStepTooltip': '刪除步驟',
  'pages.app.detailsColumnTitle': '詳情',
  'pages.app.doneCount': '已完成 ({completed}/{total})',
  'pages.app.dragHereToUpload': '拖曳至此處以上傳',
  'pages.app.dragStepTooltip': '拖曳步驟',
  'pages.app.dropZoneForNamedStep': '{stepName} 的拖放區',
  'pages.app.dropZoneForStepNumber': '步驟 {stepNumber} 的拖放區',
  'pages.app.durationColumnTitle': '期間',
  'pages.app.enterConfigNamePlaceholder': '輸入設定名稱',
  'pages.app.enterDescriptionPlaceholder': '輸入描述',
  'pages.app.enterTagsPlaceholder': '輸入標籤後按 Enter',
  'pages.app.entitiesColumnTitle': '實體',
  'pages.app.expandAllPrompts': '展開所有提示',
  'pages.app.expandPrompt': '展開提示',
  'pages.app.extendPromptTabLabel': '擴充提示',
  'pages.app.extraFieldDescriptionPlaceholder': '描述(例如:擷取提及的金額)',
  'pages.app.extraFieldKeyPlaceholder': '欄位名稱(例如:預算)',
  'pages.app.extractColumnTitle': '擷取內容',
  'pages.app.fileCountLabel': '{count} 個檔案',
  'pages.app.filesCompleteCount': '已完成 {completed}/{total} 個檔案',
  'pages.app.hardDeadlineColumnTitle': '硬性截止日期',
  'pages.app.inProgressSuffix': '(進行中)',
  'pages.app.keyDatesDeadlinesTitle': '關鍵日期與截止日期',
  'pages.app.libraryPanelTitle': '提示資料庫',
  'pages.app.loadSavedConfigPlaceholder': '載入已儲存的設定',
  'pages.app.loadingDocumentTip': '正在載入文件...',
  'pages.app.mattersUpdatedSuccess': '項目更新成功',
  'pages.app.moveStepDownTooltip': '下移',
  'pages.app.moveStepUpTooltip': '上移',
  'pages.app.newAnalysisModesTitle': '全新分析模式',
  'pages.app.newFieldDefaultKey': '欄位 {number}',
  'pages.app.newSessionLabel': '新工作階段',
  'pages.app.newStepDefaultName': '新步驟',
  'pages.app.noSourceDocumentsDescription': '沒有來源文件',
  'pages.app.noTimelineItemsExtracted': '未擷取到任何時間軸項目。',
  'pages.app.overallTabLabel': '整體',
  'pages.app.overviewSectionTitle': '概觀',
  'pages.app.partiesSectionTitle': '當事人',
  'pages.app.peopleEntitiesInvolvedLabel': '相關人員／實體',
  'pages.app.periodsDurationsTitle': '期間與時長',
  'pages.app.pleaseEnterPlaceholder': '請輸入',
  'pages.app.processingNextStep': '正在處理下一步驟...',
  'pages.app.promptForStepPlaceholder': '此步驟的提示',
  'pages.app.promptLabelWithValue': '提示:{prompt}',
  'pages.app.provideDetailsTabLabel': '提供詳細資訊',
  'pages.app.provideDocumentsTabLabel': '提供文件',
  'pages.app.providePromptsTabLabel': '提供提示',
  'pages.app.provisionColumnTitle': '條款規定',
  'pages.app.publishAudienceGroupsLabel': '群組',
  'pages.app.publishAudienceLabel': '發布對象',
  'pages.app.publishAudienceOptionFirmWide': '全公司',
  'pages.app.publishAudienceOptionGroup': '群組',
  'pages.app.publishAudienceOptionPublic': '公開',
  'pages.app.publishButton': '發布',
  'pages.app.publishConfigTitle': '發布設定',
  'pages.app.publishPublicNotice': '此設定將對所有使用者公開。系統將傳送請求至超級管理員以待核准。',
  'pages.app.publishRequestSubmitted': '發布請求已送出,等待管理員核准',
  'pages.app.publishedToGroup': '已發布至群組',
  'pages.app.readingDocumentName': '正在讀取 {name}',
  'pages.app.restrictionColumnTitle': '限制',
  'pages.app.restrictiveCovenantsTitle': '限制性條款',
  'pages.app.reuseButton': '重複使用',
  'pages.app.runAppButton': '執行應用程式',
  'pages.app.sanitizedCheckingDocuments': '正在檢查文件…',
  'pages.app.sanitizedSearchingDocuments': '正在搜尋文件…',
  'pages.app.sanitizedWorkingThroughDocuments': '正在處理文件…',
  'pages.app.saveAsConfigButton': '另存為',
  'pages.app.saveConfigButton': '儲存設定',
  'pages.app.saveConfigurationTitle': '儲存設定',
  'pages.app.savedPromptStepCount': '{count, plural, other {# 個步驟}}',
  'pages.app.savedPromptsEmpty': '找不到已儲存的多步驟提示',
  'pages.app.savedPromptsPanelTitle': '選擇已儲存的設定',
  'pages.app.savedPromptsSearchPlaceholder': '搜尋已儲存的提示...',
  'pages.app.savedPromptsTagFilterPlaceholder': '依標籤篩選',
  'pages.app.searchMattersPlaceholder': '搜尋項目...',
  'pages.app.searchPromptsPlaceholder': '搜尋提示...',
  'pages.app.selectAtLeastOneGroupError': '請至少選擇一個群組',
  'pages.app.selectDocumentsStepTitle': '1. 選擇您欲分析的文件',
  'pages.app.selectMattersLabel': '選擇項目:',
  'pages.app.sharedConfigLabel': '{name}(共用)',
  'pages.app.sourcesColumnTitle': '來源',
  'pages.app.specialRequestsSectionTitle': '特殊要求',
  'pages.app.specificInformationStepTitle': '2. 特定資訊(選填)',
  'pages.app.stepNamePlaceholder': '步驟名稱(例如:擷取實體)',
  'pages.app.stepNumberLabel': '步驟 {number}',
  'pages.app.stepsAddedFromConfig': '{count, plural, other {已新增 # 個步驟}}',
  'pages.app.subagentLabel': '子代理 {number}',
  'pages.app.subjectLabel': '主旨',
  'pages.app.summaryLabel': '摘要',
  'pages.app.tool.checkingDocuments': '檢查文件中',
  'pages.app.tool.readingDocument': '讀取文件中',
  'pages.app.tool.searchingDocuments': '搜尋文件中',
  'pages.app.tool.workingWithName': '處理中({name})',
  'pages.app.tool.writingReport': '撰寫報告中',
  'pages.app.untitledSession': '(未命名)',
  'pages.app.updateConfigButton': '更新',
  'pages.app.updateConfigurationTitle': '更新設定',
  'pages.app.updateMattersFailed': '項目更新失敗',
  'pages.app.uploadOrSelectFilesError': '請上傳檔案或選擇現有檔案',
  'pages.app.urgencyColumnTitle': '緊急程度',
  'pages.app.useAnotherAppButton': '使用其他應用程式',
  'pages.app.whatsNew': '最新消息',
  'pages.app.workingEllipsis': '處理中…',
  'pages.app.workingThroughDocumentsCount': '正在處理文件({completed}/{total})',
  'pages.chat.addToMatters': '加入項目',
  'pages.chat.agentQuestion.answersSent': '答案已傳送給代理',
  'pages.chat.agentQuestion.customAnswerPlaceholder': '或輸入您自己的答案...',
  'pages.chat.agentQuestion.dismissQuestion': '關閉問題',
  'pages.chat.agentQuestion.noAnswer': '(無答案)',
  'pages.chat.agentQuestion.question': '問題',
  'pages.chat.agentQuestion.questionOfTotal': '第 {current} 題,共 {total} 題',
  'pages.chat.agentQuestion.questionProgress': '{current} / {total}',
  'pages.chat.agentQuestion.reviewAnswers': '檢視答案',
  'pages.chat.agentQuestion.reviewYourAnswers': '送出前請先檢視您的答案。',
  'pages.chat.agentQuestion.seeLess': '顯示較少',
  'pages.chat.agentQuestion.seeMore': '顯示更多',
  'pages.chat.agentQuestion.sendAnswers': '傳送答案',
  'pages.chat.agentQuestion.submitted': '已送出',
  'pages.chat.agentQuestion.summary': '摘要',
  'pages.chat.agenticRag': '智能代理 RAG',
  'pages.chat.agenticRag.description': '由智能代理決定何時搜尋你的內容檔案',
  'pages.chat.agenticRag.tooltip': '啟用具引用來源的智能代理檢索功能。需要聊天內容中含有文件。',
  'pages.chat.allowSelfPrompting': '允許自我提示',
  'pages.chat.allowSelfPrompting.description': '智能代理會從你的提示庫中套用相符的提示',
  'pages.chat.allowSelfPrompting.tooltip': '啟用後,助理可建議並套用提示庫中的提示以改善回應。',
  'pages.chat.attachedDocument': '已附加文件',
  'pages.chat.auth.contentOpenedInNewTab': '內容已在新分頁中開啟',
  'pages.chat.auth.dataOpenedInNewTab': '資料已在新分頁中開啟',
  'pages.chat.auth.failedToFetchUrl': '擷取 URL 失敗:{error}',
  'pages.chat.auth.failedToOpenNewTab': '開啟新分頁失敗',
  'pages.chat.auth.fileOpenedInNewTab': '檔案已在新分頁中開啟',
  'pages.chat.auth.jsonResponseTitle': 'JSON 回應',
  'pages.chat.auth.textResponseTitle': '文字回應',
  'pages.chat.cannotCopyNonTextContent': '無法複製非文字內容',
  'pages.chat.chatTitle': '聊天',
  'pages.chat.clickOrDragToUpload': '點擊或拖曳以上傳',
  'pages.chat.connectionInterrupted': '您的連線已中斷。請點擊{retry}。',
  'pages.chat.context.custom': '自訂 {suffix}',
  'pages.chat.context.defaultWithName': '預設（{name}）',
  'pages.chat.context.fullContext': '完整內容',
  'pages.chat.context.label': '內容',
  'pages.chat.context.selectedLabel': '已選取',
  'pages.chat.customisation': '自訂設定',
  'pages.chat.dragHereToUpload': '拖曳至此處上傳',
  'pages.chat.emptyState.desktopTitle': '今天 A&GEL 能為您提供什麼協助？',
  'pages.chat.emptyState.mobileTitle': 'A&GEL 能為您提供什麼協助？',
  'pages.chat.emptyState.subtitle': '選擇下方提示直接開始，或直接輸入文字與 A&GEL 對話。',
  'pages.chat.failedToCopyMessage': '訊息複製失敗',
  'pages.chat.failedToDownloadFile': '檔案下載失敗：{error}',
  'pages.chat.fileDownloadedSuccessfully': '檔案下載成功',
  'pages.chat.filesInVault': '保管庫中的檔案',
  'pages.chat.home': '首頁',
  'pages.chat.htmlContentIframeTitle': 'HTML 內容',
  'pages.chat.messageCopied': '訊息已複製！',
  'pages.chat.newChatConfirm.content': '確定要清除目前的聊天記錄並開始新的工作階段嗎？',
  'pages.chat.newChatConfirm.okText': '是，開始新對話',
  'pages.chat.newChatConfirm.title': '要開始新對話嗎？',
  'pages.chat.nextStep.button': '下一步',
  'pages.chat.nextStep.review': '審閱',
  'pages.chat.nextStep.workstudio': 'Workstudio',
  'pages.chat.referenceDocument': '參考文件',
  'pages.chat.referenceTitle': '參考資料：{title}',
  'pages.chat.referencesCount': '{count} 項參考資料',
  'pages.chat.selectedContext': '已選取的內容',
  'pages.chat.selfPromptedUsing': '使用 {name} 自動產生提示。',
  'pages.chat.showMoreLines': '顯示更多（{count} 行）',
  'pages.chat.sourcesCount': '來源（{count}）',
  'pages.chat.startNewChat': '開始新對話',
  'pages.chat.starterPrompt.caseSummariser.name': '案例摘要工具',
  'pages.chat.starterPrompt.draftChecklist.name': '草擬檢查清單',
  'pages.chat.starterPrompt.summariseArticle.description': '文章摘要通用工具。',
  'pages.chat.starterPrompt.summariseArticle.name': '摘要這篇文章',
  'pages.chat.status.completed': '已完成',
  'pages.chat.status.working': '處理中',
  'pages.chat.toolCategory.compare': '比對文字中',
  'pages.chat.toolCategory.generate': '產生文件中',
  'pages.chat.toolCategory.read': '讀取文件中',
  'pages.chat.toolCategory.searchDoc': '搜尋文件中',
  'pages.chat.toolCategory.searchFiles': '搜尋檔案中',
  'pages.chat.toolCategory.selfInstruction': '套用指示中',
  'pages.chat.transientFiles': '暫存檔案',
  'pages.chat.unknownFileName': '未知',
  'pages.chat.unknownFileNameLong': '未知檔案',
  'pages.chat.untitledSession': '（未命名）',
  'pages.chat.upload.failedToUploadFile': '上傳 {fileName} 失敗',
  'pages.chat.upload.onlyAllowedTypes':
    '請僅上傳 PDF、DOC、DOCX、MSG、EML、TXT、MD、XLS、XLSX、PPT 或 PPTX 檔案',
  'pages.chat.uploadedImageAlt': '已上傳',
  'pages.chat.waiting.almostThere': '快好了...',
  'pages.chat.waiting.fetchingThatForYou': '正在為您擷取資料...',
  'pages.chat.waiting.hangTight': '請稍候，我正在處理...',
  'pages.chat.waiting.holdOnRetrieving': '請稍候，正在擷取資訊...',
  'pages.chat.waiting.justAMoment': '請稍等片刻...',
  'pages.chat.waiting.letMeCheck': '讓我確認一下...',
  'pages.chat.waiting.lookingThatUp': '正在為您查詢...',
  'pages.chat.waiting.oneSecPlease': '請稍候一下...',
  'pages.chat.waiting.workingOnIt': '處理中...',
  'pages.chat.webSearch.confidentialityNotice':
    '已開啟網路搜尋。請勿在提示中包含任何客戶機密資訊或受法律特權保護的資訊。',
  'pages.chat.webSearch.permission.title': '搜尋權限',
  'pages.chat.webSearch.permission.manual': '手動',
  'pages.chat.webSearch.permission.manualDescription': '每條查詢傳送前均需審核',
  'pages.chat.webSearch.permission.auto': '自動',
  'pages.chat.webSearch.permission.autoDescription': '無需審核直接執行。查詢內容將離開本所',
  'pages.comparison.analysisFallbackTitle': '分析',
  'pages.comparison.outcomeUnverified': '未驗證',
  'pages.comparison.commentTags': '評論標籤',
  'pages.comparison.allCommentTags': '所有評論標籤',
  'pages.comparison.noMatchingComments': '沒有與所選標籤相符的評論',
  'pages.comparison.downloadExcel': '下載 Excel',
  'pages.comparison.stopSuccess': '比對已成功停止。您可以檢視部分結果。',
  'pages.comparison.stopFailed': '停止比對失敗',
  'pages.comparison.uploadSuccess': '{fileName} 上傳成功',
  'pages.comparison.uploadFailed': '{fileName} 上傳失敗',
  'pages.comparison.uploadLimitExceeded': '此任務類型僅可上傳 {max} 個檔案。',
  'pages.comparison.pollingTimeout': '輪詢逾時。此任務可能仍在處理中。',
  'pages.comparison.taskStarted': '比對任務已開始',
  'pages.comparison.startFailed': '啟動比對失敗',
  'pages.comparison.previousAnalysisTitle': '上一項分析',
  'pages.comparison.analysisPositionCounter': '{current} / {total}',
  'pages.comparison.analysisFoundCounter': '找到 {total} 項',
  'pages.comparison.nextAnalysisTitle': '下一項分析',
  'pages.comparison.messageHeading': '訊息',
  'pages.comparison.noResultsYet': '尚無結果',
  'pages.comparison.startComparisonButton': '開始比對',
  'pages.comparison.newComparisonButton': '開始新的比對',
  'pages.comparison.searchComparisonsPlaceholder': '搜尋比對',
  'pages.comparison.reuseButton': '重複使用',
  'pages.comparison.selectMattersLabel': '選擇項目：',
  'pages.comparison.searchMattersPlaceholder': '搜尋項目...',
  'pages.comparison.mattersUpdated': '項目已成功更新',
  'pages.comparison.mattersUpdateFailed': '更新項目失敗',
  'pages.comparison.addToMattersButton': '加入項目',
  'pages.comparison.untitled': '（未命名）',
  'pages.comparison.processingMoreResults': '正在處理更多結果...',
  'pages.comparison.processingComparison': '正在處理比對...',
  'pages.comparison.taskType.strikethroughUnderline.label': '刪除線與底線',
  'pages.comparison.taskType.trackedChanges.label': '追蹤修訂',
  'pages.comparison.taskType.trackedChanges.description': '審閱使用追蹤修訂功能所做的修訂與註解。',
  'pages.comparison.taskType.twoVersions.label': '兩個版本',
  'pages.comparison.taskType.twoVersions.description': '比對文件的兩個不同版本以找出差異。',
  'pages.comparison.taskType.referenceDocument.label': '目標對照參考',
  'pages.comparison.requirement.singleDocument': '單一文件',
  'pages.comparison.requirement.twoDocuments': '兩份文件',
  'pages.comparison.startHereTab': '從這裡開始',
  'pages.comparison.selectDocumentsPrompt': '選擇您要進行比對的文件',
  'pages.comparison.dragUploadText': '點選或將檔案拖曳至此區域以上傳',
  'pages.comparison.swapOrderButton': '交換順序',
  'pages.comparison.fileLabel.old': '（舊） ',
  'pages.comparison.fileLabel.new': '（新） ',
  'pages.comparison.fileLabel.reference': '（參考） ',
  'pages.comparison.fileLabel.target': '（目標） ',
  'pages.comparison.customInstructionTab': '自訂指示（選填）',
  'pages.comparison.modifyPromptTitle': '修改提示',
  'pages.comparison.pageTitle': '比對',
  'pages.comparison.similarDocumentComparisonTitle': '相似文件比對',
  'pages.comparison.referenceDocumentComparisonTitle': '參考文件比對',
  'pages.comparison.dragHereToUpload': '拖曳至此處上傳',
  'pages.comparison.documentCount.unknownFile': '未知檔案',
  'pages.comparison.documentCount.fileCount': '{count} 個檔案',
  'pages.comparison.reviewDirection.reviewedOnBehalfOf': '代表以下對象審閱 ',
  'pages.comparison.reviewDirection.swapButton': '交換審閱方向',
  'pages.comparison.invalidFileDocxOrPdf': '{fileName} 不是有效的 .docx 或 .pdf 檔案',
  'pages.comparison.invalidFileDocx': '{fileName} 不是有效的 .docx 檔案',
  'pages.comparison.twoVersionsFileCountError': '「兩個版本」比對請務必上傳 2 份文件。',
  'pages.comparison.singleFileCountError': '此任務請務必上傳 1 份文件。',
  'pages.composer.changeAction.accept': '接受',
  'pages.composer.changeAction.reject': '拒絕',
  'pages.composer.changeAction.reset': '重設',
  'pages.composer.documentView.foundCount': '找到 {count} 項',
  'pages.composer.documentView.nextChangeArrow': '下一項 ↓',
  'pages.composer.documentView.nextChangeTitle': '下一項變更',
  'pages.composer.documentView.positionCount': '{current} / {total}',
  'pages.composer.documentView.previousChangeTitle': '上一項變更',
  'pages.composer.documentView.stepNumber': '步驟 {number}',
  'pages.composer.documentView.turnNumber': '第 {number} 輪',
  'pages.composer.playbook.askAgel': '詢問 A&GEL',
  'pages.composer.playbook.chooseDocumentTitle': '選擇文件以開始',
  'pages.composer.playbook.createSessionFailed': '建立 Workstudio 工作階段失敗',
  'pages.composer.playbook.documentCanvas': '文件畫布',
  'pages.composer.playbook.docxOnlyAllowedError': 'Workstudio 模式僅允許 .docx 檔案',
  'pages.composer.playbook.docxOnlySkippedWarning': '部分檔案已略過。僅允許 .docx 檔案',
  'pages.composer.playbook.docxOnlySupportedError': 'Workstudio 模式僅支援 .docx 檔案',
  'pages.composer.playbook.downloadGenerating': '產生中…',
  'pages.composer.playbook.dragToUpload': '拖曳至此處上傳',
  'pages.composer.playbook.fileUploadFailed': '上傳 {fileName} 失敗',
  'pages.composer.playbook.fileUploadedSuccess': '{fileName} 上傳成功',
  'pages.composer.playbook.newButtonText': '新增 Workstudio',
  'pages.composer.playbook.openFailed': '開啟 Workstudio 失敗',
  'pages.composer.playbook.reuseButton': '重複使用',
  'pages.composer.playbook.resizeChatPane': '調整聊天區域寬度',
  'pages.composer.playbook.searchPlaceholder': '搜尋 Workstudio',
  'pages.composer.playbook.title': 'Workstudio',
  'pages.composer.playbookReview.acceptAllButton': '全部接受',
  'pages.composer.playbookReview.acceptChangeError': '接受變更失敗,請再試一次。',
  'pages.composer.playbookReview.addCommentButton': '留言',
  'pages.composer.playbookReview.addCommentPlaceholder': '新增留言...',
  'pages.composer.playbookReview.addCommentTooltip': '新增留言',
  'pages.composer.playbookReview.allAcceptError': '全部接受變更失敗,請再試一次。',
  'pages.composer.playbookReview.allAcceptedSuccess': '已接受所有變更',
  'pages.composer.playbookReview.allRejectError': '全部拒絕變更失敗,請再試一次。',
  'pages.composer.playbookReview.allRejectedSuccess': '已拒絕所有變更',
  'pages.composer.playbookReview.allResetError': '重設所有變更失敗,請再試一次。',
  'pages.composer.playbookReview.allResetSuccess': '所有變更已重設為待處理',
  'pages.composer.playbookReview.backToWorkstudio': '返回 Workstudio',
  'pages.composer.playbookReview.changeOfTotal': '第 {index} 項變更,共 {total} 項',
  'pages.composer.playbookReview.commentSaveError': '儲存留言失敗,請再試一次。',
  'pages.composer.playbookReview.commentSavedSuccess': '留言已儲存',
  'pages.composer.playbookReview.discardDraftButton': '放棄草稿',
  'pages.composer.playbookReview.documentLoadFailedError': '無法載入此文件,請重新整理再試一次。',
  'pages.composer.playbookReview.documentViewAriaLabel': '文件檢視',
  'pages.composer.playbookReview.doneEditingButton': '完成',
  'pages.composer.playbookReview.downloadGenericError': '產生下載檔案失敗',
  'pages.composer.playbookReview.downloadSuccess': '文件下載成功!',
  'pages.composer.playbookReview.downloadTimeoutError': '產生下載檔案逾時',
  'pages.composer.playbookReview.editCommentButton': '編輯留言',
  'pages.composer.playbookReview.editCommentTooltip': '編輯留言',
  'pages.composer.playbookReview.editDocumentButton': '編輯',
  'pages.composer.playbookReview.groupAcceptAllCount': '全部接受 ({count})',
  'pages.composer.playbookReview.groupAcceptedError': '接受變更失敗,請再試一次。',
  'pages.composer.playbookReview.groupAcceptedSuccess': '已接受 {count} 項相同變更',
  'pages.composer.playbookReview.groupRejectAllCount': '全部拒絕 ({count})',
  'pages.composer.playbookReview.groupRejectedError': '拒絕變更失敗,請再試一次。',
  'pages.composer.playbookReview.groupRejectedSuccess': '已拒絕 {count} 項相同變更',
  'pages.composer.playbookReview.groupResetAllCount': '全部重設 ({count})',
  'pages.composer.playbookReview.groupResetError': '重設變更失敗,請再試一次。',
  'pages.composer.playbookReview.groupResetSuccess': '已重設 {count} 項相同變更',
  'pages.composer.playbookReview.hidePromptButton': '隱藏提示',
  'pages.composer.playbookReview.loadingDocument': '文件載入中...',
  'pages.composer.playbookReview.localDraftTag': '本機草稿',
  'pages.composer.playbookReview.localDraftTooltip':
    '未儲存的草稿。使用「儲存編輯」將文字變更記錄為追蹤修訂。',
  'pages.composer.playbookReview.noChangesDescription': 'AI 未針對此指示提出任何變更。',
  'pages.composer.playbookReview.noChangesFromStep': '此步驟沒有任何變更',
  'pages.composer.playbookReview.noChangesTitle': '未發現任何變更',
  'pages.composer.playbookReview.previousChangesFallback': '先前的變更',
  'pages.composer.playbookReview.processingTimeoutError': '處理時間超出預期,請重新整理以查看狀態。',
  'pages.composer.playbookReview.regenerateLabel': '重新產生',
  'pages.composer.playbookReview.rejectAllButton': '全部拒絕',
  'pages.composer.playbookReview.rejectChangeError': '拒絕變更失敗,請再試一次。',
  'pages.composer.playbookReview.resetAllButton': '全部重設',
  'pages.composer.playbookReview.reviewViewAriaLabel': '審閱檢視',
  'pages.composer.playbookReview.saveEditsButton': '儲存編輯',
  'pages.composer.playbookReview.saveEditsError': '儲存編輯失敗。您的草稿已保留，請再試一次。',
  'pages.composer.playbookReview.saveEditsNoChanges': '沒有可儲存的文字變更。',
  'pages.composer.playbookReview.saveEditsSuccess': '編輯已儲存為追蹤修訂。',
  'pages.composer.playbookReview.saveEditsTooltip':
    '將文字變更儲存為追蹤修訂。僅格式的變更不會被儲存。',
  'pages.composer.playbookReview.saveEditsUnavailableTooltip':
    '無法儲存：此文件的版面配置無法對應回文件文字。編輯內容將保留為本機草稿。',
  'pages.composer.playbookReview.selfPromptedUsing': '使用 {promptName} 自動產生提示。',
  'pages.composer.playbookReview.showFullPromptButton': '顯示完整提示',
  'pages.composer.playbookReview.showingDocumentView': '顯示文件檢視',
  'pages.composer.playbookReview.showingStepView': '顯示逐步檢視',
  'pages.composer.playbookReview.status.accepted': '已接受',
  'pages.composer.playbookReview.status.pending': '待處理',
  'pages.composer.playbookReview.status.rejected': '已拒絕',
  'pages.composer.playbookReview.statusDistributionAriaLabel': '審閱狀態分佈',
  'pages.composer.playbookReview.stepTag': '步驟 {number}',
  'pages.composer.playbookReview.stepViewAriaLabel': '逐步檢視',
  'pages.composer.playbookReview.turnNeedsRegeneration': '此輪對話需要重新產生。',
  'pages.composer.playbookReview.turnHasConflicts': '此輪對話包含衝突的變更。',
  'pages.composer.playbookReview.turnConflictReason':
    '部分建議的變更彼此重疊。請重新產生此輪對話以重新套用。',
  'pages.composer.playbookReview.turnHasUnlocatableChanges': '此輪對話包含無法定位的變更。',
  'pages.composer.playbookReview.turnUnlocatableReason':
    '部分建議的變更無法在文件中定位。請重新產生此輪對話以重新套用。',
  'pages.composer.playbookReview.turnTitle': '第 {order} 輪:{prompt}',
  'pages.composer.playbookReview.undoChangeError': '復原失敗,請再試一次。',
  'pages.composer.playbookReview.updatingCanvas': '正在更新審閱畫布...',
  'pages.composer.playbookReview.viewChangeTooltip': '在原始文件中檢視變更',
  'pages.composer.playbookReview.viewContextButton': '檢視內文',
  'pages.composer.playbookReview.waitForUpdateWarning': '請等待目前的更新完成後再下載。',
  'pages.dashboard.allChannelsOption': '所有頻道',
  'pages.dashboard.presetPast30Days': '過去 30 天',
  'pages.dashboard.presetToday': '今天',
  'pages.dashboard.presetWtd': '本週至今',
  'pages.dashboard.presetMtd': '本月至今',
  'pages.dashboard.presetYtd': '本年至今',
  'pages.dashboard.exportLoading': '匯出儀表板',
  'pages.dashboard.downloaded': '已下載',
  'pages.dashboard.downloadingName': '正在下載 {name}',
  'pages.dashboard.chatGptMessageSeries': 'ChatGPT 訊息',
  'pages.dashboard.storyboardMessageSeries': 'Storyboard 訊息',
  'pages.dashboard.broadcastMessageSeries': '廣播訊息',
  'pages.dashboard.messageTrendDataTitle': '訊息趨勢資料',
  'pages.dashboard.messageTrendDataTooltip': '所選期間內訊息統計數據的歷史趨勢。',
  'pages.dashboard.newUsersSeries': '新使用者',
  'pages.dashboard.activeUsersSeries': '活躍使用者',
  'pages.dashboard.userTrendDataTitle': '使用者趨勢資料',
  'pages.dashboard.userTrendDataTooltip': '所選期間內使用者統計數據的歷史趨勢。',
  'pages.dashboard.userActivityHeatmapTitle': '使用者活動熱圖',
  'pages.dashboard.userActivityHeatmapTooltip': '所選期間內每週各日、每小時的平均使用者訊息數。',
  'pages.dashboard.wordCloudTitle': '文字雲',
  'pages.dashboard.wordCloudTooltip': '所選期間內使用者訊息中高頻詞彙的圖形化呈現。',
  'pages.dashboard.realTimeUsersTitle': '即時使用者',
  'pages.dashboard.activeUsersTitle': '活躍使用者',
  'pages.dashboard.newUsersTitle': '新使用者',
  'pages.dashboard.promptTokensTitle': '提示詞 Token 數',
  'pages.dashboard.completionTokensTitle': '回覆 Token 數',
  'pages.dashboard.userMessagesTitle': '使用者訊息',
  'pages.dashboard.chatGptTitle': 'ChatGPT',
  'pages.dashboard.storyboardsTitle': 'Storyboards',
  'pages.dashboard.botMessagesTitle': '機器人訊息',
  'pages.dashboard.broadcastsTitle': '廣播',
  'pages.dashboard.repliesTitle': '回覆',
  'pages.dashboard.messageExchangesTitle': '訊息往來',
  'pages.dashboard.broadcastTitle': '#廣播',
  'pages.dashboard.outreachTitle': '觸及率',
  'pages.dashboard.totalUsersTitle': '使用者總數',
  'pages.dashboard.totalUserMessagesTitle': '使用者訊息總數',
  'pages.dashboard.totalBotMessagesTitle': '機器人訊息總數',
  'pages.dashboard.totalMessageExchangesTitle': '訊息往來總數',
  'pages.diagnostics.usersFilter.label': '使用者:',
  'pages.diagnostics.usersFilter.placeholder': '使用者',
  'pages.diagnostics.typesFilter.label': '類型:',
  'pages.diagnostics.typesFilter.placeholder': '類型',
  'pages.diagnostics.dateFilter.label': '日期:',
  'pages.diagnostics.datePreset.past30Days': '過去 30 天',
  'pages.diagnostics.datePreset.today': '今天',
  'pages.diagnostics.datePreset.wtd': '本週至今',
  'pages.diagnostics.datePreset.mtd': '本月至今',
  'pages.diagnostics.datePreset.ytd': '本年至今',
  'pages.diagnostics.errorItem.description': ' {username} · 建立時間:{createdTime}',
  'pages.files.you': '您',
  'pages.files.assignAnotherOwnerFirst': '請先指派另一位擁有者。',
  'pages.files.keepAtLeastOneMember': '請至少保留一位成員。',
  'pages.files.keepAtLeastOneOwner': '請至少保留一位擁有者。',
  'pages.files.deletingEllipsis': '刪除中...',
  'pages.files.failedToDelete': '刪除失敗',
  'pages.files.dropToUploadCurrentFolder': '拖放以上傳至目前資料夾',
  'pages.files.deleteConfirm.title': '要刪除 {count} 個檔案嗎?',
  'pages.files.fromPath': '來自:{path}',
  'pages.files.createdAtColumn': '建立時間',
  'pages.files.favoritesTitle': '我的最愛',
  'pages.files.searchFavoritesPlaceholder': '搜尋我的最愛...',
  'pages.files.chatTooltip': '聊天',
  'pages.files.uploadingEllipsis': '上傳中...',
  'pages.files.paginationRangeOfTotal': '第 {start}-{end} 項,共 {total} 項',
  'pages.files.enterNamePlaceholder': '輸入名稱',
  'pages.files.deleteConfirm.itemContent': '確定要刪除「{name}」嗎?',
  'pages.files.chatWithFolderTooltip': '與此資料夾聊天',
  'pages.files.chatWithFileTooltip': '與此檔案聊天',
  'pages.files.filePreviewAlt': '檔案預覽',
  'pages.files.fileTypeCannotBePreviewed': '此檔案類型無法預覽',
  'pages.files.uploadFilesMenuItem': '上傳檔案',
  'pages.files.uploadFolderMenuItem': '上傳資料夾',
  'pages.files.newFolderButton': '新增資料夾',
  'pages.files.sortOption.newestFirst': '最新優先',
  'pages.files.sortOption.oldestFirst': '最舊優先',
  'pages.files.sortOption.nameAZ': '名稱 A–Z',
  'pages.files.sortOption.nameZA': '名稱 Z–A',
  'pages.files.cleanupButton': '清理',
  'pages.files.selectButton': '選取',
  'pages.files.addGroupTitle': '新增群組',
  'pages.files.editGroupTitle': '編輯群組',
  'pages.files.groupType.privateGroup': '私人群組',
  'pages.files.groupType.firmWide': '全所',
  'pages.files.groupType.public': '公開',
  'pages.files.selectGroupTypeRequired': '請選擇群組類型。',
  'pages.files.groupNameRequired': '請輸入群組名稱。',
  'pages.files.groupNameTaken': '已有相同名稱的群組。',
  'pages.files.addPersonPlaceholder': '新增成員',
  'pages.files.noMembersYet': '尚無成員。',
  'pages.files.memberColumn': '成員',
  'pages.files.roleColumn': '角色',
  'pages.files.roleOwner': '擁有者',
  'pages.files.roleMember': '成員',
  'pages.files.revisionHistoryTitle': '修訂記錄',
  'pages.files.renamedTo': ' 至 ',
  'pages.files.noFieldValue': '無{field}',
  'pages.files.chatWithGroupTooltip': '與此群組對話',
  'pages.files.searchFilesPlaceholder': '搜尋檔案...',
  'pages.files.historyTitle': '歷史記錄',
  'pages.files.addNewButton': '新增',
  'pages.files.homeButton': '首頁',
  'pages.files.selectFolderPlaceholder': '選擇資料夾',
  'pages.files.moveMultipleFilesTitle': '移動 {count} 個檔案',
  'pages.files.moveSingleFileTitle': '移動「{name}」',
  'pages.files.addAtLeastOneMember': '請至少新增一位成員。',
  'pages.files.selectAtLeastOneOwner': '請至少選擇一位擁有者。',
  'pages.files.folderWarning.privateGroup': '安全性較低：您的群組可見。',
  'pages.files.folderWarning.firmWide': '非常不安全：全所皆可見。',
  'pages.files.folderWarning.public': '非常不安全：所有人皆可見。',
  'pages.files.duplicateFileNameError': '檔案名稱重複，請重新命名檔案',
  'pages.files.failedToUpdate': '更新失敗',
  'pages.files.filesDeletedCount': '已刪除 {count} 個檔案',
  'pages.files.filesMovedCount': '已移動 {count} 個檔案',
  'pages.files.failedToDeleteCount': '刪除 {count} 個檔案失敗',
  'pages.files.failedToMoveCount': '移動 {count} 個檔案失敗',
  'pages.files.filesDeletedCountWithFailures': '已刪除 {count} 個檔案，{failedCount} 個失敗',
  'pages.files.filesMovedCountWithFailures': '已移動 {count} 個檔案，{failedCount} 個失敗',
  'pages.files.failedToDeleteFiles': '刪除檔案失敗',
  'pages.files.failedToMoveFiles': '移動檔案失敗',
  'pages.files.unnamedFile': '未命名',
  'pages.files.failedToUploadFile': '上傳 {fileName} 失敗',
  'pages.files.failedToCreateFolder': '建立資料夾失敗：{folderName}',
  'pages.files.someFilesSkippedUnsupportedTypes': '部分檔案因類型不受支援而被略過',
  'pages.files.uploadingFolderEllipsis': '正在上傳資料夾...',
  'pages.files.folderUploadFailed': '資料夾上傳失敗',
  'pages.library.attachedDocsAccessNote': '提示詞附加文件的存取權限與提示詞本身的存取權限相同。',
  'pages.library.functionOption.summarise': '摘要',
  'pages.library.functionOption.review': '審閱',
  'pages.library.functionOption.amend': '修訂',
  'pages.library.functionOption.redFlagging': '風險標記',
  'pages.library.functionOption.promptlet': 'Promptlet',
  'pages.library.visibilityOption.personal': '個人',
  'pages.library.visibilityOption.group': '群組',
  'pages.library.visibilityOption.firmWide': '全所',
  'pages.library.visibilityOption.public': '公開',
  'pages.library.updateSuccess': '更新成功',
  'pages.library.updateFailed': '更新失敗',
  'pages.library.copySuccess': '提示詞已複製到剪貼簿！',
  'pages.library.copyFailed': '複製提示詞失敗',
  'pages.library.selfInstruction': '自我指示',
  'pages.library.pendingApproval': '待審核',
  'pages.library.publishPromptModalTitle': '發布提示詞',
  'pages.library.publishButton': '發布',
  'pages.library.publishRequestSentToAdmin': '您發布此提示詞的請求已送交管理員審核。',
  'pages.library.publishSuccess': '提示詞發布成功。',
  'pages.library.publishFailedDefault': '提交發布請求失敗，請再試一次。',
  'pages.library.field.visibility': '可見範圍',
  'pages.library.cloneButton': '複製',
  'pages.library.chatWithPromptButton': '與此提示詞對話',
  'pages.library.enterPromptNamePlaceholder': '輸入提示詞名稱',
  'pages.library.field.purpose': '用途',
  'pages.library.enterPurposePlaceholder': '輸入用途',
  'pages.library.field.notes': '備註',
  'pages.library.enterNotesPlaceholder': '輸入備註',
  'pages.library.field.author': '作者',
  'pages.library.allowSelfInstruction': '允許自我指示',
  'pages.library.attachedDocuments': '附加文件',
  'pages.library.documentsCount': '{count} 份文件',
  'pages.library.field.prompt': '提示詞',
  'pages.library.enterPromptContentPlaceholder': '輸入提示詞內容',
  'pages.library.noPromptsSelected': '尚未選取提示詞',
  'pages.library.promptClonedSuccess': '提示詞複製成功',
  'pages.library.cloneAuthorLabel': '作者：{author}',
  'pages.library.cloneAudienceLabel': '適用對象：{visibility}',
  'pages.library.undoChangesButton': '還原變更',
  'pages.library.saveChangesButton': '儲存變更',
  'pages.library.unsavedChangesTitle': '尚未儲存的變更',
  'pages.library.unsavedChangesContent': '您有尚未儲存的變更，確定要離開嗎？',
  'pages.library.exitModifyButton': '結束編輯',
  'pages.library.field.tags': '標籤',
  'pages.library.title': '提示詞庫',
  'pages.library.exitCompareButton': '結束比較',
  'pages.library.compareButton': '比較',
  'pages.library.addPromptModalTitle': '新增提示詞',
  'pages.library.addButton': '新增 +',
  'pages.library.tagsPlaceholder': '標籤清單',
  'pages.library.filterByFunctionPlaceholder': '依功能篩選',
  'pages.library.filterByAudiencePlaceholder': '依適用對象篩選',
  'pages.library.searchPlaceholder': '搜尋提示詞與標籤',
  'pages.library.favoriteOnly': '僅顯示我的最愛',
  'pages.library.filterByLabel': '篩選條件：',
  'pages.library.compareSelectHint': '請選擇兩個或三個要比較的提示詞',
  'pages.library.untitledPrompt': '未命名提示詞',
  'pages.library.compareLimitWarning': '最多只能比較 3 個提示詞',
  'pages.library.copyPromptButton': '複製提示詞',
  'pages.organisation.idColumnTitle': 'ID',
  'pages.organisation.untitledOrganisationFallback': '未命名機構',
  'pages.organisation.userLimitLabel': '使用者上限',
  'pages.organisation.userLimitUnlimitedCount': '{count} / 無上限',
  'pages.organisation.userLimitUnlimited': '無上限',
  'pages.organisation.userLimitOnly': '上限：{limit}',
  'pages.organisation.msTenantIdsLabel': 'MS 租用戶 ID',
  'pages.organisation.organisationsTableHeaderTitle': '機構',
  'pages.organisation.createOrganisationLabel': '建立機構',
  'pages.organisation.usersTableHeaderTitle': '{orgName} 使用者',
  'pages.organisation.defaultOrganisationName': '機構',
  'pages.organisation.userLimitReachedTooltip': '已達使用者上限',
  'pages.organisation.addUserButtonLabel': '新增使用者',
  'pages.organisation.usernameColumnTitle': '使用者名稱',
  'pages.organisation.emailColumnTitle': '電子郵件',
  'pages.organisation.roleLabel': '角色',
  'pages.organisation.defaultUserRoleLabel': '使用者',
  'pages.organisation.changeRoleButtonLabel': '變更角色',
  'pages.organisation.removeUserConfirmTitle': '要將此使用者移出機構嗎？',
  'pages.organisation.userRemovedSuccessMessage': '使用者已移除',
  'pages.organisation.unableToRemoveUserErrorMessage': '無法移除使用者',
  'pages.organisation.editOrganisationModalTitle': '編輯機構',
  'pages.organisation.organisationUpdatedSuccessMessage': '機構更新成功',
  'pages.organisation.organisationCreatedSuccessMessage': '機構建立成功',
  'pages.organisation.organisationNameRequiredMessage': '機構名稱為必填項目',
  'pages.organisation.organisationNameLabel': '機構名稱',
  'pages.organisation.userLimitTooltip': '允許的最大使用者數量。留空表示無上限。',
  'pages.organisation.msTenantIdsTooltip': '來自這些 Microsoft 租用戶 ID 的使用者可透過 SSO 登入。',
  'pages.organisation.userEmailLabel': '使用者電子郵件',
  'pages.organisation.userEmailPlaceholder': 'user@company.com',
  'pages.organisation.emailRequiredMessage': '電子郵件為必填項目',
  'pages.organisation.roleRequiredMessage': '角色為必填項目',
  'pages.organisation.userAddedSuccessMessage': '使用者已新增',
  'pages.organisation.unableToAddUserErrorMessage': '無法新增使用者',
  'pages.organisation.roleUpdatedSuccessMessage': '角色已更新',
  'pages.organisation.unableToUpdateRoleErrorMessage': '無法更新角色',
  'pages.organisation.unableToLoadRolesErrorMessage': '無法載入角色',
  'pages.playbook.header.title': 'Workstudio',
  'pages.playbook.emptyState.title': '隨時準備就緒。',
  'pages.playbook.emptyState.description': '可要求改寫、條款審閱、摘要，或進行特定修訂。',
  'pages.playbook.checkingDocument': '正在檢查文件...',
  'pages.playbook.updatingReviewCanvas': '正在更新審閱畫布...',
  'pages.playbook.inputPlaceholder': '告訴 A&GEL 要修改的內容...',
  'pages.playbook.inputAriaLabel': 'Workstudio 指令',
  'pages.playbook.contextButton': '內容參考',
  'pages.playbook.sendButtonAriaLabel': '傳送 Workstudio 指令',
  'pages.playbook.sendInstructionError': '傳送 Workstudio 指令失敗',
  'pages.projectsHub.func.chat': '對話',
  'pages.projectsHub.func.scribe': '記錄',
  'pages.projectsHub.func.apps': '應用程式',
  'pages.projectsHub.func.review': '審閱',
  'pages.projectsHub.func.sideBySide': '並排比對',
  'pages.projectsHub.func.comparison': '比較',
  'pages.projectsHub.func.translation': '翻譯',
  'pages.projectsHub.func.template': '自訂輸出',
  'pages.projectsHub.func.quote': '報價',
  'pages.projectsHub.untitledSession': '未命名',
  'pages.projectsHub.untitledFileLabel': '（未命名）',
  'pages.projectsHub.errors.loadDataFailed': '載入資料失敗',
  'pages.projectsHub.subfolderCreated': '已建立子資料夾',
  'pages.projectsHub.collectionCreated': '已建立collection',
  'pages.projectsHub.errors.createFailed': '建立失敗',
  'pages.projectsHub.errors.updateFailed': '更新失敗',
  'pages.projectsHub.deleteCollectionConfirm.title': '刪除Collection',
  'pages.projectsHub.deleteCollectionConfirm.content': '確定要刪除「{name}」嗎？',
  'pages.projectsHub.collectionDeleted': '已刪除',
  'pages.projectsHub.errors.deleteFailed': '刪除失敗',
  'pages.projectsHub.sessionsAdded': '已新增 {count} 個工作階段',
  'pages.projectsHub.errors.addSessionsFailed': '新增失敗',
  'pages.projectsHub.sessionRemoved': '已移除工作階段',
  'pages.projectsHub.errors.removeSessionFailed': '移除工作階段失敗',
  'pages.projectsHub.sessionsRemoved': '已移除 {count} 個工作階段',
  'pages.projectsHub.errors.removeSessionsFailed': '移除工作階段失敗',
  'pages.projectsHub.fieldSaved': '已儲存',
  'pages.projectsHub.errors.saveFieldFailed': '儲存失敗',
  'pages.projectsHub.folderDeleted': '資料夾已刪除',
  'pages.projectsHub.errors.deleteFolderFailed': '刪除資料夾失敗',
  'pages.projectsHub.folderCreated': '資料夾已建立',
  'pages.projectsHub.errors.createFolderFailed': '建立資料夾失敗',
  'pages.projectsHub.deleteFolderConfirm.description': '確定要刪除「{name}」及其所有內容嗎？',
  'pages.projectsHub.deleteSessionsConfirm.title': '刪除工作階段',
  'pages.projectsHub.removeSessionConfirm.title': '移除工作階段',
  'pages.projectsHub.removeSessionConfirm.description': '確定要從此collection中移除「{name}」嗎？',
  'pages.projectsHub.sort.newestFirst': '最新優先',
  'pages.projectsHub.sort.oldestFirst': '最舊優先',
  'pages.projectsHub.sort.nameAsc': '名稱（A-Z）',
  'pages.projectsHub.sort.nameDesc': '名稱（Z-A）',
  'pages.projectsHub.doubleClickToOpen': '按兩下以開啟',
  'pages.projectsHub.tidyUp': '整理',
  'pages.projectsHub.exit': '退出',
  'pages.projectsHub.manage': '管理',
  'pages.projectsHub.deleteSessionsButton': '刪除（{count}）',
  'pages.projectsHub.searchSessionsPlaceholder': '搜尋工作階段',
  'pages.projectsHub.emptyState.noFiles': '沒有檔案',
  'pages.projectsHub.newFolderButton': '新增資料夾',
  'pages.projectsHub.addSessionsButton': '新增工作階段',
  'pages.projectsHub.folderInfoLabel': '資料夾資訊',
  'pages.projectsHub.mattersHeading': '項目',
  'pages.projectsHub.hubBreadcrumbLabel': '中心',
  'pages.projectsHub.deleteFolderButton': '刪除資料夾',
  'pages.projectsHub.itemsLabel': '項目',
  'pages.projectsHub.selectSubfolderEmptyState': '選取子資料夾以檢視詳細資料',
  'pages.projectsHub.selectFolderEmptyState': '選取資料夾以檢視詳細資料',
  'pages.projectsHub.noCollectionsMatch': '沒有符合目前篩選條件的collection。',
  'pages.projectsHub.noSessionsFoundForFunction': '找不到{func}工作階段。',
  'pages.projectsHub.step1ChooseFunctionType': '步驟 1 — 選擇功能類型',
  'pages.projectsHub.selectFunctionPlaceholder': '選擇功能',
  'pages.projectsHub.step2SelectSessions': '步驟 2 — 選取要新增的工作階段',
  'pages.projectsHub.createFolderButton': '建立資料夾',
  'pages.projectsHub.folderNameLabel': '資料夾名稱',
  'pages.projectsHub.subfolderNamePlaceholder': '例如：盡職調查',
  'pages.projectsHub.collectionNamePlaceholder': '例如：併購盡職調查',
  'pages.projectsHub.optionalDescriptionPlaceholder': '選填說明',
  'pages.projectsHub.optionalNotesPlaceholder': '選填備註',
  'pages.projectsHub.createCollectionModalTitle': '建立Collection',
  'pages.projectsHub.collectionNameLabel': 'Collection名稱',
  'pages.projectsHub.editCollectionModalTitle': '編輯 • {name}',
  'pages.projectsHub.itemCountLabel': '{count, plural, other {# 個項目}}',
  'pages.projectsHub.fileCountLabel': '{count, plural, other {# 個檔案}}',
  'pages.quote.historyTooltip': '歷程記錄（Tab+H）',
  'pages.quote.hideTooltip': '隱藏（Tab+H）',
  'pages.quote.newQuoteTooltip': '新增報價（Tab+N）',
  'pages.quote.untitled': '（未命名）',
  'pages.quote.newQuote': '新增報價',
  'pages.quote.deletedExample': '已刪除範例',
  'pages.quote.generateDescription': '根據您的範本與事實產生報價',
  'pages.quote.sizeLabel': '長度',
  'pages.quote.sizeShort': '簡短',
  'pages.quote.sizeMedium': '中等',
  'pages.quote.sizeLong': '詳盡',
  'pages.quote.examplesLabel': '範例',
  'pages.quote.promptLabel': '提示',
  'pages.quote.examplesTitle': '範例',
  'pages.quote.quoteTitle': '報價',
  'pages.quote.uploadManageExamples': '上傳／管理範例',
  'pages.quote.generateQuoteSubtitle': '產生報價',
  'pages.quote.fileLabel': '檔案',
  'pages.quote.deleteConfirmTitle': '確定要刪除下列範例嗎？',
  'pages.review.addAtLeastOneQuestion': '提交前請至少新增一個問題。',
  'pages.review.addAtLeastOneQuestionFirst': '請先至少新增一個問題。',
  'pages.review.addAtLeastOneQuestionRule': '請至少新增一個問題',
  'pages.review.addQuestionButton': '問題',
  'pages.review.addSectionButton': '章節',
  'pages.review.addToMatters': '新增至項目',
  'pages.review.adhocModifyMode': '臨時修改',
  'pages.review.audiencePlaceholder': '客戶或目標對象名稱',
  'pages.review.authorLabel': '作者',
  'pages.review.categoryLabel': '類別',
  'pages.review.cellDetailsDrawer.addCommentPlaceholder': '新增備註...',
  'pages.review.cellDetailsDrawer.answer': '答案',
  'pages.review.cellDetailsDrawer.comments': '備註',
  'pages.review.cellDetailsDrawer.commentsWithCount': '備註（{count}）',
  'pages.review.cellDetailsDrawer.exactMatch': '在來源文件中找到完全相符的內容',
  'pages.review.cellDetailsDrawer.explanation': '說明',
  'pages.review.cellDetailsDrawer.fullReference': '完整參考資料',
  'pages.review.cellDetailsDrawer.fuzzyMatch': '在來源文件中找到近似相符的內容',
  'pages.review.cellDetailsDrawer.openDocument': '開啟文件',
  'pages.review.cellDetailsDrawer.openInSearch': '在搜尋中開啟',
  'pages.review.cellDetailsDrawer.verified': '已驗證',
  'pages.review.cellDetailsDrawer.verify': '驗證',
  'pages.review.cellMarkedUnverified': '已將儲存格標示為未驗證',
  'pages.review.cellMarkedVerified': '已將儲存格標示為已驗證',
  'pages.review.cellUpdateFailed': '更新儲存格失敗',
  'pages.review.cellUpdatedSuccessfully': '儲存格更新成功',
  'pages.review.cellVerificationUpdateFailed': '更新儲存格驗證狀態失敗',
  'pages.review.changesUndone': '已復原變更',
  'pages.review.chatWithEntireOutput': '與整份輸出對話',
  'pages.review.cloneButton': '複製',
  'pages.review.clonedNamePrefix': '已複製 - {name}',
  'pages.review.columnEditModal.addTitle': '新增文件（欄）',
  'pages.review.columnEditModal.columnUpdated': '欄位更新已開始，欄位將於稍後重新整理。',
  'pages.review.columnEditModal.columnsAdded': '已新增欄位，矩陣將於稍後重新整理。',
  'pages.review.columnEditModal.dropToUpload': '將檔案拖曳至此以上傳',
  'pages.review.columnEditModal.fileRequired': '請上傳或選取要用於此欄位的檔案。',
  'pages.review.columnEditModal.filesRequiredValidation': '請上傳檔案或選取現有檔案',
  'pages.review.columnEditModal.updateFailed': '更新欄位失敗',
  'pages.review.columnEditModal.updateTitle': '此欄位的新文件',
  'pages.review.createQuestionListButton': '建立問題清單',
  'pages.review.createdByYou': '您',
  'pages.review.customInstruction': '自訂指示',
  'pages.review.customInstructionOptional': '自訂指示（選填）',
  'pages.review.deleteQuestionListConfirm': '確定要刪除此問題清單嗎？',
  'pages.review.downloadExcel': 'Excel（.xlsx）',
  'pages.review.downloadWord': 'Word 文件 (.docx)',
  'pages.review.dragHereToUpload': '拖曳至此處上傳',
  'pages.review.exitButton': '退出',
  'pages.review.exitClone': '退出複製',
  'pages.review.exitCreate': '退出建立',
  'pages.review.exitModify': '退出修改',
  'pages.review.fileCount': '{count} 個檔案',
  'pages.review.mattersUpdateFailed': '更新項目失敗',
  'pages.review.mattersUpdated': '項目更新成功',
  'pages.review.modifyButton': '修改',
  'pages.review.newCategoryPlaceholder': '新類別',
  'pages.review.newQuestionListDefaultName': '新增審查問題清單',
  'pages.review.noEmailOnFile': '無登記電子郵件',
  'pages.review.noNotesAvailable': '無可用備註。',
  'pages.review.noPrivateGroupsFound': '找不到私人群組',
  'pages.review.noPurposeAvailable': '無可用目的。',
  'pages.review.noQuestionsYet': '尚無問題。',
  'pages.review.notesLabel': '備註',
  'pages.review.pendingApproval': '待核准',
  'pages.review.pollingTimeout': '輪詢逾時。審查可能仍在處理中。',
  'pages.review.publishButton': '發佈',
  'pages.review.publishFailed': '發佈問題清單失敗',
  'pages.review.publishTargetFirm': '全事務所',
  'pages.review.publishToLabel': '發佈至：',
  'pages.review.publishedAccess.firm': '事務所',
  'pages.review.publishedAccess.privateGroup': '私人群組',
  'pages.review.publishedAccess.public': '公開',
  'pages.review.publishedToLabel': '已發佈至 {access}',
  'pages.review.publishedToPrivateGroup': '問題清單已發佈至私人群組',
  'pages.review.publishedToPrivateGroups': '問題清單已發佈至多個私人群組',
  'pages.review.purposeLabel': '目的',
  'pages.review.questionListCloned': '問題清單複製成功',
  'pages.review.questionListCreated': '問題清單建立成功',
  'pages.review.questionListDeleted': '問題清單刪除成功',
  'pages.review.questionListImporter.allColumns': '所有欄位（合併每個儲存格）',
  'pages.review.questionListImporter.checklistText': '檢查清單文字',
  'pages.review.questionListImporter.columnOption': '欄位 {index} - {label}',
  'pages.review.questionListImporter.couldNotParse': '無法解析檢查清單。',
  'pages.review.questionListImporter.couldNotReadFile': '無法讀取 {fileName}。',
  'pages.review.questionListImporter.docxColumn': 'DOCX 欄位',
  'pages.review.questionListImporter.dropZoneText': '點選或拖曳檢查清單至此區域',
  'pages.review.questionListImporter.granularityEveryLine': '每行為一個問題',
  'pages.review.questionListImporter.granularityLevel2': '至第 2 層',
  'pages.review.questionListImporter.granularityLevel3': '至第 3 層',
  'pages.review.questionListImporter.granularityLevel4': '至第 4 層',
  'pages.review.questionListImporter.granularityLevel5': '至第 5 層',
  'pages.review.questionListImporter.granularityTopLevel': '僅頂層',
  'pages.review.questionListImporter.groupByLevel': '依層級將問題分組',
  'pages.review.questionListImporter.importQuestions': '匯入問題',
  'pages.review.questionListImporter.importQuestionsAction': '匯入問題',
  'pages.review.questionListImporter.loadedFile': '已載入 {fileName}',
  'pages.review.questionListImporter.noQuestionsDetected': '檢查清單中未偵測到任何問題。',
  'pages.review.questionListImporter.noQuestionsSelected': '尚未選擇要匯入的問題。',
  'pages.review.questionListImporter.pasteOrSelectRequired': '請先貼上或選擇檢查清單，再進行預覽。',
  'pages.review.questionListImporter.previewQuestions': '預覽問題',
  'pages.review.questionListImporter.questionGranularity': '問題細分程度',
  'pages.review.questionListImporter.readingChecklist': '正在讀取檢查清單...',
  'pages.review.questionListImporter.removeFile': '移除檔案',
  'pages.review.questionListImporter.removeQuestion': '移除問題 {number}',
  'pages.review.questionListImporter.removeQuestionsHint': '請移除任何您不想匯入的問題。',
  'pages.review.questionListImporter.reviewQuestions': '檢閱問題',
  'pages.review.questionListNamePlaceholder': '審查問題清單名稱',
  'pages.review.questionListUpdated': '問題清單更新成功',
  'pages.review.questionNamePlaceholder': '問題',
  'pages.review.questionRow.dragToReorder': '拖曳以重新排序',
  'pages.review.questionRow.moveDown': '下移',
  'pages.review.questionRow.moveUp': '上移',
  'pages.review.questionRow.rowType': '行類型',
  'pages.review.questionsList': '問題清單',
  'pages.review.quickQuestionsDescription': '根據一組臨時問題，為一份或多份文件產生結構化審查',
  'pages.review.quickQuestionsHeading': '快速提問',
  'pages.review.rejected': '已拒絕',
  'pages.review.resizeHint': '拖曳邊框以調整大小。',
  'pages.review.restoreConfigFailed': '還原設定失敗，請再試一次。',
  'pages.review.resultPanel.processing': '處理中',
  'pages.review.resultPanel.stopped': '處理已停止。',
  'pages.review.reuseButton': '重複使用',
  'pages.review.rowEditModal.addTitle': '新增問題（列）',
  'pages.review.rowEditModal.promptLabel': '提示',
  'pages.review.rowEditModal.promptRequired': '請輸入提示。',
  'pages.review.rowEditModal.rowAdded': '已新增列，矩陣即將重新整理。',
  'pages.review.rowEditModal.rowUpdated': '列更新已開始，此列即將重新整理。',
  'pages.review.rowEditModal.updateFailed': '更新列失敗',
  'pages.review.rowEditModal.updateTitle': '更新問題提示',
  'pages.review.saveAsButton': '另存為',
  'pages.review.saveChangesButton': '儲存變更',
  'pages.review.searchMattersPlaceholder': '搜尋項目...',
  'pages.review.sectionNamePlaceholder': '章節標題',
  'pages.review.selectCellHint': '點選儲存格、列或欄以選取。',
  'pages.review.selectDocumentsToReview': '請選擇您要進行審查的文件',
  'pages.review.selectDocumentsToReviewNumbered': '2. 請選擇您要進行審查的文件',
  'pages.review.selectMatters': '選擇項目：',
  'pages.review.selectPrivateGroupsHint': '選擇一個或多個要共用的私人群組：',
  'pages.review.selectPrivateGroupsPlaceholder': '選擇私人群組',
  'pages.review.sentForApproval': '問題清單已送出核准',
  'pages.review.sentimentLegendPrefix': '圖例：AI 的情緒判斷：',
  'pages.review.sentimentNegative': '負面',
  'pages.review.sentimentPositive': '正面',
  'pages.review.showAll': '顯示全部',
  'pages.review.startNewReview': '開始新審查',
  'pages.review.stayButton': '留在此頁',
  'pages.review.submitReviewFailed': '提交審查失敗',
  'pages.review.systemPromptLabel': '系統提示',
  'pages.review.tabs.customiseOptional': '自訂（選填）',
  'pages.review.tabs.prompts': '提示',
  'pages.review.tabs.selectDocuments': '選擇文件',
  'pages.review.tabs.startHere': '從此處開始',
  'pages.review.typeHerePlaceholder': '請在此輸入...',
  'pages.review.undoChangesButton': '復原變更',
  'pages.review.unsavedChangesWillBeLost': '任何未儲存的變更將會遺失。',
  'pages.review.untitledSession': '（未命名）',
  'pages.review.updateFailed': '更新失敗',
  'pages.review.viewMode': '檢視',
  'pages.review.whatsNewDescription': '推出多項新功能，提升您的文件審查流程。',
  'pages.review.whoIsItFor': '適用對象？',
  'pages.review.whoIsItForNumbered': '1. 適用對象？',
  'pages.scribe.addToMatters': '加入項目',
  'pages.scribe.aiWorking': 'AI 處理中...',
  'pages.scribe.appDescription': '將音訊檔案或錄音轉錄為結構化文字。',
  'pages.scribe.audioUploadFailedSavingOnly': '音訊檔案上傳失敗，僅儲存逐字稿',
  'pages.scribe.audioUploadSuccess': '音訊檔案上傳成功',
  'pages.scribe.autoDetect': '自動偵測',
  'pages.scribe.autoGenerateFailed': '自動產生所選輸出項目失敗',
  'pages.scribe.autoRecordingName': '錄音 {timestamp}',
  'pages.scribe.autoSavedNote': '已於 {relative} 自動儲存（{time}）',
  'pages.scribe.convertingEllipsis': '轉換中...',
  'pages.scribe.customLanguageFallback': '自訂',
  'pages.scribe.deleteConfirm.content': '確定要刪除此逐字稿嗎？',
  'pages.scribe.deleteConfirm.title': '刪除逐字稿',
  'pages.scribe.deleteTranscriptFailed': '刪除逐字稿失敗',
  'pages.scribe.discardChangesConfirm.cancelText': '繼續編輯',
  'pages.scribe.discardChangesConfirm.content': '您有尚未儲存的變更，是否要捨棄？',
  'pages.scribe.discardChangesConfirm.okText': '捨棄',
  'pages.scribe.discardChangesConfirm.title': '捨棄變更？',
  'pages.scribe.downloadAudio': '下載音訊',
  'pages.scribe.downloadFailed': '下載失敗',
  'pages.scribe.downloadScript': '下載逐字稿',
  'pages.scribe.downloadStarted': '已開始下載',
  'pages.scribe.downloadingAudio': '正在下載音訊...',
  'pages.scribe.enterTranscriptNamePlaceholder': '輸入逐字稿名稱',
  'pages.scribe.errors.authTokenFailed': '取得驗證權杖失敗',
  'pages.scribe.errors.startRecordingFailed': '開始錄音失敗',
  'pages.scribe.exitRecordingConfirm.cancelText': '繼續錄音',
  'pages.scribe.exitRecordingConfirm.content': '逐字稿將不會被儲存。',
  'pages.scribe.exitRecordingConfirm.okText': '退出錄音',
  'pages.scribe.exitRecordingConfirm.title': '退出錄音？',
  'pages.scribe.exitRecordingPopconfirm.description': '退出錄音？逐字稿將不會被儲存。',
  'pages.scribe.fastForward10': '快轉 10 秒',
  'pages.scribe.fileUploadFailed': '{fileName} 檔案上傳失敗。',
  'pages.scribe.fileUploadSuccess': '檔案上傳成功，開始處理。',
  'pages.scribe.generateButton': '產生',
  'pages.scribe.generationFailedRetryText': '產生失敗，請重新產生。',
  'pages.scribe.generationStarted': '已開始產生',
  'pages.scribe.historyButton': '歷史紀錄',
  'pages.scribe.homeButton': '首頁',
  'pages.scribe.initializingTranscription': '正在初始化轉錄...',
  'pages.scribe.interruptedModal.okText': '檢視逐字稿',
  'pages.scribe.interruptedModal.title': '錄音已中斷',
  'pages.scribe.langGroup.custom': '自訂',
  'pages.scribe.langGroup.everythingElse': '其他語言',
  'pages.scribe.langGroup.otherOption': '其他…',
  'pages.scribe.langGroup.preferred': '偏好語言',
  'pages.scribe.langGroup.seaEastAsian': '東南亞及東亞語言',
  'pages.scribe.languageSelector.addLanguageButton': '新增語言',
  'pages.scribe.languageSelector.customPlaceholder': '輸入語言（例如：馬來語）',
  'pages.scribe.liveTranslationLabel': '即時翻譯',
  'pages.scribe.loadingAudio': '正在載入音訊...',
  'pages.scribe.mattersUpdatedSuccess': '項目已成功更新',
  'pages.scribe.modeNotGenerated': '尚未產生 {modeLabel}',
  'pages.scribe.nameYourTranscriptPlaceholder': '為您的逐字稿命名',
  'pages.scribe.newRecordingTitle': '新錄音',
  'pages.scribe.newTranscript': '新逐字稿',
  'pages.scribe.newTranscriptName': '新逐字稿 {timestamp}',
  'pages.scribe.noAudioFileAvailable': '沒有可用的音訊檔案。',
  'pages.scribe.noAudioForDownload': '沒有可供下載的音訊檔案。',
  'pages.scribe.noContentAvailable': '沒有可用內容，請重新產生。',
  'pages.scribe.noOutputsGenerated': '未產生任何輸出結果',
  'pages.scribe.noRecentRecordings': '尚無最近的錄音。',
  'pages.scribe.noSegmentsToEdit': '沒有可供編輯的段落',
  'pages.scribe.noTimestampedSegments': '沒有含時間戳記的逐字稿段落。',
  'pages.scribe.notAvailable': '無資料',
  'pages.scribe.optionEmailDrafts': '電子郵件草稿',
  'pages.scribe.outputNotGeneratedYet': '此輸出結果尚未產生。',
  'pages.scribe.outputViewer.actionItemsLabel': '待辦事項',
  'pages.scribe.outputViewer.addActionItemButton': '新增待辦事項',
  'pages.scribe.outputViewer.columnAction': '行動',
  'pages.scribe.outputViewer.columnAssignee': '負責人',
  'pages.scribe.outputViewer.columnDueDate': '截止日期',
  'pages.scribe.outputViewer.columnTask': '任務',
  'pages.scribe.outputViewer.commaSeparatedNamesPlaceholder': '以逗號分隔多個姓名',
  'pages.scribe.outputViewer.fieldBody': '內文',
  'pages.scribe.outputViewer.fieldCategory': '類別',
  'pages.scribe.outputViewer.fieldCleanedTranscript': '整理後逐字稿',
  'pages.scribe.outputViewer.fieldExecutiveSummary': '重點摘要',
  'pages.scribe.outputViewer.fieldGeneratedTitle': '產生的標題',
  'pages.scribe.outputViewer.fieldKeyDecisions': '關鍵決議',
  'pages.scribe.outputViewer.fieldNextMeeting': '下次會議',
  'pages.scribe.outputViewer.fieldParticipants': '與會人員',
  'pages.scribe.outputViewer.fieldRecipients': '收件人',
  'pages.scribe.outputViewer.fieldSignatureBlock': '簽名檔',
  'pages.scribe.outputViewer.fieldSubject': '主旨',
  'pages.scribe.outputViewer.fieldTopic': '主題',
  'pages.scribe.outputViewer.generatingContent': '正在產生內容...',
  'pages.scribe.outputViewer.generationFailed': '產生失敗',
  'pages.scribe.outputViewer.onePerLinePlaceholder': '每行一項',
  'pages.scribe.outputViewer.pleaseCheckFields': '請檢查欄位內容',
  'pages.scribe.outputViewer.titleDefault': '輸出結果',
  'pages.scribe.outputViewer.titleEmailDraft': '電子郵件草稿',
  'pages.scribe.outputViewer.titleMeetingNotes': '會議紀錄',
  'pages.scribe.outputViewer.titleVoiceMemo': '語音備忘錄',
  'pages.scribe.outputViewer.unknownOutputType': '未知的輸出類型',
  'pages.scribe.pauseRecordingTitle': '暫停錄音',
  'pages.scribe.recentRecordingsTitle': '最近的錄音',
  'pages.scribe.recentlyTranscribed': '最近轉錄',
  'pages.scribe.recordingInProgressWarning': '您目前正在錄音，請先停止錄音再切換工作階段',
  'pages.scribe.recordingPaused': '錄音已暫停',
  'pages.scribe.recordingPausedInline': '錄音已暫停',
  'pages.scribe.regenerateButton': '重新產生',
  'pages.scribe.resumeRecordingTitle': '繼續錄音',
  'pages.scribe.retranslatingSegments': '正在重新翻譯已編輯的段落...',
  'pages.scribe.fillingMissingTranslations': '正在翻譯缺少的段落...',
  'pages.scribe.rewind10': '倒轉 10 秒',
  'pages.scribe.saveEditsFailed': '儲存逐字稿編輯失敗',
  'pages.scribe.saveFailed': '儲存失敗',
  'pages.scribe.saveTranscriptFailed': '儲存逐字稿失敗',
  'pages.scribe.saveTranscriptModalTitle': '儲存逐字稿',
  'pages.scribe.saveTranscriptTitle': '儲存逐字稿',
  'pages.scribe.savedSuccessfully': '已成功儲存',
  'pages.scribe.savingTranscript': '正在儲存逐字稿...',
  'pages.scribe.scribeTitle': '錄音',
  'pages.scribe.scrollToBottom': '捲動至底部',
  'pages.scribe.searchMattersPlaceholder': '搜尋項目...',
  'pages.scribe.searchTranscriptsPlaceholder': '搜尋逐字稿',
  'pages.scribe.segmentTranslationFailed': '段落翻譯失敗',
  'pages.scribe.selectMattersLabel': '選擇項目：',
  'pages.scribe.startGenerationFailed': '啟動產生程序失敗',
  'pages.scribe.startTranscriptionFailed': '啟動轉錄程序失敗',
  'pages.scribe.status.clickMicToStart': '點擊麥克風圖示以開始錄音',
  'pages.scribe.status.defaultDescription': '將音訊檔案或錄音轉錄為結構化文字',
  'pages.scribe.status.processingFile': '正在處理檔案...{stage}',
  'pages.scribe.status.queued': '排隊中',
  'pages.scribe.status.transcriptionCancelled': '轉錄已取消',
  'pages.scribe.status.transcriptionCompleted': '轉錄已完成',
  'pages.scribe.status.transcriptionFailed': '轉錄失敗',
  'pages.scribe.stopRecordingConfirm.cancelText': '留在此頁',
  'pages.scribe.stopRecordingConfirm.okText': '離開頁面',
  'pages.scribe.stopRecordingConfirm.title': '是否停止錄音？',
  'pages.scribe.stopRecordingSaveTitle': '停止錄音並儲存',
  'pages.scribe.tabs.emailDraft': '電子郵件草稿',
  'pages.scribe.tabs.meetingNotes': '會議紀錄',
  'pages.scribe.tabs.rawTranscript': '原始逐字稿',
  'pages.scribe.tabs.voiceMemo': '語音備忘錄',
  'pages.scribe.transcriptDeleted': '逐字稿已刪除',
  'pages.scribe.transcriptEmpty': '逐字稿為空',
  'pages.scribe.transcriptNameUpdated': '逐字稿名稱已更新',
  'pages.scribe.transcriptSavedSuccess': '逐字稿已成功儲存',
  'pages.scribe.transcriptUpdated': '逐字稿已更新',
  'pages.scribe.transcriptionFailedDesc': 'Scribe 無法轉錄此音訊。請嘗試下載音訊檔案後重新上傳。',
  'pages.scribe.transcriptionFailedTitle': '轉錄失敗',
  'pages.scribe.transcriptionLanguageQuestion': '轉錄應使用哪種語言？',
  'pages.scribe.transcriptionPurposeQuestion': '此逐字稿的用途為何？',
  'pages.scribe.translatingEllipsis': '正在翻譯...',
  'pages.scribe.increaseTranslationSize': '放大翻譯文字',
  'pages.scribe.decreaseTranslationSize': '縮小翻譯文字',
  'pages.scribe.translationTextSize': '翻譯文字大小',
  'pages.scribe.unassigned': '未指派',
  'pages.scribe.unnamedTranscript': '未命名逐字稿',
  'pages.scribe.untitled': '未命名',
  'pages.scribe.untitledParens': '（未命名）',
  'pages.scribe.untitledTranscript': '未命名逐字稿',
  'pages.scribe.updateMattersFailed': '更新項目失敗',
  'pages.scribe.updateNameFailed': '更新逐字稿名稱失敗',
  'pages.scribe.updateTranscriptNameTitle': '更新逐字稿名稱',
  'pages.scribe.uploadRecordingButton': '上傳錄音',
  'pages.scribe.uploadingAudioFile': '正在上傳音訊檔案...',
  'pages.scribe.waitingEllipsis': '等待中...',
  'pages.scribe.waitingForTranslations': '正在等待翻譯完成...',
  'pages.scribe.whatsNew': '最新功能',
  'pages.scribe.whatsNew.filteringSortingDesc': '改進使用者介面，讓您更輕鬆管理與尋找逐字稿。',
  'pages.scribe.whatsNew.filteringSortingLabel': '篩選與排序：',
  'pages.scribe.whatsNew.guidanceTabsDesc': '輕鬆找到開始使用或探索新功能的操作說明。',
  'pages.scribe.whatsNew.guidanceTabsLabel': '指南分頁：',
  'pages.scribe.whatsNew.intro': '我們已強化 Scribe，帶來更流暢的轉錄體驗：',
  'pages.scribe.whatsNew.upcomingFeaturesTitle': '即將推出的功能',
  'pages.search.chunkCopiedSuccess': '區塊已複製！',
  'pages.search.chunkCopyFailed': '複製區塊失敗',
  'pages.search.searchRatioLabel': '搜尋比例',
  'pages.search.favouriteFileWeightLabel': '常用檔案權重',
  'pages.search.rerankLabel': '重新排序',
  'pages.search.filePreviewAlt': '檔案預覽',
  'pages.search.previewNotSupported': '此檔案類型不支援預覽',
  'pages.search.chunkPageLabel': '頁碼：{pageNumber}',
  'pages.search.matchPercentage': '符合度 {score}%',
  'pages.search.openChunkAriaLabel': '開啟區塊 {index}',
  'pages.search.navigateResultsTitle': '瀏覽結果',
  'pages.search.loadingChunkResults': '正在載入區塊結果...',
  'pages.search.chunkResultCount': '{count, plural, other {個區塊結果}}',
  'pages.search.previousResultTitle': '上一個結果',
  'pages.search.nextResultTitle': '下一個結果',
  'pages.search.chatWithDocumentButton': '與此文件對話',
  'pages.search.searchWithinDocumentPlaceholder': '在文件中搜尋...',
  'pages.search.filterDownLabel': '縮小篩選範圍',
  'pages.search.documentPreviewTitle': '文件預覽',
  'pages.search.askAgelPlaceholder': '詢問 A&GEL',
  'pages.search.searchAllButton': '搜尋全部',
  'pages.search.advancedSettingsButton': '進階設定',
  'pages.search.allTagsOption': ' 所有標籤',
  'pages.sideBySide.addAtLeastOneQuestion': '請至少新增一個問題',
  'pages.sideBySide.addAtLeastOneQuestionBeforeSubmitting': '請在提交前至少新增一個問題。',
  'pages.sideBySide.addNewQuestionsPlaceholder': '新增問題（每行一個）',
  'pages.sideBySide.addPlusButton': '新增 +',
  'pages.sideBySide.addQuestionsLabel': '新增問題',
  'pages.sideBySide.addToMattersButton': '新增至項目',
  'pages.sideBySide.authorFieldLabel': '作者',
  'pages.sideBySide.authorLabel': '作者：',
  'pages.sideBySide.categoryLabel': '類別',
  'pages.sideBySide.cellDetails.answer': '答案',
  'pages.sideBySide.cellDetails.verified': '已驗證',
  'pages.sideBySide.cellDetails.verify': '驗證',
  'pages.sideBySide.cellMarkedUnverified': '儲存格已標記為未驗證',
  'pages.sideBySide.cellMarkedVerified': '儲存格已標記為已驗證',
  'pages.sideBySide.cellUpdatedSuccess': '儲存格已成功更新',
  'pages.sideBySide.changesUndone': '變更已復原',
  'pages.sideBySide.clickOrDragToUpload': '點擊或拖曳以上傳',
  'pages.sideBySide.cloneButton': '複製',
  'pages.sideBySide.cloneModeLabel': '複製',
  'pages.sideBySide.clonedNamePrefix': '已複製 - {name}',
  'pages.sideBySide.columnEditModal.columnAddedSuccess': '已新增欄位，矩陣將稍後重新整理。',
  'pages.sideBySide.columnEditModal.enterPromptWarning': '請輸入提示內容。',
  'pages.sideBySide.columnEditModal.promptLabel': '提示',
  'pages.sideBySide.columnEditModal.promptPlaceholder': '描述此欄位的提示／系統指令',
  'pages.sideBySide.columnEditModal.title': '修改欄位',
  'pages.sideBySide.columnEditModal.updateColumnFailed': '更新欄位失敗',
  'pages.sideBySide.createCustomQuestionListDescription': '為此工作階段建立自訂的並排比較問題清單',
  'pages.sideBySide.createModeLabel': '建立',
  'pages.sideBySide.createQuestionListButton': '建立問題清單',
  'pages.sideBySide.createdByLabel': '建立者：',
  'pages.sideBySide.createdByYou': '您',
  'pages.sideBySide.customInstructionOptional': '2. 自訂指令（選填）',
  'pages.sideBySide.deleteQuestionListConfirm': '您確定要刪除此問題清單嗎？',
  'pages.sideBySide.dragHereToUpload': '拖曳至此以上傳',
  'pages.sideBySide.emailButton': '電子郵件',
  'pages.sideBySide.exitButton': '離開',
  'pages.sideBySide.exitModeButton': '離開 {mode}',
  'pages.sideBySide.fileCount': '{count} 個檔案',
  'pages.sideBySide.firmOption': '事務所',
  'pages.sideBySide.firmWideOption': '全事務所',
  'pages.sideBySide.fromDocumentOption': '來自文件',
  'pages.sideBySide.groupOption': '群組',
  'pages.sideBySide.leadRowHeader': '來源文件段落',
  'pages.sideBySide.manualCraftOption': '手動製作',
  'pages.sideBySide.modifyButton': '修改',
  'pages.sideBySide.modifyModeLabel': '修改',
  'pages.sideBySide.newCategoryPlaceholder': '新類別',
  'pages.sideBySide.newQuestionListButtonLabel': '新增並排比較問題清單',
  'pages.sideBySide.newQuestionListDefaultName': '新的並排比較問題清單',
  'pages.sideBySide.noNotesAvailable': '無可用備註。',
  'pages.sideBySide.noPurposeAvailable': '無可用用途說明。',
  'pages.sideBySide.noSystemPromptConfigured': '尚未設定系統提示。',
  'pages.sideBySide.notesFieldLabel': '備註',
  'pages.sideBySide.notesLabel': '備註：',
  'pages.sideBySide.pendingApprovalTag': '待審核',
  'pages.sideBySide.pollingTimeoutWarning': '輪詢逾時。並排比較可能仍在處理中。',
  'pages.sideBySide.processing': '處理中',
  'pages.sideBySide.processingStopped': '處理已停止。',
  'pages.sideBySide.publicOption': '公開',
  'pages.sideBySide.publishButton': '發布',
  'pages.sideBySide.publishQuestionListFailed': '發布問題清單失敗',
  'pages.sideBySide.publishStatusLabel': '發布狀態',
  'pages.sideBySide.publishToLabel': '發布至：',
  'pages.sideBySide.publishedToAccess': '已發布至 {access}',
  'pages.sideBySide.publishedToGroupSuccess': '問題清單已發布至群組',
  'pages.sideBySide.publishedToPrivateGroups': '問題清單已發布至私人群組',
  'pages.sideBySide.publisherLabel': '發布者：',
  'pages.sideBySide.purposeFieldLabel': '用途',
  'pages.sideBySide.purposeLabel': '用途：',
  'pages.sideBySide.questionListClonedSuccess': '問題清單已成功複製',
  'pages.sideBySide.questionListCreatedSuccess': '問題清單已成功建立',
  'pages.sideBySide.questionListDeletedSuccess': '問題清單已成功刪除',
  'pages.sideBySide.questionListNamePlaceholder': '並排比較問題清單名稱',
  'pages.sideBySide.questionListUpdatedSuccess': '問題清單已成功更新',
  'pages.sideBySide.questionsListLabel': '問題清單',
  'pages.sideBySide.quickQuestionsTitle': '快速提問',
  'pages.sideBySide.rejectedTag': '已拒絕',
  'pages.sideBySide.restoreConfigurationFailed': '還原設定失敗，請再試一次。',
  'pages.sideBySide.reuseButton': '重複使用',
  'pages.sideBySide.reviewTemplateQuestionsDescription': '檢視此範本的問題',
  'pages.sideBySide.saveChangesButton': '儲存變更',
  'pages.sideBySide.selectDocumentDescription': '選擇您要進行並排比較的文件',
  'pages.sideBySide.selectGroupsPlaceholder': '選擇群組',
  'pages.sideBySide.selectGroupsToShareDescription': '選擇一個或多個要分享的群組：',
  'pages.sideBySide.selectionDescription': '根據您的問題清單，為一份或多份文件產生結構化並排比較',
  'pages.sideBySide.selectionFeatureName': '並排比較',
  'pages.sideBySide.selectionTitle': '並排比較',
  'pages.sideBySide.sentForApprovalSuccess': '問題清單已送出審核',
  'pages.sideBySide.showQuestionsButton': '顯示問題',
  'pages.sideBySide.startGenerateReview': '開始產生審閱',
  'pages.sideBySide.startNewSideBySideButton': '開始新的並排比較',
  'pages.sideBySide.stayButton': '留在此頁',
  'pages.sideBySide.submitFailed': '提交並排比較失敗',
  'pages.sideBySide.systemPromptLabel': '系統提示',
  'pages.sideBySide.tabs.prompts': '提示',
  'pages.sideBySide.tabs.questionList': '問題清單',
  'pages.sideBySide.tabs.selectDocuments': '選擇文件',
  'pages.sideBySide.targetAudiencePlaceholder': '客戶或目標受眾名稱',
  'pages.sideBySide.teamsButton': '團隊',
  'pages.sideBySide.templateSystemPromptLabel': '範本系統提示',
  'pages.sideBySide.tour.step1.title': '選擇問題清單',
  'pages.sideBySide.tour.step2.description': '輸入目標受眾或客戶名稱，然後選擇您要並排比較的文件。',
  'pages.sideBySide.tour.step2.title': '填寫目標受眾並選擇檔案',
  'pages.sideBySide.tour.step3.title': '檢視系統提示與問題',
  'pages.sideBySide.tour.step4.title': '檢視並排比較結果',
  'pages.sideBySide.typeHerePlaceholder': '在此輸入...',
  'pages.sideBySide.undoChangesButton': '復原變更',
  'pages.sideBySide.unsavedChangesWillBeLost': '任何未儲存的變更都將遺失。',
  'pages.sideBySide.untitled': '（未命名）',
  'pages.sideBySide.updateCellFailed': '更新儲存格失敗',
  'pages.sideBySide.updateCellVerificationFailed': '更新儲存格驗證狀態失敗',
  'pages.sideBySide.updateFailed': '更新失敗',
  'pages.sideBySide.uploadDocumentFailed': '上傳文件失敗',
  'pages.sideBySide.whatsNewDescription': '我們新增了多項功能，提升您的文件並排比對流程。',
  'pages.sideBySide.whoIsItForQuestion': '1. 適用對象？',
  'pages.template.waitingMessage.justAMoment': '請稍候...',
  'pages.template.waitingMessage.fetchingThatForYou': '正在為您擷取資料...',
  'pages.template.waitingMessage.hangTight': '請稍候，我正在處理...',
  'pages.template.waitingMessage.letMeCheck': '讓我確認一下...',
  'pages.template.waitingMessage.oneSecPlease': '請稍等片刻...',
  'pages.template.waitingMessage.lookingThatUp': '正在為您查詢...',
  'pages.template.waitingMessage.almostThere': '即將完成...',
  'pages.template.waitingMessage.holdOnRetrieving': '請稍候，我正在擷取資訊...',
  'pages.template.waitingMessage.workingOnIt': '處理中...',
  'pages.template.dragDropUpload': '拖曳至此以上傳',
  'pages.template.uploadInvalidFileTypes': '請僅上傳 PDF、DOC、DOCX、MSG、EML、TXT 或 MD 檔案',
  'pages.template.fileUploadedSuccess': '{fileName} 上傳成功',
  'pages.template.fileUploadFailed': '{fileName} 上傳失敗',
  'pages.template.loadTemplateDetailsFailed': '載入範本詳細資料失敗',
  'pages.template.viewLess': '顯示較少',
  'pages.template.viewAll': '顯示全部',
  'pages.template.tour.step1Title': '選擇自訂輸出範本',
  'pages.template.tour.step1Description': '從可用類別中選擇範本預設集，開始使用。',
  'pages.template.tour.step2Title': '選取要分析的檔案',
  'pages.template.tour.step2Description': '上傳或選取您要執行自訂輸出的文件。',
  'pages.template.tour.step3Title': '檢視提示與說明',
  'pages.template.tour.step3Description': '在此提供目標受眾資訊及選填的自訂指示。',
  'pages.template.tour.step4Title': '檢視結果',
  'pages.template.tour.step4Description': '送出後，產生的自訂輸出將顯示於此區域。',
  'pages.template.noSessionsFound': '找不到範本工作階段，請執行一次以查看結果。',
  'pages.template.startNewCustomOutput': '開始新的自訂輸出',
  'pages.template.untitled': '（未命名）',
  'pages.template.newSession': '新工作階段',
  'pages.template.fileCount': '{count} 個檔案',
  'pages.template.reuseButton': '重複使用',
  'pages.template.addToMattersButton': '加入至項目',
  'pages.template.startFillingTemplates': '開始填寫範本',
  'pages.template.unsavedChangesWarning': '任何未儲存的變更將會遺失。',
  'pages.template.stayButton': '留在此頁',
  'pages.template.exitButton': '離開',
  'pages.template.undoChangesButton': '復原變更',
  'pages.template.changesUndoneMessage': '已復原變更',
  'pages.template.templateCreatedSuccess': '範本建立成功',
  'pages.template.templateUpdatedSuccess': '範本更新成功',
  'pages.template.fillRequiredFields': '請填寫所有必填欄位',
  'pages.template.saveTemplateFailed': '儲存範本失敗',
  'pages.template.createTemplateButton': '建立範本',
  'pages.template.saveTemplateButton': '儲存範本',
  'pages.template.presetNamePlaceholder': '自訂範本預設集名稱',
  'pages.template.categoryLabel': '類別',
  'pages.template.newCategoryPlaceholder': '新類別',
  'pages.template.addCategoryButton': '新增類別',
  'pages.template.purposeLabel': '用途',
  'pages.template.notesLabel': '備註',
  'pages.template.systemPromptLabel': '系統提示',
  'pages.template.typeProse': '文章',
  'pages.template.typeTable': '表格',
  'pages.template.tableTypeLabel': '表格類型',
  'pages.template.tableTypeTooltip': '「逐條款」與「逐文件」表格不支援使用者自訂欄位。',
  'pages.template.tableTypeStandard': '標準',
  'pages.template.tableTypeDocument': '逐文件',
  'pages.template.tableTypeClause': '逐條款',
  'pages.template.columnsLabel': '欄位',
  'pages.template.newColumnButton': '新增欄位',
  'pages.template.exampleLabel': '範例',
  'pages.template.userDefinedLabel': '使用者自訂',
  'pages.template.userDefinedColumnTooltip': '使用者自訂欄位',
  'pages.template.columnTypeString': '字串',
  'pages.template.columnTypeNumber': '數字',
  'pages.template.columnTypeDatetime': '日期時間',
  'pages.template.sectionsLabel': '章節',
  'pages.template.newSectionButton': '新增章節',
  'pages.template.headingColumnHeader': '標題',
  'pages.template.promptColumnHeader': '提示',
  'pages.template.modifyButton': '修改',
  'pages.template.publishToLabel': '發佈至：',
  'pages.template.publishFirmWide': '全所適用',
  'pages.template.publicAccessLabel': '公開',
  'pages.template.firmAccessLabel': '事務所',
  'pages.template.publishButton': '發佈',
  'pages.template.publishSentForApproval': '範本預設集已送交審核',
  'pages.template.publishTemplateFailed': '發佈範本失敗',
  'pages.template.deleteConfirmQuestion': '確定要刪除此範本嗎？',
  'pages.template.templateDeletedSuccess': '範本刪除成功',
  'pages.template.deleteTemplateFailed': '刪除範本失敗',
  'pages.template.customTemplateCreatedForSession': '已成功為此工作階段建立自訂範本',
  'pages.template.publishStatusLabel': '發佈狀態',
  'pages.template.pendingApprovalStatus': '審核中',
  'pages.template.rejectedStatus': '已駁回',
  'pages.template.publishedToStatus': '已發佈至 {target}',
  'pages.template.authorLabel': '作者',
  'pages.template.emailButton': '電子郵件',
  'pages.template.noPurposeAvailable': '尚無用途說明。',
  'pages.template.noNotesAvailable': '尚無備註。',
  'pages.template.startHereTab': '從這裡開始',
  'pages.template.whoIsItForQuestion': '1. 適用對象？',
  'pages.template.clientAudiencePlaceholder': '客戶或目標受眾名稱',
  'pages.template.selectDocumentsQuestion': '2. 選取您要審閱的文件',
  'pages.template.customInstructionTab': '自訂指示（選填）',
  'pages.template.modifyPromptLabel': '修改提示',
  'pages.template.typeHerePlaceholder': '請在此輸入...',
  'pages.template.noSystemPromptConfigured': '尚未設定系統提示。',
  'pages.template.exampleValuePrefix': '例如 {example}',
  'pages.template.customOutputTitle': '自訂輸出',
  'pages.template.whatsNewButton': '最新功能',
  'pages.template.tourButton': '導覽',
  'pages.template.addNewCustomTemplateButton': '新增自訂範本',
  'pages.template.whatsNewModal.intro': '我們新增了多項功能，提升您的文件審閱流程：',
  'pages.template.whatsNewModal.improvedFilteringTitle': '篩選功能優化：',
  'pages.template.whatsNewModal.adhocQuestionsTitle': '即興問題：',
  'pages.template.whatsNewModal.adhocQuestionsBody': '以更靈活的方式即時新增問題。',
  'pages.template.whatsNewModal.uiEnhancementsTitle': '介面優化：',
  'pages.template.whatsNewModal.uiEnhancementsBody': '更簡潔直覺的介面，方便管理您的範本。',
  'pages.template.upcomingFeaturesTitle': '即將推出的功能',
  'pages.template.upcomingFeaturesBody': '敬請期待更多更新，包括協作審閱與進階 AI 分析功能。',
  'pages.template.tourIndicator': '{current} / {total}',
  'pages.translation.addToMattersButton': '加入至項目',
  'pages.translation.batchFileCountLabel': '{count} 個檔案',
  'pages.translation.batchTranslationStarted': '批次翻譯已開始',
  'pages.translation.copiedSuccess': '已複製！',
  'pages.translation.couldNotResolveFile': '無法解析所選檔案，請重新上傳或選取檔案。',
  'pages.translation.customInstructionTab': '自訂指示（選填）',
  'pages.translation.docxOrPdfOnly': '請僅選取 DOCX 或 PDF 檔案。',
  'pages.translation.downloadFailed': '下載失敗（{status}）',
  'pages.translation.dragHereToUpload': '拖曳至此以上傳',
  'pages.translation.enterLanguageRequired': '請輸入語言',
  'pages.translation.failedRenderOriginalPreview': '原始文件預覽產生失敗',
  'pages.translation.failedRenderTranslatedPreview': '翻譯文件預覽產生失敗',
  'pages.translation.failedToFetchDocx': '擷取 DOCX 失敗（{status}）',
  'pages.translation.failedToStartTranslation': '翻譯啟動失敗',
  'pages.translation.failedToStartTranslationMissingId': '翻譯啟動失敗（缺少 ID）',
  'pages.translation.fileCountLabel': '{count} 個檔案',
  'pages.translation.filterFilesPlaceholder': '篩選檔案',
  'pages.translation.liveTranslationHint': '在左側輸入文字，即可在右側即時看到翻譯結果。',
  'pages.translation.liveTranslationTitle': '即時翻譯',
  'pages.translation.modifyPromptLabel': '修改提示',
  'pages.translation.failed': '翻譯失敗',
  'pages.translation.noPreviewAvailable': '無可用預覽',
  'pages.translation.noFilesMatch': '找不到符合「{query}」的檔案',
  'pages.translation.noTranslatedDocumentYet': '尚無翻譯文件可供使用。',
  'pages.translation.originalLabel': '原文',
  'pages.translation.originalPdfTitle': '原始 PDF',
  'pages.translation.otherLanguagePlaceholder': '例如：坦米爾文',
  'pages.translation.outputLanguageStep': '2. 輸出語言',
  'pages.translation.previewNotSupported': '目前僅支援 DOCX 與 PDF 檔案的預覽功能。',
  'pages.translation.processingTitle': '處理中…',
  'pages.translation.processingTranslation': '翻譯處理中…',
  'pages.translation.promptOptionalLabel': '提示（選填）',
  'pages.translation.recentlyTranslatedLabel': '最近翻譯',
  'pages.translation.renderingOriginal': '正在載入原文…',
  'pages.translation.renderingTranslation': '正在載入譯文…',
  'pages.translation.reuseButton': '重複使用',
  'pages.translation.searchTranslationsPlaceholder': '搜尋翻譯',
  'pages.translation.selectAtLeastOneDocument': '請上傳或選擇至少 1 份文件進行翻譯。',
  'pages.translation.selectAtMostDocuments': '請最多選擇 {max} 份文件進行翻譯。',
  'pages.translation.selectDocumentStep': '1. 選擇您要翻譯的文件',
  'pages.translation.selectLanguagePlaceholder': '選擇語言',
  'pages.translation.selectLanguageRequired': '請選擇語言',
  'pages.translation.selectOutputLanguagePlaceholder': '選擇一種輸出語言',
  'pages.translation.selectOutputLanguageRequired': '請選擇輸出語言。',
  'pages.translation.startHereTab': '從這裡開始',
  'pages.translation.startLiveTranslationButton': '開始即時翻譯',
  'pages.translation.startNewTranslationButton': '開始新的翻譯',
  'pages.translation.startTranslationButton': '開始翻譯',
  'pages.translation.stopTranslationFailed': '停止翻譯失敗',
  'pages.translation.swapLanguagesTooltip': '交換語言',
  'pages.translation.title': '翻譯',
  'pages.translation.translateButton': '翻譯',
  'pages.translation.translatedLabel': '已翻譯',
  'pages.translation.translatedPdfTitle': '已翻譯的 PDF',
  'pages.translation.translationFailedError': '翻譯失敗',
  'pages.translation.translationStoppedSuccess': '翻譯已停止',
  'pages.translation.translationTaskStarted': '翻譯工作已開始',
  'pages.translation.typeTextToTranslatePlaceholder': '輸入要翻譯的文字',
  'pages.translation.unknownLanguage': '未知',
  'pages.translation.untitledFallback': '(未命名)',
  'pages.translation.untitledTranslationFallback': '未命名的翻譯',
  'pages.user.passwordConfirmationPlaceholder': '確認密碼',
  'pages.user.logoAlt': '標誌',
  'pages.user.emailPlaceholder': '電子郵件',
  'pages.user.passwordPlaceholder': '密碼',
  'pages.user.newPasswordPlaceholder': '新密碼',
  'pages.user.forgotPassword.emailSentMessage': '如果此電子郵件已註冊,系統將立即寄送郵件',
  'pages.user.forgotPassword.submitButton': '傳送重設連結',
  'pages.user.resetPassword.successMessage': '您的密碼已更新',
  'pages.user.resetPassword.submitButton': '重設密碼',
  'pages.user.resetPassword.passwordRequired': '密碼為必填項目',
  'pages.user.resetPassword.passwordMinLength': '長度至少須為 8 個字元',
  'pages.user.resetPassword.passwordNeedsAlpha': '須至少包含 1 個英文字母',
  'pages.user.resetPassword.passwordNeedsNumber': '須至少包含 1 個數字',
  'pages.user.resetPassword.passwordNeedsSpecial': '須至少包含 1 個特殊字元',
  'pages.user.resetPassword.confirmPasswordRequired': '請確認您的新密碼!',
  'pages.user.resetPassword.passwordMismatch': '您輸入的兩次密碼不一致!',
  'pages.user.login.ssoNotConfigured': 'Microsoft SSO 尚未正確設定',
  'pages.user.login.ssoAccountNotFound': '找不到 Microsoft SSO 帳戶',
  'pages.user.login.emailPasswordWrong': '電子郵件或密碼錯誤',
  'pages.user.login.contactAdminContent': '請聯絡您的管理員以重設密碼。',
  'pages.user.management.pageTitle': '管理',
  'pages.user.rolesLoadingPlaceholder': '正在載入角色...',
  'pages.user.selectRolePlaceholder': '選擇角色',
  'pages.user.billing.seatsMinimumError': '席次數必須為至少 1 的整數。',
  'pages.user.billing.contactRequiredError': '帳單聯絡人姓名與電子郵件為必填項目。',
  'pages.user.billing.renewOrChoosePlan': '續訂 / 選擇方案',
  'pages.user.billing.switchPlanAction': '變更方案',
  'pages.user.billing.subscribeAction': '訂閱',
  'pages.user.billing.renewPlanAction': '續訂方案',
  'pages.user.billing.switchPlanModalTitle': '變更方案',
  'pages.user.billing.renewThisPlanButton': '續訂此方案',
  'pages.user.billing.currentPlanButton': '目前方案',
  'pages.user.billing.switchToThisPlanButton': '切換至此方案',
  'pages.user.billing.subscribeToThisPlanButton': '訂閱此方案',
  'pages.user.billing.planText': '方案',
  'pages.user.billing.selectedTag': '已選取',
  'pages.user.billing.totalLabel': '總計:',
  'pages.user.billing.billingContactTitle': '帳單聯絡人',
  'pages.user.billing.billingContactHint': '付款結帳與發票所需。',
  'pages.user.billing.fullNameLabel': '全名',
  'pages.user.billing.billingEmailLabel': '帳單電子郵件',
  'pages.user.billing.seatsLabel': '席次',
  'pages.user.billing.registeringTenantTitle': '正在註冊 Microsoft 租用戶',
  'pages.user.billing.tenantStep1': '步驟 1/4:正在載入 Microsoft SSO 設定...',
  'pages.user.billing.ssoNotEnabledError': 'Microsoft SSO 尚未啟用。請聯絡您的管理員。',
  'pages.user.billing.tenantStep3': '步驟 3/4:正在向伺服器驗證租用戶權杖...',
  'pages.user.billing.tenantStep4': '步驟 4/4:正在將租用戶註冊儲存至您目前的組織...',
  'pages.user.billing.tenantRegistrationCompleteTitle': 'Microsoft 租用戶註冊完成',
  'pages.user.billing.tenantAddedMessage': '成功。租用戶 ID {tenantId} 已新增至您的組織。',
  'pages.user.billing.tenantRegisterGenericError': '無法註冊 Microsoft 租用戶,請再試一次。',
  'pages.user.billing.tenantRegistrationFailedTitle': 'Microsoft 租用戶註冊失敗',
  'pages.user.billing.tenantRegistrationIncompleteMessage': '註冊未完成。{detail}',
  'pages.user.billing.loadInvoicesError': '無法載入發票。',
  'pages.user.billing.loadBillingDetailsError': '無法載入帳單詳細資料。',
  'pages.user.billing.openCheckoutError': '無法開啟帳單結帳頁面。',
  'pages.user.billing.seatChangeScheduledMessage': '席次變更已排定,將於下次續訂時生效。',
  'pages.user.billing.seatsUpdatedMessage': '席次已更新。',
  'pages.user.billing.editSeatsModalTitle': '編輯席次',
  'pages.user.billing.saveSeatsButton': '儲存席次',
  'pages.user.billing.currentTotalLabel': '目前總計',
  'pages.user.billing.previewTotalLabel': '預覽總計',
  'pages.user.billing.differenceLabel': '與下次續訂的差額',
  'pages.user.billing.invoices': '發票',
  'pages.user.billing.nextInvoiceDateLabel': '下次發票日期:',
  'pages.user.billing.invoiceColumn': '發票',
  'pages.user.billing.dueColumn': '到期日',
  'pages.user.billing.amountColumn': '金額',
  'pages.user.billing.downloadInvoiceError': '無法下載發票 PDF。',
  'pages.user.billing.membersSeatsLabel': '成員 / 席次',
  'pages.user.billing.scheduledTag': '已排定',
  'pages.user.billing.pendingSeatsNotice': '→ 下次續訂起為 {seats} 個席次',
  'pages.user.billing.editSeatsButton': '編輯席次',
  'pages.user.billing.currentPlanCardLabel': '目前方案',
  'pages.user.billing.priceLabel': '價格:',
  'pages.user.billing.billingCardTitle': '帳單',
  'pages.user.billing.nextInvoiceLabel': '下次發票',
  'pages.user.billing.registerMicrosoftTenantButton': '註冊 Microsoft 租用戶',
  'pages.user.billing.contactOrgAdmin': '請聯絡您的組織管理員。',
  'pages.user.billing.graceDeadlineFallback': '寬限期限',
  'pages.user.billing.paymentIssueTitle': '付款問題',
  'pages.user.billing.subscriptionCancelledTitle': '訂閱已取消。',
  'pages.user.billing.subscriptionInactiveTitle': '訂閱未啟用',
  'pages.user.billing.orgAccessRestrictedDescription': '在帳單問題解決前,組織存取權限將受到限制。',
  'pages.angelInsider.basics.habits.habit1.intro':
    '新使用者最常犯的錯誤，就是低估了為 AI 工具提供足夠起始資訊的重要性。',
  'pages.angelInsider.basics.habits.habit2.intro':
    '了解大型語言模型（LLM）究竟是什麼至關重要。它們並非真理資料庫，也無法取代人類的判斷。相反地，可以將 LLM 視為處理語言與基本認知任務的高速 CPU 或處理器。',
  'pages.angelInsider.basics.welcome.intro':
    '很高興您的加入。在您開始探索 A&GEL 之際，我們想分享一些想法，助您順利踏出第一步。',
  'pages.angelInsider.basics.welcome.supportParagraph':
    '我們了解，一開始要熟悉新技術可能會感到有些挑戰。請記得：我們會在每一步支持您。如果您有任何問題、遇到困難，或只是希望我們協助您了解某項功能，請不吝與我們聯繫。',
  'pages.angelInsider.basics.welcome.differentParagraph':
    '像 A&GEL 這樣的 AI 工具與過往的工具<strong>截然不同</strong>—它們能直接<strong>賦能於您</strong>。可以將其想像成隨時待命的一整支助理團隊：它們或許無法取代人類的判斷，但在許多方面，能將您的能力大幅提升，遠超過單打獨鬥所能達到的程度。',
  'pages.angelInsider.basics.welcome.bestWayParagraph':
    '<strong>開始學習的最佳方式，就是開始使用 A&GEL —</strong>我們鼓勵您自由探索。多方嘗試、犯點（安全的）錯誤，找出最適合自己的使用方式。',
  'pages.angelInsider.basics.welcome.staircaseParagraph':
    '可以將技能養成想像成爬樓梯。從基礎開始，隨著信心逐漸累積，邁向下一個層級也會變得更加自然。不需要著急—這不是一場競賽。請花時間打好穩固的基礎。',
  'pages.angelInsider.basics.welcome.togetherParagraph':
    '當團隊與事務所共同擁抱 A&GEL 時，所帶來的效益會為每個人加倍累積。在使用者社群中分享知識、彼此協作，將產生連鎖效應，讓所有人共同受益。',
  'pages.angelInsider.basics.welcome.welcomeAboardParagraph':
    '歡迎加入—我們很期待看到大家透過 A&GEL 能共同成就些什麼。',
  'pages.angelInsider.basics.habitsSection.intro':
    '開始使用 A&GEL，不只是在聊天視窗輸入問題並按下 Enter 而已。要真正發揮像 A&GEL 這類 AI 工具的威力，您需要轉變與 AI 互動的思維方式。',
  'pages.angelInsider.basics.habitsSection.lockHint':
    '點擊面板可鎖定較大的檢視範圍，再次點擊即可解鎖。',
  'pages.app.analysisType.agenticResearch.description':
    '探索所選文件與上傳的檔案，並整合出附有引註的完整答案。',
  'pages.app.analysisType.comparison.description':
    '比較兩份文件並產生說明差異的報告，您可提供提示詞以聚焦比較重點。',
  'pages.app.analysisType.contractDeadlines.description':
    '列出合約／文件中所有的截止日期、重要日期與期限。提供客戶詳細資訊會有所幫助（例如「客戶為專營電子銀行服務的新加坡銀行」）',
  'pages.app.analysisType.executiveSummary.description':
    '提供關鍵建議、議題、風險與行動的精簡摘要報告。',
  'pages.app.analysisType.multiStepPrompt.description':
    '依序執行多個提示詞，並以每個步驟的輸出為基礎持續推進。',
  'pages.app.analysisType.scopeOfWork.description':
    '上傳或選擇客戶提出協助或服務需求的電子郵件、信函或 RFP。在「提示詞」中提供客戶詳細資訊會有所幫助（例如「客戶為專營電子銀行服務的新加坡銀行」）',
  'pages.app.analysisType.standardInfo.description':
    '提供精簡摘要、相關人員與實體清單，以及簡短的事件時間軸，最多可提供 100 份文件。',
  'pages.app.appsInstructions':
    '選取多個要處理的檔案，然後從下方清單中選擇分析類型。請求約需 1 至 5 分鐘處理完成。',
  'pages.app.appsList.agenticResearch.description':
    '探索所選文件與上傳的檔案，並整合出附有引註的完整答案。',
  'pages.app.appsList.contractDeadlines.description':
    '列出合約／文件中所有的截止日期、重要日期與期限。',
  'pages.app.appsList.multiStepPrompt.description':
    '依序執行多個提示詞，並以每個步驟的輸出為基礎持續推進',
  'pages.app.appsList.scopeOfWork.description':
    '上傳或選擇客戶提出協助或服務需求的電子郵件、信函或 RFP。',
  'pages.app.extractDeadlinesModalDescription':
    '列出合約/文件中所有截止日期、重要日期及期間。提供客戶詳細資訊會有所幫助(例如「客戶為一家專營電子銀行服務的新加坡銀行」)',
  'pages.app.newAnalysisModesDescription':
    '我們推出了兩種強大的全新分析模式,協助您從合約中獲得更多價值。',
  'pages.app.publishFirmWideNotice':
    '此設定將與貴機構內所有成員共用。系統將傳送請求至機構管理員以待核准。',
  'pages.app.scopeOfWorkModalDescription':
    '上傳或選擇客戶的電子郵件、信函或包含服務/協助請求的 RFP。在「提示」中提供客戶詳細資訊會有所幫助(例如「客戶為一家專營電子銀行服務的新加坡銀行」)',
  'pages.app.timelineFieldsDescription':
    '定義您希望在時間軸中顯示的其他欄位。針對每個欄位,請提供欄位名稱(欄標題)及欲擷取資訊的描述。',
  'pages.chat.starterPrompt.caseSummariser.description':
    '包含法律背景的詳細提示，用於摘要新加坡案例。',
  'pages.chat.starterPrompt.draftChecklist.description':
    '讓 Angel 根據任何文件建立檢查清單的提示。',
  'pages.chat.upload.fileTypeNotAllowed':
    '不允許的檔案類型。僅允許 PDF、DOC、DOCX、MSG、EML、TXT、MD、XLS、XLSX、PPT、PPTX 檔案。',
  'pages.chat.upload.someFilesSkipped':
    '部分檔案已略過。僅允許 PDF、DOC、DOCX、MSG、EML、TXT、MD、XLS、XLSX、PPT 或 PPTX 檔案',
  'pages.comparison.taskType.strikethroughUnderline.description':
    '分析以標準刪除線與底線格式標記的變更。',
  'pages.comparison.taskType.referenceDocument.description':
    '將目標文件與參考文件（例如條款清單）進行比對。',
  'pages.comparison.customInstructionPlaceholder':
    '請輸入您給 A&GEL 的具體指示（例如「我的客戶是 XYZ，請著重於影響我客戶的修訂」或「請以馬來語註解」）',
  'pages.comparison.legalReviewDescription':
    '比對功能經過最佳化，可對修訂進行「法律審閱」（即預設會針對修訂所產生的法律後果提供意見）。',
  'pages.composer.playbook.chooseDocumentDescription':
    '選擇一個 .docx 檔案以開啟其畫布並開始對話。',
  'pages.composer.playbookReview.downloadInfoTooltip':
    '每一輪對話皆可供審閱。下載會套用已接受及待處理的變更圖層,產生目前的整合文件。',
  'pages.composer.playbookReview.layerChangeCount':
    '{count, plural, one {# 項變更} other {# 項變更}}',
  'pages.composer.playbookReview.showMoreIdentical':
    '{action, select, hide {隱藏} other {顯示}}另外 {count} 項相同{count, plural, one {變更} other {變更}}',
  'pages.composer.playbookReview.stepChangeCount':
    '{count, plural, one {# 項變更} other {# 項變更}}',
  'pages.composer.playbookReview.turnRegenerationReason':
    '先前某一輪對話的決定變更了其所依據的文件。',
  'pages.files.deleteAllFailedFilesConfirm':
    '{count, plural, other {刪除所有 {count} 個上傳失敗的檔案？}}',
  'pages.files.allowedFileTypesMessage':
    '僅支援 PDF、DOC、DOCX、MSG、EML、TXT、MD、PPT、PPTX、XLS、XLSX 檔案格式',
  'pages.library.firmWideVisibilityNote':
    '此提示詞將對貴機構內所有人可見。系統將傳送請求給機構管理員審核。',
  'pages.library.publicVisibilityNote':
    '此提示詞將對所有使用者可見。系統將傳送請求給超級管理員審核。',
  'pages.library.pendingApprovalNote':
    '目前有發布請求待審核。在該請求核准或拒絕前，無法選擇「全所」與「公開」。',
  'pages.library.description':
    '一套經過結構化整理的預設提示詞集合，用於引導或最佳化與 AI 語言模型的互動。它作為一個集中式的資料庫，依用途、任務或領域（例如寫作、程式設計、資料分析或創意生成）組織各項提示詞。',
  'pages.projectsHub.deleteSessionsConfirm.description':
    '確定要從此collection中移除 {count} 個工作階段嗎？',
  'pages.projectsHub.mattersSubtitle':
    '在同一個工作區中建立collection，並整理來自不同功能的工作階段。',
  'pages.projectsHub.addSelectedSessionsButton':
    '新增{count, plural, =0 {已選取}other {# 個工作階段}}',
  'pages.review.questionListImporter.checklistTextPlaceholder':
    '請在此貼上檢查清單，每行一項要求。',
  'pages.review.questionListImporter.dropZoneHint':
    'DOCX、PDF、EML、MSG、TXT 或 MD。檔案僅保留在本機。',
  'pages.review.questionListImporter.questionsReadyCount':
    '{count, plural, one {# 個問題} other {# 個問題}} 已就緒',
  'pages.scribe.interruptedModal.content':
    '您的錄音因連線中斷而中止（例如裝置進入休眠）。請點選「檢視逐字稿」以儲存已擷取的內容。',
  'pages.scribe.recordingMicOnlyNote':
    '錄音僅擷取麥克風的聲音，不含喇叭播放的聲音。若要轉錄電腦播放的音訊，請使用其他裝置錄製，或上傳錄音檔。',
  'pages.scribe.stopRecordingConfirm.content':
    '您目前有進行中的錄音，離開此頁面將停止錄音。是否要繼續？',
  'pages.scribe.whatsNew.upcomingFeaturesDesc':
    '敬請期待更深入的多語言控制功能及進階結構化輸出格式。',
  'pages.sideBySide.columnEditModal.columnUpdateStartedSuccess':
    '欄位更新已開始，該欄位將稍後重新整理。',
  'pages.sideBySide.quickQuestionsDescription':
    '根據一組臨時問題，為一份或多份文件產生結構化並排比較',
  'pages.sideBySide.tour.noHistorySessions':
    '歷史記錄中沒有可用的並排比較工作階段。請先建立一個，才能檢視此步驟。',
  'pages.sideBySide.tour.step1.description':
    '首先從可用類別中選擇一個問題清單，點擊任一問題清單卡片即可繼續。',
  'pages.sideBySide.tour.step3.description':
    '在此檢視系統提示與問題清單，切換至歷史記錄面板即可查看先前的工作階段。',
  'pages.sideBySide.tour.step4.description':
    '提交後，並排比較結果將顯示於表格中，點擊儲存格即可檢視詳細內容。',
  'pages.template.someFilesSkipped':
    '部分檔案已略過。僅允許 PDF、DOC、DOCX、MSG、EML、TXT 或 MD 檔案',
  'pages.template.customOutputDescription':
    '建立並使用自訂提示（在 A&GEL 上稱為「自訂輸出」），針對需要擷取特定資訊或需要更深入分析的文件，進行更精準的客製化分析',
  'pages.template.whatsNewModal.improvedFilteringBody':
    '新增受眾與作者篩選條件，協助您更快找到問題清單。',
  'pages.translation.translationHint':
    '將您的文件翻譯成一種或多種輸出語言。翻譯結果會與原文段落並列顯示。',
  'pages.user.login.tenantNotRegistered':
    '您的 Microsoft 租用戶尚未註冊此應用程式。請聯絡您的 IT 管理員。',
  'pages.user.billing.contactNameInvalidError':
    "帳單聯絡人姓名僅能包含英文字母、空格、連字號 (-) 及撇號 (')。",
  'pages.user.billing.switchPlanConfirmContent':
    '您將被導向結帳頁面,並為 {planName}({interval}繳)方案的 {seats} 個席次支付 {total}。',
  'pages.user.billing.switchPlanConfirmContentRenewal':
    '您將被導向結帳頁面,並為 {planName}({interval}繳)方案的 {seats} 個席次支付 {total},以續訂您已取消的訂閱。',
  'pages.user.billing.switchPlanConfirmContentReplace':
    '您將被導向結帳頁面,並為 {planName}({interval}繳)方案的 {seats} 個席次支付 {total}。您目前的方案將被取代。',
  'pages.user.billing.tenantStep2':
    '步驟 2/4:正在開啟 Microsoft 登入彈出視窗。請登入並授權您的租用戶。',
  'pages.user.billing.tenantAlreadyRegisteredMessage':
    '租用戶 ID {tenantId} 已為您的組織註冊,無需進一步操作。',
  'pages.user.billing.tenantPopupNotice':
    '請保持此視窗開啟。系統需要開啟 Microsoft 彈出視窗,請完成登入與授權以繼續。',
  'pages.user.billing.seatChangeRenewalNotice':
    '席次變更將於下次續訂日 {nextInvoiceDisplay} 生效。',
  'pages.user.billing.pastDueDescription':
    '您的訂閱已逾期。存取權限將持續至 {graceDate}。請立即續訂以避免服務中斷。',
  'pages.welcomeDashboard.jsonResponseTitle': 'JSON 回應',
  'pages.welcomeDashboard.textResponseTitle': '文字回應',
  'pages.welcomeDashboard.visibility.public': '公開',
  'pages.welcomeDashboard.visibility.firm': '所屬機構',
  'pages.welcomeDashboard.visibility.unknown': '未知',
  'pages.welcomeDashboard.rejectButton': '拒絕',
  'pages.welcomeDashboard.approveButton': '核准',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.title': '今日生成字數',
  'pages.welcomeDashboard.metrics.wordsGenerated.chartLabel': '生成字數',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.description': 'AI 輔助起草',
  'pages.welcomeDashboard.metrics.pagesProcessed.title': '已處理 A4 頁數',
  'pages.welcomeDashboard.metrics.pagesProcessed.chartLabel': '已處理頁數',
  'pages.welcomeDashboard.metrics.pagesProcessed.description': '今日活躍項目中',
  'pages.welcomeDashboard.metrics.documentsDownloaded.title': '已下載文件',
  'pages.welcomeDashboard.metrics.documentsDownloaded.chartLabel': '已下載文件',
  'pages.welcomeDashboard.metrics.documentsDownloaded.description': '今日匯出檔案',
  'pages.welcomeDashboard.metrics.questionsAnswered.title': '已回答問題',
  'pages.welcomeDashboard.metrics.questionsAnswered.chartLabel': '已回答問題',
  'pages.welcomeDashboard.metrics.questionsAnswered.description': '今日處理的 AI 提示',
  'pages.welcomeDashboard.features.apps.name': '應用',
  'pages.welcomeDashboard.features.apps.description': '分析並彙整內容',
  'pages.welcomeDashboard.features.scribe.name': '錄音',
  'pages.welcomeDashboard.features.scribe.description': '文件轉錄',
  'pages.welcomeDashboard.features.comparison.name': '對比',
  'pages.welcomeDashboard.features.comparison.description': '並排比較文件',
  'pages.welcomeDashboard.features.review.name': '審閱',
  'pages.welcomeDashboard.features.review.description': '使用問題清單審閱文件',
  'pages.welcomeDashboard.features.translation.name': '翻譯',
  'pages.welcomeDashboard.features.translation.description': '翻譯文件',
  'pages.welcomeDashboard.features.chat.name': '對話',
  'pages.welcomeDashboard.features.chat.description': '與 AI 助理對話',
  'pages.welcomeDashboard.features.templates.name': '範本',
  'pages.welcomeDashboard.features.templates.description': '管理範本',
  'pages.welcomeDashboard.features.quote.name': '報價',
  'pages.welcomeDashboard.features.quote.description': '產生報價',
  'pages.welcomeDashboard.features.files.name': '檔案',
  'pages.welcomeDashboard.features.files.description': '管理您的檔案',
  'pages.welcomeDashboard.features.library.name': '提示庫',
  'pages.welcomeDashboard.features.library.description': '存取您的提示庫',
  'pages.welcomeDashboard.features.sideBySide.name': '並排',
  'pages.welcomeDashboard.features.sideBySide.description': '並排比較',
  'pages.welcomeDashboard.features.playbook.name': 'Workstudio',
  'pages.welcomeDashboard.features.playbook.description': '建立並管理 Workstudio 工作階段',
  'pages.welcomeDashboard.features.fallback.description': '功能',
  'pages.welcomeDashboard.features.search.name': '搜尋',
  'pages.welcomeDashboard.greeting': '您好，{username}',
  'pages.welcomeDashboard.useCasesButton': '使用案例',
  'pages.welcomeDashboard.faqsButton': '常見問題',
  'pages.welcomeDashboard.publishingApprovalsButton': '發布審核（{count}）',
  'pages.welcomeDashboard.jumpBackInTitle': '繼續先前的操作',
  'pages.welcomeDashboard.untitledSession': '未命名工作階段',
  'pages.welcomeDashboard.viewAllButton': '查看全部',
  'pages.welcomeDashboard.noRecentSessions': '暫無最近的工作階段',
  'pages.welcomeDashboard.statsTitle': '統計',
  'pages.welcomeDashboard.usefulFeaturesTitle': '實用功能',
  'pages.welcomeDashboard.sessionsCount': '{count, plural, other {# 個工作階段}}',
  'pages.welcomeDashboard.foundUsefulThisWeek': '本週有 {count} 位使用者認為實用',
  'pages.welcomeDashboard.noRecentActivity': '暫無最近活動',
  'pages.welcomeDashboard.publishingApprovalsModalTitle': '發布審核',
  'pages.welcomeDashboard.approvalTag.template': '範本',
  'pages.welcomeDashboard.approvalTag.review': '審閱',
  'pages.welcomeDashboard.approvalTag.sideBySide': '並排對比',
  'pages.welcomeDashboard.approvalTag.prompt': '提示詞',
  'pages.welcomeDashboard.approvalTag.multiStep': '多步驟',
  'pages.welcomeDashboard.recentSessionsModalTitle': '{pageName} — 最近工作階段',
  'pages.welcomeDashboard.detail.publishTarget': '發布目標',
  'pages.welcomeDashboard.detail.author': '作者',
  'pages.welcomeDashboard.detail.unknown': '未知',
  'pages.welcomeDashboard.detail.category': '類別',
  'pages.welcomeDashboard.detail.purpose': '用途',
  'pages.welcomeDashboard.detail.notes': '備註',
  'pages.welcomeDashboard.systemPromptLabel': '系統提示詞',
  'pages.welcomeDashboard.noSystemPromptProvided': '未提供系統提示詞',
  'pages.welcomeDashboard.promptContentLabel': '提示詞內容',
  'pages.welcomeDashboard.noPromptContentAvailable': '暫無提示詞內容',
  'pages.welcomeDashboard.multiStepConfigFallback': '多步驟設定',
  'pages.welcomeDashboard.detail.description': '描述',
  'pages.welcomeDashboard.stepsLabel': '步驟',
  'pages.welcomeDashboard.stepFallback': '步驟 {number}',
  'pages.welcomeDashboard.templateFallback': '範本',
  'pages.welcomeDashboard.detail.target': '目標',
  'pages.welcomeDashboard.miscFallback': '其他',
  'pages.welcomeDashboard.detail.type': '類型',
  'pages.welcomeDashboard.templateType.prose': '文字式',
  'pages.welcomeDashboard.templateType.table': '表格式',
  'pages.welcomeDashboard.tableTypeLabel': '表格類型',
  'pages.welcomeDashboard.tableType.standard': '標準',
  'pages.welcomeDashboard.tableType.documentByDocument': '逐文件',
  'pages.welcomeDashboard.tableType.clauseByClause': '逐條款',
  'pages.welcomeDashboard.columnsLabel': '欄',
  'pages.welcomeDashboard.sectionsLabel': '章節',
  'pages.welcomeDashboard.userDefinedTag': '使用者自訂',
  'pages.welcomeDashboard.noTemplateStructureAvailable': '暫無範本結構',
  'pages.welcomeDashboard.questionListFallback': '問題清單',
  'pages.welcomeDashboard.noQuestionsAvailable': '暫無問題',
};
